import React, { useEffect, useState } from "react";
import { GoGlobe, GoSearch } from "react-icons/go";
import { Button, Placeholder, Spinner, Tab, Tabs } from 'react-bootstrap';
import { Stack, Table, Modal } from 'react-bootstrap'
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiPlusCircle, FiMinusCircle } from "react-icons/fi";
import { format, set } from 'date-fns';
import {
    GET_ALL_INVOICES_ERROR, SET_PAGINATION_COUNT_TO,
    REGENERATE_INVOICE_DATA_SUCCESS, handlePaginationLoaderTrue,
    getAllInvoices, getAllPartnerCompanies,
    putInvoiceData, PUT_INVOICE_DATA_SUCCESS,
    regenerateAnInvoice, commercialHeadGetBillingEntities,
    commercialHeadGetCompleteContractsForDropdown,
    handleDocumentLoaderTrue, commercialHeadUploadDocument,
    createNewMiscInvoice, PUT_ADD_MISC_INVOICE_SUCCESS,
    PUT_ADD_MISC_INVOICE_FAILURE, submitToGSTSubmissionPortal,
    sendToCustomerAsEmail, PUT_GST_SUBMIT_SUCCESS,
    editAMiscInvoice, PUT_EDIT_MISC_INVOICE_SUCCESS,
    CONTRACT_API_LOADER_TRIGGER_TRUE, commercialHeadGetAllFacilitiesForNav,
    getAllServices,
    createNewCreditNote,
    updateCreditNoteApi,
    putNoteData,
    PUT_ADD_NOTE_DATA_SUCCESS,
    PUT_ADD_NOTE_DATA_FAILURE,
    createNewDebitNote,
    updateDebitNoteApi,
    PUT_UPDATE_CREDIT_SUCCESS,
    PUT_UPDATE_CREDIT_FAILURE,
    submitNoteToGSTSubmissionPortal,
    handleDocumentLoaderFalse
} from "../../Redux/Actions/Actions";
import { useDispatch, useSelector } from "react-redux";
import FormLoader from "../Reusable_Components/FromLoader";
import { MdErrorOutline } from "react-icons/md";
import Pagination from "../Reusable_Components/Pagination";
import NavBarTop from '../Reusable_Components/NavBarTop'
import LeftNavBar from '../Reusable_Components/LeftNavBar'
import axios from "../../axios-interceptor"
import AlertPopUp from "../Reusable_Components/Alert";
import { base_url } from "../../utilities";
import { RECORDS_PER_PAGE } from "../../Config";
import PdfViewer from "../Reusable_Components/pdfviewer";
import {
    formatCurrencyBasedOnRegion, formatToIndianRupee,
    convertCurrencyToWords, timeElapsed, validateValue,
    formatNumericInput, limitCurrencyAmount,
    formatDateBasedOnValue,
    getMonthName
} from "../Reusable_Components/ReusableFunctions";
import QRCode from "react-qr-code";
import { formatDateView } from "../Reusable_Components/ReusableFunctions";
import Footer from '../Login/Footer';
import UploadComponent from "../Reusable_Components/UploadComponent";
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useLocation } from "react-router-dom";
import { FaSort } from 'react-icons/fa';
import { BsCurrencyRupee } from "react-icons/bs";
import SearchableDropdown from '../Reusable_Components/SearchableDropdown';
import JSZip, { filter } from "jszip";
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import TableComponent from "../Reusable_Components/TableComponent";
import ReduxReducer from "../../Redux/Reducers/Reducers";
import { GrDocumentPdf } from "react-icons/gr";
import { IoImage } from "react-icons/io5";


export const SET_LOADER = "SET_LOADER"




function CreditAndDebit() {


    const navigate = useNavigate()
    const location = useLocation()
    const invoiceNumberFromState = location.state?.invoice_number;
    const facilityIdFromState = location.state?.facilityId;
    const noteTypeFromState = location.state?.noteType;
    const { props } = location.state || {};

    useEffect(() => {
        if (facilityIdFromState && invoiceNumberFromState) {
            setSelectedFacilityId(facilityIdFromState)
            setNoteType(noteTypeFromState === "Credit" ? 'Credit Note' : 'Debit Note')
            setSelectedInvoiceNo(invoiceNumberFromState)
            handleViewButton(invoiceNumberFromState)

            setCurrentPage(2)
        }

    }, [])

    const typesOfTabs = [
        { id: "all", name: "All Notes" },
        { id: "credit", name: "Credit Note" },
        { id: "debit", name: "Debit Note" }
    ];



    const taxPercentageOptions = [0, 5, 12, 18, 28]


    const servicesForDropdown = useSelector((state) => state.servicesList);
    const newNoteNumber = useSelector((state) => state.newNoteNumber);
    const noteUpdate = useSelector((state) => state.noteUpdate);

    useEffect(() => {
        if (newNoteNumber) {
            setAlertShow(true)
            setAlertType('success')
            setAlertMessage('Success')
            setAlertValue(<p className="mb-3">Note <span style={{ fontWeight: 'bold' }}>{newNoteNumber}</span> Created Successfully</p>)
            setAlertButtons([
                {
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        setCurrentPage(1);
                        backFunction();
                        backPagination()
                        dispatch({
                            type: PUT_ADD_NOTE_DATA_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_ADD_NOTE_DATA_FAILURE,
                            payload: null
                        })
                    }
                },
                {
                    name: 'View Note', variant: 'outline-secondary', action: () => {
                        setAlertShow(false)
                        viewInvoiceNoteByNumber(newNoteNumber)
                        setIsNote(true);
                        setEditInvoiceClicked(false);
                        dispatch({
                            type: PUT_ADD_NOTE_DATA_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_ADD_NOTE_DATA_FAILURE,
                            payload: null
                        })
                    }
                },
            ])
        }
    }, [newNoteNumber])

    useEffect(() => {
        if (noteUpdate?.data?.status === "success") {
            setAlertShow(true)
            setAlertType('success')
            setAlertMessage('Success')
            setAlertValue(<p className="mb-3">Note <span style={{ fontWeight: 'bold' }}>{noteNumber}</span> Updated Successfully</p>)
            setAlertButtons([
                {
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        setCurrentPage(1);
                        backFunction();
                        backPagination()
                        dispatch({
                            type: PUT_UPDATE_CREDIT_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_UPDATE_CREDIT_FAILURE,
                            payload: null
                        })
                    }
                },
                {
                    name: 'View Note', variant: 'outline-secondary', action: () => {
                        setAlertShow(false)
                        viewInvoiceNoteByNumber(noteNumber)
                        setIsNote(true);
                        setEditInvoiceClicked(false);
                        dispatch({
                            type: PUT_UPDATE_CREDIT_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_UPDATE_CREDIT_FAILURE,
                            payload: null
                        })
                    }
                },
            ])
        }
    }, [noteUpdate])

    const [sample, setSample] = useState()
    const [totalInvoices, setTotalInvoices] = useState()
    const [invoiceSelected, setinvoiceSelected] = useState('')
    const [searchText, setSearchText] = useState("")
    const [asc, setAsC] = useState(false);
    const [desc, setDesc] = useState(false);
    const [filteredData, setFilteredData] = useState("")
    const [invoiceType, setInvoiceType] = useState("draft")
    const [igstToggle, setIgstToggle] = useState(false)
    const [paymentToggle, setPaymentToggle] = useState(false)
    const [termsToggle, setTermsToggle] = useState(false)
    const [userNotesToggle, setUserNotesToggle] = useState(false)
    const [biilingPeriodFilter, setBillingPeriodFilter] = useState(new Date())

    const [currentPage, setCurrentPage] = useState(1)
    const [editInvoiceClicked, setEditInvoiceClicked] = useState(false)
    const [invoiceTableData, setInvoiceTableData] = useState([])
    const [currentTime, setCurrentTime] = useState(new Date())
    const [invoiceStatus, setInvoiceStatus] = useState([])
    const [preview, setPreview] = useState(false)
    const [miscDueDate, setMiscDueDate] = useState("")
    const [miscService, setMiscService] = useState("")
    const [miscDescription, setMiscDescription] = useState("")
    const [miscBasicAmount, setMiscBasicAmount] = useState(0)
    const [miscIgst, setMiscIgst] = useState(18);
    const [miscCsgtSgst, setMiscCgstSgst] = useState(9)
    const [slfShow, setSlfShow] = useState(false);
    const [userNotes, setUserNotes] = useState("")
    const [userNotesError, setUserNotesError] = useState("")
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(5)

    const dispatch = useDispatch()
    const invoicesList = useSelector(state => state.invoicesList?.data)
    const invoicesListError = useSelector(state => state.invoicesListError)
    const [invoiceListErrorFlag, setInvoiceListErrorFlag] = useState(false)
    const loading = useSelector(state => state.loading)
    const paginationCount = useSelector(state => state.paginationCount)
    const editInvoiceSubmisssion = useSelector(state => state.editInvoiceSubmisssion)
    const partnerCompaniesList = useSelector(state => state.partnerCompaniesList)
    const partnerCompaniesListError = useSelector(state => state.partnerCompaniesListError)
    const generateInvoiceStatus = useSelector(state => state.generateInvoiceStatus)
    const gstsubmmisiondata = useSelector(state => state.gstsubmmisiondata)
    const error = useSelector(state => state.error)
    const [isLoading, setIsLoading] = useState(false)
    const [facilityName, setFacilityName] = useState('')

    const handleClose = () => setSlfShow(false);
    const handleShow = () => setSlfShow(true);
    const [sortOrder, setSortOrder] = useState(false);

    //invoice data fields
    const [companyName, setCompanyName] = useState("")
    const [companyAddress, setCompanyAddress] = useState("")
    const [companyCIN, setCompanyCIN] = useState("")
    const [companyGST, setCompanyGST] = useState("")
    const [companyPhone, setCompanyPhone] = useState("")
    const [invoiceDetails, setInvoiceDetails] = useState([])
    const [companyLogo, setCompanyLogo] = useState("")
    const [contractNo, setContractNo] = useState("")
    const [customerName, setcustomerName] = useState("")
    const [customerAddress, setcustomerAddress] = useState("")
    const [customerStateCode, setcustomerStateCode] = useState("")
    const [customerGSTIN, setcustomerGSTIN] = useState("")
    const [customerCIN, setcustomerCIN] = useState("")
    const [customerPlaceOfSupply, setcustomerPlaceOfSupply] = useState("")
    const [customerPAN, setcustomerPAN] = useState("")
    const [IRN, setIRN] = useState("")
    const [ackNo, setAckNo] = useState("")
    const [ackDate, setAckDate] = useState("")
    const [invoiceNo, setInvoiceNo] = useState("")
    const [parnterState, setPartnerState] = useState("")
    const [partnerStateCode, setPartnerStateCode] = useState("")
    const [partnerPAN, setPartnerPAN] = useState("")
    const [partnerCIN, setPartnerCIN] = useState("")
    const [partnerBillDate, setPartnerBillDate] = useState("")
    const [shippingAddress, setShippingAddress] = useState('')
    const [partnerDueDate, setPartnerDueDate] = useState("")
    const [basicAmount, setBasicAmount] = useState(0)
    const [totalSgst, setTotalSgst] = useState(0)
    const [totalIgst, setTotalIgst] = useState(0)
    const [totalCgst, setTotalCgst] = useState(0)
    const [TotalAmount, setTotalAmount] = useState(0)
    const [totalAmountInWords, setTotalAmountInWords] = useState('');
    //for alert pop up
    const [alertShow, setAlertShow] = useState(false)
    const [alertType, setAlertType] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertValue, setAlertValue] = useState('')
    const [alertButtons, setAlertButtons] = useState([])
    const [alertAction, setAlertAction] = useState([])
    //edit invoice data
    const [streetAddress, setStreetAddress] = useState("")
    const [city, setCity] = useState("")
    const [state, setState] = useState("")
    const [pincode, setPincode] = useState("")
    const [toggleShippingAddress, setToggleShippingAddress] = useState(false)
    const [approvalType, setApprovalType] = useState("")
    const [listOfPartnerCompanies, setListOfPartnerCompanies] = useState([])
    const [pdfDataForPayments, setpdfDataForPayments] = useState(null);
    const [pdfDataForTerms, setpdfDataForTerms] = useState(null);
    const totalRecordsAc = useSelector((state) => state.invoicesList?.info?.total_no_of_records);
    const currentPaginationPageAc = useSelector((state) => state.invoicesList?.info?.page_number);
    const [shippingAddressToggle, setShippingAddressToggle] = useState(false)
    const [shippingCompanyName, setShippingCompanyName] = useState('');
    const [shippingCompanyAddress, setShippingCompanyAddress] = useState('');
    const [QrCode, setQrCode] = useState('');
    const [invoiceStatusTo, setInvoiceStatusTo] = useState('')
    const [invoiceId, setInvoiceId] = useState('')
    const [slfInvoiceName, setSlfInvoiceName] = useState('')
    const [rejectReason, setRejectReason] = useState('')
    const [rejectReasonError, setRejectReasonError] = useState('')
    const [rejectModal, setRejectModal] = useState(false)
    const [sendCustomerModal, setSendCustomerModal] = useState(false)
    const [sendCustomerSubject, setSendCustomerSubject] = useState('')
    const [sendCustomerMessage, setSendCustomerMessage] = useState('')
    const [showComputationDetails, setShowComputationDetails] = useState(true) //has to be changes to false when backend is updated
    const [showBillingPeriod, setShowBillingPeriod] = useState(false)
    const [showPaymentDetails, setShowPaymentDetails] = useState(false) //has to be changes to false when backend is updated
    const [showTermsDetails, setShowTermsDetails] = useState(false) //has to be changes to false when backend is updated
    const [downloadPath, setDownloadPath] = useState('')

    const [billingMonthFilter, setBillingMonthFilter] = useState(dayjs().month() + 1);
    const [billingYearFilter, setBillingYearFilter] = useState(dayjs().year());
    //circle progress bar for donwload zip
    const [downloadProgress, setDownloadProgress] = useState(0);
    const [showDownloadProgress, setShowDownloadProgress] = useState(false);
    const [miscListOfContacts, setMiscListOfContacts] = useState([])
    const billingEntities = useSelector((state) => state.billingEntities);
    const contractsForDropdown = useSelector((state) => state.contractsForDropdown);
    const contractApiLoader = useSelector((state) => state.contractApiLoader);
    const facilitiesListForNav = useSelector((state) => state.facilitiesListForNav);
    const newInvoiceNumber = useSelector((state) => state.newInvoiceNumber);
    const [miscIgstOptions, setMiscIgstOptions] = useState([...taxPercentageOptions])
    const [contractsDropdown, setContractsDropdown] = useState([])
    const [billingEntityDropdown, setBillingEntityDropdown] = useState(null)
    const [billingEntityOptions, setBillingEntityOptions] = useState([])
    const [miscPlaceOfSupply, setMiscPlaceOfSupply] = useState(null);
    const [miscContractName, setMiscContractName] = useState(null)
    const [editMiscInvoiceClicked, setEditMiscInvoiceClicked] = useState(false)
    const [miscInvoiceServiceIntifier, setMiscInvoiceServiceIntifier] = useState('')
    const [miscSelectedContacts, setMiscSelectedContacts] = useState(true)
    const [uploadedFiles, setUploadedFiles] = useState();
    const [miscTotalBasicAmount, setMiscTotalBasicAmount] = useState(0.0)
    const [miscTotalTaxAmount, setMiscTotalTaxAmount] = useState(0.0)
    const [miscShowBilling, setMiscShowBilling] = useState(false)
    const [miscShowComputations, setMiscShowComputations] = useState(false)
    const [selectedFacility, setSelectedFacility] = useState(`${localStorage.getItem("selected_city_name")}, ${localStorage.getItem("selected_facility_name")}`);
    const [selectedFacilityId, setSelectedFacilityId] = useState(localStorage.getItem("selected_facility_id"));
    const [selectedFacilityName, setSelectedFacilityName] = useState(localStorage.getItem("selected_facility_name"));
    const [selectedCityName, setSelectedCityName] = useState(localStorage.getItem("selected_city_name"));
    const [facilityList, setFacilityList] = useState([]);
    const [noteType, setNoteType] = useState('Credit Note');
    const [creditList, setCreditList] = useState([]);
    const [debitList, setDebitList] = useState([]);


    // for list
    const [tabType, setTabType] = useState("all");
    const [creditAndDebitList, setCreditAndDebitList] = useState([]);
    const [isNote, setIsNote] = useState(false);
    const [isEditClicked, setIsEditClicked] = useState(false);
    const [noteNumber, setNoteNumber] = useState('');
    const [noteId, setNoteId] = useState('');
    const [noteTypeStatus, setNoteTypeStatus] = useState('');
    const [currentPaginationPage, setCurrentPaginationPage] = useState(1);
    const [totalNotes, setTotalNotes] = useState(0);

    const [isRegisteredAddressEdited, setIsRegisteredAddressEdited] = useState(false);
    const [invoicePaymentDetails, setInvoicePaymentDetails] = useState(null)
    const [paymentDetailsError, setPaymentDetailsError] = useState(false)

    const [partnerName, setPartnerName] = useState('')

    const [ccEmailInput, setCCEmailInput] = useState('');
    const [isDuplicateEmail, setIsDuplicateEmail] = useState(false);
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [ccEmailsData, setCCEmailsData] = useState([])
    const [newlyAddedEmails, setNewlyAddedEmails] = useState([]);

    const [allEmails, setAllEmails] = useState([...ccEmailsData, ...newlyAddedEmails]);
    const [deleteCCEmailSelectedIndex, setDeleteCCEmailSelectedIndex] = useState();
    const [deleteCCEmailSelected, setDeleteCCEmailSelected] = useState();
    const [isCreditDebitClicked, setIsCreditDebitClicked] = useState(false);
    const [termsAndConditions, setTermsAndConditions] = useState(null);
    const [termsAndConditionsKey, setTermsAndConditionsKey] = useState(null);
    const [fileData, setFileData] = useState([]);
    const [documentLoader, setDocumentLoader] = useState(false);
    const [errorValue, setErrorValue] = useState(null);


    const processAndValidateEmail = (input, currentEmail) => {
        const processedInput = (input === " " && currentEmail.length === 0) ? currentEmail : input;
        // Improved regex: no consecutive dots, no dot at start/end, valid domain
        const emailRegex = /^(?!.*\.\.)(?!.*\.$)(?!^\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
        const isValid = emailRegex.test(processedInput) || processedInput === '';
        return { processedInput, isValid };
    };

    const handleRemoveCCEmail = (index) => {
        const updatedCCEmailsData = ccEmailsData.filter(email => email.email_cc_master_id !== index);
        setCCEmailsData(updatedCCEmailsData);
        const updatedAllEmails = allEmails.filter(email => email.email_cc_master_id !== index);
        setAllEmails(updatedAllEmails);
        setAlertShow(false);
    }

    const handleCCEmailInput = (e) => {
        const input = e.target.value;
        const { processedInput, isValid } = processAndValidateEmail(input, ccEmailsData);
        setCCEmailInput(processedInput);
        setIsValidEmail(isValid);
        const allEmailsList = [...ccEmailsData, ...newlyAddedEmails];
        const isDuplicate = allEmailsList.some(emailObj => emailObj.cc_email === processedInput);
        setIsDuplicateEmail(isDuplicate);
    }
    const handleAddCCEmail = () => {
        if (isValidEmail && !isDuplicateEmail && ccEmailInput) {
            const newEmailObj = { cc_email: ccEmailInput }; // No cc_email_id for new
            setNewlyAddedEmails([...newlyAddedEmails, newEmailObj]);
            setCCEmailInput('');
            setAllEmails([...allEmails, newEmailObj]);
        }
    }
    const handleConfirmRemoveCCEmail = (email, index) => {
        if (email?.email_cc_master_id) {
            setDeleteCCEmailSelectedIndex(email?.email_cc_master_id);
            setDeleteCCEmailSelected(email);

            setAlertShow(true);
            setAlertType('question');
            setAlertValue(`Are you sure you want to remove this ${email?.cc_email}?`);
            setAlertButtons([
                {
                    name: 'Cancel',
                    action: () => setAlertShow(false)
                },
                {
                    name: 'Proceed',
                    action: () => handleRemoveCCEmail(email?.email_cc_master_id)
                }
            ]);
        } else {
            const updatedNewlyAddedEmails = newlyAddedEmails.filter((_, i) => i !== index - ccEmailsData.length);
            setNewlyAddedEmails(updatedNewlyAddedEmails);
            const updatedAllEmails = allEmails.filter((_, i) => i !== index);
            setAllEmails(updatedAllEmails);
        }
    }

    useEffect(() => {
        const totalAmount = (parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2)
        if (parseFloat(totalAmount) > parseFloat(invoicePaymentDetails?.amount_due)) {
            setPaymentDetailsError(true)
        } else {
            setPaymentDetailsError(false)
        }
    }, [invoicePaymentDetails, miscTotalBasicAmount, miscTotalTaxAmount])



    useEffect(() => {
        // success message for gst submission
        if (gstsubmmisiondata) {
            setAlertShow(true)
            setAlertType('success')
            setAlertMessage('Success')
            setAlertValue(<>
                <p className="mb-3">Note <span style={{ fontWeight: 'bold' }}>{noteNumber}</span> Submitted to GST Portal Successfully</p>
            </>)
            setAlertButtons([
                {
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        setCurrentPage(1);
                        backFunction();
                        backPagination()
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_GST_SUBMIT_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_FAILURE,
                            payload: null
                        })

                    }
                },
                {
                    name: 'view Note', variant: 'outline-secondary', action: () => {
                        setAlertShow(false)
                        viewInvoiceNote(noteId, 'gstsubmitted', 'miscellaneous')
                        dispatch({
                            type: PUT_GST_SUBMIT_SUCCESS,
                            payload: null
                        })
                    }
                },
            ])
        }
    }, [gstsubmmisiondata])

    useEffect(() => {
        if (editInvoiceSubmisssion) {
            let approvalTypeCapital = approvalType
            approvalTypeCapital = approvalTypeCapital[0]?.toLocaleUpperCase() + approvalTypeCapital?.slice(1)
            setAlertShow(true)
            setAlertType('success')
            setAlertMessage('Success')
            setAlertValue(<>
                {invoiceStatusTo === "approved" && <>{noteType?.toLocaleUpperCase()} <b>{noteNumber}</b> has been approved</>}
                {invoiceStatusTo === "rejected" && <>{noteType?.toLocaleUpperCase()} <b>{noteNumber}</b> has been rejected</>}
                {invoiceStatusTo === "onhold" && <>{noteType?.toLocaleUpperCase()} <b>{noteNumber}</b> has been put on hold</>}
            </>)
            setAlertButtons([{
                name: 'Close', action: () => {
                    setAlertShow(false)
                    // window.location.reload() //going to current page one with same filtered data
                    backFunction()
                    applyFilter()
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_GST_SUBMIT_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_FAILURE,
                        payload: null
                    })
                    dispatch({
                        type: PUT_INVOICE_DATA_SUCCESS,
                        payload: null,
                    });

                }
            },
            {
                name: 'View Note', action: () => {
                    setAlertShow(false)
                    viewInvoiceNote(noteId, 'approved', 'miscellaneous')
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_GST_SUBMIT_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_FAILURE,
                        payload: null
                    })
                    dispatch({
                        type: PUT_INVOICE_DATA_SUCCESS,
                        payload: null,
                    });

                }
            },

            ])
        }
        setIsLoading(false)
    }, [editInvoiceSubmisssion])

    useEffect(() => {
        if (error) {
            setAlertShow(true)
            setAlertType('error')
            setAlertMessage('Error ')
            setAlertValue(error)
            setAlertButtons([{
                name: 'Close', action: () => {
                    setAlertShow(false)
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_GST_SUBMIT_SUCCESS,
                        payload: null
                    })
                    dispatch({
                        type: PUT_ADD_MISC_INVOICE_FAILURE,
                        payload: null
                    })
                }
            }])
        }
        setIsLoading(false);
    }, [error]);

    const handledPaginationNextClicked = () => {
        setInvoiceListErrorFlag(false)
        setCurrentPaginationPage(currentPaginationPage + 1)
        getCreditList(tabType === "all" ? undefined : (tabType === 'credit' ? 'credit' : 'debit'), currentPaginationPage + 1)
    }

    const handledPaginationPrevClicked = () => {
        setInvoiceListErrorFlag(false)
        setCurrentPaginationPage(currentPaginationPage - 1)
        getCreditList(tabType === "all" ? undefined : (tabType === 'credit' ? 'credit' : 'debit'), currentPaginationPage - 1)
    }

    const handleDownloadZip = async (s3keys) => {
        setIsLoading(true);
        setShowDownloadProgress(true);
        setDownloadProgress(0);

        try {
            const keys1 = Array.isArray(s3keys) ? s3keys : [];

            if (keys1.length === 0) {
                throw new Error("No files to download");
            }

            const zip = new JSZip();


            // Fetch and add files for keys1 into 'pdfgenerated'
            if (keys1.length > 0) {
                const response1 = await axios.get(`${base_url}documents/invoiceDocuments`, {
                    params: {
                        filter_condition: JSON.stringify({
                            s3_keys: keys1
                        })
                    },
                });

                const data1 = response1.data?.data;
                if (data1 && data1.length > 0) {
                    data1.forEach(file => {
                        if (file.invoice) {
                            let base64Data = file.invoice.replace(/^b'|^b"|['"]$/g, ''); // Clean base64 data
                            const fileName = file.key.split('/').pop();
                            // folderPdfGenerated.file(fileName, base64Data, { base64: true });
                            zip.file(fileName, base64Data, { base64: true });
                        }
                    });
                }
            }

            const zipBlob = await zip.generateAsync({ type: 'blob' }, metadata => {
                const percent = Math.round(metadata.percent);
                setDownloadProgress(percent);
            });

            setAlertShow(true);
            setAlertType('success');
            setAlertMessage('Success');
            setAlertValue('Download completed successfully.');
            setAlertButtons([{
                name: 'Close', action: () => {
                    setAlertShow(false);
                    setShowDownloadProgress(false);
                    setDownloadProgress(0);
                    dispatch({ type: PUT_ADD_MISC_INVOICE_SUCCESS, payload: null });
                    dispatch({ type: PUT_GST_SUBMIT_SUCCESS, payload: null });
                    dispatch({ type: PUT_ADD_MISC_INVOICE_FAILURE, payload: null });
                }
            }]);

            const url = URL.createObjectURL(zipBlob);
            const link = document.createElement('a');
            link.href = url;
            const zipFileName = `invoices-${selectedFacility}-${billingMonthFilter}-${billingYearFilter}.zip`;
            link.setAttribute('download', zipFileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);

            setDownloadProgress(100);

        } catch (error) {
            console.error(error);
            setAlertShow(true);
            setAlertType('error');
            setAlertMessage('Error');
            setAlertValue(error?.response?.data?.message || error.message || 'An error occurred');
            setAlertButtons([{
                name: 'Close',
                action: () => {
                    setAlertShow(false);
                    setDownloadProgress(0);
                    setShowDownloadProgress(false);
                    dispatch({ type: PUT_ADD_MISC_INVOICE_SUCCESS, payload: null });
                    dispatch({ type: PUT_GST_SUBMIT_SUCCESS, payload: null });
                    dispatch({ type: PUT_ADD_MISC_INVOICE_FAILURE, payload: null });
                }
            }]);
        } finally {
            setIsLoading(false);
        }
    };

    const submitToGSTPortal = (noteNumber) => {
        // endpoint - https://q73ion9zv2.execute-api.us-east-2.amazonaws.com/dev/api/invoices/submitToGSTPortal
        // body - {"invoice_number": "SRST2425-001174"}

        dispatch(submitNoteToGSTSubmissionPortal({ note_number: noteNumber }))
    }

    const generateBodyHtml = (sendCustomerMessage) => {
        // Replace newlines with <br> for HTML formatting
        const htmlMessage = sendCustomerMessage.replace(/\r?\n/g, '<br>');

        return `<!DOCTYPE html><html><head></head><body><p>${htmlMessage}</p></body></html>`;
    }


    const sendToCustomer = () => {
        setIsLoading(true)
        const body_html = generateBodyHtml(sendCustomerMessage)
        const body_text = sendCustomerMessage
        const subject = sendCustomerSubject
        axios
            .post(base_url + "invoices/dispatchNoteEmail", {
                note_number: noteNumber,
                body_html: body_html,
                body_text: body_text,
                subject: subject,
                cc_list: allEmails.map(emailObj => emailObj.cc_email)
            })
            .then((response) => {
                if (response.data.status === "success") {
                    setIsLoading(false)
                    setAlertShow(true)
                    setAlertType('success')
                    setAlertMessage('Success')
                    setSendCustomerModal(false)
                    setAlertValue(<>
                        <p className="mb-3">Note <span style={{ fontWeight: 'bold' }}>{noteNumber}</span> Sent to Customer Successfully</p>
                    </>)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setCCEmailsData([]);
                                setNewlyAddedEmails([]);
                                setAllEmails([]);
                                setAlertShow(false)
                                setCurrentPage(1);
                                backFunction();
                                backPagination()
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_GST_SUBMIT_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_FAILURE,
                                    payload: null
                                })
                            }
                        },
                        {
                            name: 'View Note', variant: 'outline-secondary', action: () => {
                                setCCEmailsData([]);
                                setNewlyAddedEmails([]);
                                setAllEmails([]);
                                setAlertShow(false)
                                viewInvoiceNote(noteId, 'emailed', 'miscellaneous')
                            }
                        },
                    ])
                }
            })
            .catch((error) => {
                setIsLoading(false)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error ')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_GST_SUBMIT_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_FAILURE,
                            payload: null
                        })
                    }
                }])
            })
    }

    const handleGeneratePdf = () => {
        setIsLoading(true);
        axios.post(`${base_url}invoices/generateNotePdf`, {
            note_number: noteNumber
        }
        ) // Get JSON response
            .then((response) => {
                if (response.data.status === 'success') {
                    setAlertShow(true)
                    setAlertType('success')
                    setAlertMessage('Success')
                    setAlertValue(
                        <p className="mb-3">Note <span style={{ fontWeight: 'bold' }}>{noteNumber}</span> Generated PDF Successfully</p>
                    )
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                                setIsLoading(false);
                                setCurrentPage(1);
                                backFunction();
                                backPagination()
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_GST_SUBMIT_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_FAILURE,
                                    payload: null
                                })
                            }
                        },
                        {
                            name: 'view Note', variant: 'outline-secondary', action: () => {
                                setAlertShow(false)
                                viewInvoiceNote(noteId, 'pdfgenerated',)
                            }
                        },
                    ])
                }
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                if (error) {
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error ')
                    setAlertValue(error?.response?.data.message)
                    setAlertButtons([{
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_GST_SUBMIT_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_FAILURE,
                                payload: null
                            })
                        }
                    }])
                }
                setIsLoading(false);
            });
    };

    const handleReject = () => {
        setRejectModal(true)
    }

    const handleHold = () => {
        setAlertShow(true)
        setAlertType('question')
        setAlertMessage('')
        setAlertValue('Do you want to put this note On-hold?')
        setAlertButtons([{
            name: 'Close', action: () => {
                setAlertShow(false)
                dispatch({
                    type: PUT_ADD_MISC_INVOICE_SUCCESS,
                    payload: null
                })
                dispatch({
                    type: PUT_GST_SUBMIT_SUCCESS,
                    payload: null
                })
                dispatch({
                    type: PUT_ADD_MISC_INVOICE_FAILURE,
                    payload: null
                })
            }
        },
        {
            name: 'Proceed', action: () => {
                setAlertShow(false)
                holdInvoice()
            }
        }
        ])
    }

    const editInvoice = () => {
        setAlertShow(true)
        setAlertType('question')
        setAlertMessage('')
        setAlertValue('Do you approve this note?')
        setAlertButtons([{
            name: 'Close', action: () => {
                setAlertShow(false)
                dispatch({
                    type: PUT_ADD_MISC_INVOICE_SUCCESS,
                    payload: null
                })
                dispatch({
                    type: PUT_GST_SUBMIT_SUCCESS,
                    payload: null
                })
                dispatch({
                    type: PUT_ADD_MISC_INVOICE_FAILURE,
                    payload: null
                })
            }
        },
        {
            name: 'Proceed', action: () => {
                setAlertShow(false)
                sendForApproval()
            }
        }
        ])
    }

    const checkSendForApprovalValidation = () => {
        if (toggleShippingAddress) {
            // return streetAddress && city && state && pincode && streetAddress !== "" && city !== "" && state !== "" && pincode !== "" && pincode.length === 6
            return true
        } else {
            return true
        }
    }

    const rejectAnInvoice = () => {
        const body = {
            "note_number": noteNumber,
            "note_id": noteId,
            'rejected_reason': rejectReason,
            "status": "rejected"
        }
        dispatch({
            type: PUT_INVOICE_DATA_SUCCESS,
            payload: null
        })
        setInvoiceStatusTo('rejected')
        dispatch(putNoteData(body))
    }

    const holdInvoice = () => {
        const body = {
            "note_number": noteNumber,
            "note_id": noteId,
            "status": "onhold"
        }
        dispatch({
            type: PUT_INVOICE_DATA_SUCCESS,
            payload: null
        })
        setInvoiceStatusTo('onhold')
        dispatch(putNoteData(body))
    }

    const sendForApproval = () => {
        // setIsLoading(true)
        const body = {
            // "invoice_number": invoiceNo,
            // "invoice_id": invoiceId,
            "note_number": noteNumber,
            "note_id": noteId,
            "status": "approved"
        }
        dispatch({
            type: PUT_INVOICE_DATA_SUCCESS,
            payload: null
        })
        setInvoiceStatusTo('approved')
        dispatch(putNoteData(body))
    }

    const handleDownload = () => {
        setIsLoading(true);
        axios.get(`${base_url}documents/invoiceDocuments`, {
            params: {
                filter_condition: JSON.stringify({
                    s3_keys: [downloadPath]
                })
            },
        }
        ) // Get JSON response
            .then((response) => {
                let data = response.data?.data[0]?.invoice; // Assuming the base64-encoded PDF is inside this path
                if (!data) {
                    return;
                }
                // Remove b' prefix and trailing '
                data = data.replace(/^b'|^b"|['"]$/g, '');
                // Create a data URL with base64 content
                const link = document.createElement('a');
                link.href = `data:application/pdf;base64,${data}`;
                link.setAttribute('download', `${noteType}-${noteNumber}.pdf`); // Set the file name for download
                document.body.appendChild(link); // Append the link to the DOM
                link.click(); // Programmatically click the link to trigger the download
                link.remove(); // Remove the link after triggering download
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                if (error) {
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error ')
                    setAlertValue(error?.response?.data.message)
                    setAlertButtons([{
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_GST_SUBMIT_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_FAILURE,
                                payload: null
                            })
                        }
                    }])
                }
                setIsLoading(false);
            });
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const invoiceNo = params.get('number');
        const type = params.get('type');
        // if (invoiceNo || isCreate) {
        //     if (isCreate) {
        //         handleViewButton(invoiceNo)
        //     }
        // }
        if (type == "00") {
            handleViewButton(invoiceNo)
        } else if (type == "01") {
            handleViewButton(invoiceNo)
            setNoteType('Debit Note');
        }
        else if (type == "10") {
            viewInvoiceNote(invoiceNo, 'credit')
            setIsNote(true);
        } else if (type == "11") {
            viewInvoiceNote(invoiceNo, 'debit')
            setNoteType('Debit Note');
            setIsNote(true);
        }
        if (!invoiceNo) {
            getCreditList(undefined, 1);
        }
    }, []);

    useEffect(() => {
        // dispatch(commercialHeadGetAllFacilitiesForNav());
        dispatch(getAllServices())
        // get company details
        dispatch(getAllPartnerCompanies());
        dispatch(commercialHeadGetBillingEntities());
    }, [dispatch]);

    useEffect(() => {
        if (facilitiesListForNav) {
            const options = facilitiesListForNav?.map((facility) => `${facility.city}, ${facility.name}`);
            setFacilityList(options);
        }
    }, [facilitiesListForNav]);

    // Error handling
    useEffect(() => {
        if (invoicesListError) {
            setInvoiceListErrorFlag(true);
            setAlertShow(true);
            setAlertType('error');
            setAlertMessage('Error');
            setAlertValue(invoicesListError);
            setAlertButtons([{
                name: 'Close', action: () => {
                    setAlertShow(false);
                    dispatch({
                        type: GET_ALL_INVOICES_ERROR,
                        payload: null
                    });
                }
            }]);
        }
    }, [invoicesListError, dispatch]);

    // Filter apply
    const applyFilter = () => {
        localStorage.setItem("selected_facility_name", selectedFacilityName);
        localStorage.setItem("selected_city_name", selectedCityName);
        localStorage.setItem("selected_facility_id", selectedFacilityId);
        const monthNumber = billingMonthFilter;
        const fullYear = billingYearFilter;
        getCreditList(tabType === "all" ? undefined : (tabType === 'credit' ? 'credit' : 'debit'), 1);


        setInvoiceListErrorFlag(false);
    };

    // Search handler
    const handleSearchSubmit = (searchValue) => {
        if (validateValue(searchValue)) {
            setSearchText(searchValue);
        }
    };

    // Clear filters
    const handleClear = () => {
        setSearchText('');
        setinvoiceSelected('');
        setBillingPeriodFilter(new Date());
        setBillingMonthFilter(dayjs().month() + 1);
        setBillingYearFilter(dayjs().year());
        setInvoiceListErrorFlag(false);
        setTabType("all");
        getCreditList(undefined, 1, dayjs().month() + 1, dayjs().year(), "", "");
    };


    const getCreditList = (noteType, page, month, year, serviceName, text) => {
        setIsLoading(true);
        let typeOfInvoice = '';
        if (serviceName) {
            typeOfInvoice = serviceName;
        } else {
            typeOfInvoice = invoiceSelected;
        }
        axios.get(`${base_url}invoices/get_all_notes`, {
            params: {
                note_type: noteType,
                search_text: text === '' ? undefined : searchText,
                items_per_page: RECORDS_PER_PAGE,
                page_number: page ? page : currentPaginationPage,
                filter_condition: JSON.stringify({
                    facility_id: selectedFacilityId,
                    note_year: year ? year : billingYearFilter,
                    note_month: month ? month : billingMonthFilter,
                    service_name_in_note: typeOfInvoice !== "" ? typeOfInvoice : undefined,
                })
            }
        })
            .then(res => {
                const response = res.data.data;
                const info = res.data.info;
                setCurrentPaginationPage(info.page_number);
                setTotalNotes(info.total_no_of_records);



                const updatedData = response.map(item => ({
                    ...item,
                    invoice_number: item.invoice_data?.invoice_number || null, // bring it out
                    billingPeriod: getMonthName(item.note_month) + " " + item.note_year
                }));

                setCreditAndDebitList(updatedData);
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
                setAlertShow(true);
                setAlertType('error');
                setAlertMessage('Error');
                setAlertValue(error?.response?.data.message);
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false);
                        dispatch({
                            type: GET_ALL_INVOICES_ERROR,
                            payload: null
                        });
                    }
                }]
                );

            });
    }

    useEffect(() => {
        if (billingEntities) {
            const billingEntitiesOptions = billingEntities.map((each) => {
                return {
                    label: each?.company_name,
                    value: each?.partner_company_id
                }
            })
            setBillingEntityOptions(billingEntitiesOptions)
            // if (editMiscInvoiceClicked) {
            const billingEntity = billingEntities.find(each => each.company_name === companyName && each.gst_number === companyGST)
            setBillingEntityDropdown({
                label: billingEntity?.company_name,
                value: billingEntity?.partner_company_id
            })
        }
    }, [billingEntities, companyName, companyGST]);

    useEffect(() => {
        if (facilitiesListForNav) {
            const options = facilitiesListForNav?.map((facility) => `${facility.city}, ${facility.name}`);
            setFacilityList(options);
        }
    }, [facilitiesListForNav]);

    const [miscCgstSgstOptions, setMiscCgstSgstOptions] = useState(() => {
        const options = []
        taxPercentageOptions.forEach(each => {
            options.push(parseFloat(each / 2))
        })
        return options
    })
    const [miscInvoiceTable, setMiscInvoiceTable] = useState([{
        service: "", hsn: "", hsnError: false, hsnLoader: false, hsnMsg: '', basicAmount: 0.0, cgst: 9.0, sgst: 9.0, igst: 18.0, gross: 0.0
        , from_date: "", to_date: "", consumption: 0.0, rate_per_unit: 0.0
    }])

    const getImage = (logo) => {
        dispatch({
            type: SET_LOADER,
            payload: true
        })
        axios.get(`${base_url}documents?filter_condition=%7B%22s3_keys%22%3A%5B%22${logo}%22%5D%7D`)
            .then(response => {
                const documentData = response.data.data[0].file
                const trimmedData = 'data:image/webp;base64,' + documentData.slice(2, -1)
                if (trimmedData) {
                    setCompanyLogo(trimmedData)
                }
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            })
            .catch(error => {
                setCompanyLogo(null)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_GST_SUBMIT_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_FAILURE,
                                payload: null
                            })
                        }
                    },
                ])
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            }
            )
    }

    const [serviceNameInInvoice, setServiceNameInInvoice] = useState('')

    const [invoiceNoList, setInvoiceNoList] = useState([])
    const [selectedInvoiceNo, setSelectedInvoiceNo] = useState(null)

    const states = [
        'Delhi',
        'Andhra Pradesh',
        'Arunachal Pradesh',
        'Assam',
        'Bihar',
        'Chhattisgarh',
        'Goa',
        'Gujarat',
        'Haryana',
        'Himachal Pradesh',
        'Jharkhand',
        'Karnataka',
        'Kerala',
        'Madhya Pradesh',
        'Maharashtra',
        'Manipur',
        'Meghalaya',
        'Mizoram',
        'Nagaland',
        'Odisha',
        'Punjab',
        'Rajasthan',
        'Sikkim',
        'Tamil Nadu',
        'Telangana',
        'Tripura',
        'Uttar Pradesh',
        'Uttarakhand',
        'West Bengal'
    ];

    const stateOptions = states.map(state => ({
        label: state,
        value: state
    }));

    const addMiscInvoiceValidation = () => {
        let isValid = billingEntityDropdown
            && miscContractName && miscPlaceOfSupply
            && miscInvoiceTable.length > 0 && miscInvoiceTable.every(each => each.service && each.hsn && each.basicAmount && !each.hsnError)
            && miscListOfContacts.length > 0 && miscListOfContacts.some(each => each.sendEmail)

        if (miscShowBilling) {
            isValid = isValid && miscInvoiceTable.every(each => each.from_date && each.to_date)
        }
        if (miscShowComputations) {
            isValid = isValid && miscInvoiceTable.every(each => each.consumption && each.rate_per_unit)
        }
        return isValid
    }


    const backFunction = () => {
        setFileData([]);
        setTermsAndConditionsKey(null);
        setDocumentLoader(false);
        setIsCreditDebitClicked(false);
        setInvoicePaymentDetails(null)
        setSendCustomerMessage('')
        setSendCustomerSubject('')
        // setCreditAndDebitList([]);
        setIsRegisteredAddressEdited(false);
        getCreditList(tabType === "all" ? undefined : (tabType === 'credit' ? 'credit' : 'debit'), 1);
        setIsEditClicked(false);
        setNoteNumber('');
        setNoteId('');
        setNoteTypeStatus('');
        setCurrentPage(1)
        setEditInvoiceClicked(false)
        setIsNote(false);
        setServiceNameInInvoice('')
        setInvoiceId('')
        setPreview(false)
        setIgstToggle(false)
        setPaymentToggle(false)
        setTermsToggle(false)
        setUserNotesToggle(false)
        setUserNotes("")
        setUserNotesError("")
        setShippingAddressToggle(false)
        setShippingCompanyName("")
        setShippingCompanyAddress("")
        setMiscService("")
        setMiscDescription("")
        setMiscBasicAmount(null)
        setMiscDueDate("")
        setCompanyName("")
        setInvoiceDetails([])
        setCompanyCIN("")
        setCompanyGST("")
        setCompanyPhone("")
        setCompanyAddress("")
        setCompanyLogo("")
        setcustomerName("")
        setContractNo("")
        setcustomerGSTIN("")
        setcustomerPAN("")
        setIRN("")
        setAckNo("")
        setAckDate("")
        setCompanyAddress("")
        setcustomerAddress("")
        setcustomerPlaceOfSupply("")
        setPartnerBillDate("")
        setPartnerDueDate("")
        setPartnerState("")
        setPartnerPAN("")
        setPartnerCIN("")
        setInvoiceNo("")
        setPartnerStateCode("")
        setcustomerStateCode("")
        setBasicAmount("")
        setTotalAmount("")
        setTotalAmountInWords("")
        setTotalCgst(0)
        setTotalSgst(0)
        setTotalIgst(0)
        setInvoiceStatus("")
        setToggleShippingAddress(false)
        setStreetAddress("")
        setCity("")
        setState("")
        setPincode("")
        setApprovalType('')
        setInvoiceStatusTo('')
        setpdfDataForPayments('')
        setpdfDataForTerms('')
        setcustomerCIN('')
        setRejectReason('')
        setShowComputationDetails(false)
        setShowPaymentDetails(false)
        setShowTermsDetails(false)

        //for misc invoice 
        setMiscInvoiceTable([{
            service: "", hsn: "", hsnError: false, hsnLoader: false, hsnMsg: '', basicAmount: 0.0, cgst: 9.0, sgst: 9.0, igst: 18.0, gross: 0.0,
            consumption: 0.0, rate_per_unit: 0.0, from_date: '', to_date: ''
        }])
        setMiscListOfContacts([])
        setMiscIgstOptions([...taxPercentageOptions])
        setContractsDropdown([])
        setBillingEntityDropdown(null)
        setBillingEntityOptions([])
        setMiscPlaceOfSupply(null)
        setMiscContractName(null)
        setMiscTotalBasicAmount(0.0)
        setMiscTotalTaxAmount(0.0)
        setMiscCgstSgstOptions(() => {
            const options = []
            taxPercentageOptions.forEach(each => {
                options.push(parseFloat(each / 2))
            })
            return options
        })
        setUploadedFiles([])
        setEditMiscInvoiceClicked(false)
        setCompanyAddress('')
        setcustomerAddress('')
        setShippingAddress('')
        setDownloadPath('')
        setQrCode('')
        setMiscShowBilling(false)
        setMiscShowComputations(false)
        setinvoiceSelected('')
        // setInvoiceNo('')
        setSelectedInvoiceNo('')
    }
    const backPagination = () => {
        const monthNumber = billingMonthFilter
        const fullYear = billingYearFilter

        dispatch({
            type: SET_PAGINATION_COUNT_TO,
            payload: 1
        })
        // dispatch(getAllInvoices({ page: currentPaginationPageAc, limit: RECORDS_PER_PAGE, facility_id: localStorage.getItem("selected_facility_id"), invoiceType, monthNumber, fullYear, searchText, invoiceSelected }))
        setInvoiceListErrorFlag(false)
    }

    const editMiscInvoice = () => {
        const tableDetails = miscInvoiceTable?.map(each => {
            if (igstToggle) {
                return {
                    service_name_in_invoice: each.service,
                    hsn_code: each.hsn?.toString(),
                    net_amount: parseFloat(each.basicAmount),
                    igst_rate: parseInt(each.igst),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date
                }
            } else {
                return {
                    service_name_in_invoice: each.service,
                    hsn_code: each.hsn?.toString(),
                    net_amount: parseFloat(each.basicAmount),
                    cgst_rate: parseFloat(each.cgst),
                    sgst_rate: parseFloat(each.sgst),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date
                }
            }
        })
        let listOfContacts = []
        miscListOfContacts?.forEach(each => {
            if (each.sendEmail) {
                listOfContacts.push(each?.contact_id)
            }
        })
        const data = {
            invoice_number: invoiceNo,
            place_of_supply: miscPlaceOfSupply?.value,
            invoice_details: tableDetails,
            billing_entity: billingEntityDropdown?.value,
            contract_name: miscContractName?.label,
            misc_list_of_contacts: listOfContacts,
            show_billing_period: miscShowBilling,
            show_computation_details: miscShowComputations,
        }
        dispatch(editAMiscInvoice(data))
    }

    const addMiscInvoice = () => {
        const tableDetails = miscInvoiceTable?.map(each => {
            if (igstToggle) {
                return {
                    service_name_in_invoice: each.service,
                    hsn_code: each.hsn,
                    net_amount: parseFloat(each.basicAmount),
                    igst_rate: parseInt(each.igst),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date
                }
            } else {
                return {
                    service_name_in_invoice: each.service,
                    hsn_code: each.hsn,
                    net_amount: parseFloat(each.basicAmount),
                    cgst_rate: parseFloat(each.cgst),
                    sgst_rate: parseFloat(each.sgst),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date
                }
            }
        })
        let listOfContacts = []
        miscListOfContacts?.forEach(each => {
            if (each.sendEmail) {
                listOfContacts.push(each?.contact_id)
            }
        })
        const data = {
            place_of_supply: miscPlaceOfSupply?.value,
            invoice_details: tableDetails,
            billing_entity: billingEntityDropdown?.value,
            contract_name: miscContractName?.label,
            misc_list_of_contacts: listOfContacts,
            show_billing_period: miscShowBilling,
            show_computation_details: miscShowComputations,
        }
        dispatch(createNewMiscInvoice(data))
    }

    const addCreditDebitNote = () => {
        const tableDetails = invoiceDetails?.map(each => {
            if (igstToggle) {
                return {
                    service_name_in_note: each.service_name_in_invoice,
                    hsn_code: (each.hsn)?.toString(),
                    service_identifier: each.service_identifier,
                    net_amount: parseFloat(each.basicAmount),
                    igst_rate: parseInt(each.igst_rate),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date,
                    initial_reading: parseFloat(each.initial_reading),
                    final_reading: parseFloat(each.final_reading),
                }
            } else {
                return {
                    service_name_in_note: each.service_name_in_invoice,
                    service_identifier: each.service_identifier,
                    hsn_code: (each.hsn)?.toString(),
                    net_amount: parseFloat(each.basicAmount),
                    cgst_rate: parseFloat(each.cgst_rate),
                    sgst_rate: parseFloat(each.sgst_rate),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date,
                    initial_reading: parseFloat(each.initial_reading),
                    final_reading: parseFloat(each.final_reading),
                }
            }
        })

        const billingEntity = billingEntityDropdown?.value;
        // Convert ackDate from dd-mm-YYYY to YYYY-mm-dd
        let invoice_date = '';
        if (ackDate) {
            const [dd, mm, yyyy] = ackDate.split('/');
            invoice_date = `${yyyy}-${mm}-${dd}`;
        }

        const data = {
            invoice_number: invoiceNo,
            invoice_type: invoiceType,
            invoice_date: invoice_date,
            // registered_address : 
            // registered_address: isRegisteredAddressEdited ? companyAddress : undefined,
            invoice_details: tableDetails,
            place_of_supply: customerPlaceOfSupply,
            billing_entity: billingEntity,
            contract_name: miscContractName,
            show_billing_period: miscShowBilling,
            show_computation_details: miscShowComputations,
            invoice_id: invoiceId,
            terms_and_conditions: termsAndConditionsKey,
            invoice_due_amount: parseFloat(invoicePaymentDetails?.amount_due),
        }
        if (noteType == 'Credit Note') {
            dispatch(createNewCreditNote(data))
        } else {
            dispatch(createNewDebitNote(data))
        }
    }

    const updateCreditNote = () => {
        const tableDetails = invoiceDetails?.map(each => {
            if (igstToggle) {
                return {
                    service_name_in_note: each.service_name_in_note,
                    hsn_code: (each.hsn)?.toString(),
                    service_identifier: each.service_identifier,
                    net_amount: parseFloat(each.basicAmount),
                    igst_rate: parseInt(each.igst_rate),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date,
                    initial_reading: parseFloat(each.initial_reading),
                    final_reading: parseFloat(each.final_reading),
                }
            } else {
                return {
                    service_name_in_note: each.service_name_in_note,
                    service_identifier: each.service_identifier,
                    hsn_code: (each.hsn)?.toString(),
                    net_amount: parseFloat(each.basicAmount),
                    cgst_rate: parseFloat(each.cgst_rate),
                    sgst_rate: parseFloat(each.sgst_rate),
                    consumption: parseFloat(each.consumption),
                    rate_per_unit: parseFloat(each.rate_per_unit),
                    from_date: each.from_date,
                    to_date: each.to_date,
                    initial_reading: parseFloat(each.initial_reading),
                    final_reading: parseFloat(each.final_reading),
                }
            }
        })

        const placeOfSupply = null;
        const billingEntity = billingEntityDropdown?.value;
        const listOfContacts = miscListOfContacts

        const data = {
            // invoice_number: invoiceNo,
            // invoice_type: invoiceType,
            note_number: noteNumber,
            note_id: noteId,
            note_type: noteTypeStatus,
            // registered_address: isRegisteredAddressEdited ? companyAddress : undefined,
            note_details: tableDetails,
            place_of_supply: customerPlaceOfSupply,
            billing_entity: billingEntity,
            contract_name: miscContractName,
            terms_and_conditions: termsAndConditionsKey,
            // misc_list_of_contacts: listOfContacts,
            show_billing_period: miscShowBilling,
            show_computation_details: miscShowComputations,
            invoice_id: invoiceId,
            invoice_due_amount: parseFloat(invoicePaymentDetails?.amount_due),
        }
        if (noteTypeStatus == 'credit') {
            dispatch(updateCreditNoteApi(data))
        } else {
            dispatch(updateDebitNoteApi(data))
        }
        // dispatch(updateCreditNoteApi(data))
    }

    const getDocuments1 = (footer) => {
        const payementDoc = footer?.payment_terms
        const termsDoc = footer?.terms_and_conditions
        let url = '%7B%22s3_keys%22%3A%5B%22'
        if (payementDoc && termsDoc) {
            url = url + payementDoc + '%22%2C%22' + termsDoc + '%22%5D%7D'
        }
        else if (payementDoc) {
            url = url + payementDoc + '%22%5D%7D'
        }
        else if (termsDoc) {
            url = url + termsDoc + '%22%5D%7D'
        }
        if (url !== '%7B%22s3_keys%22%3A%5B%22') {
            dispatch({
                type: SET_LOADER,
                payload: true
            })
            axios.get(`${base_url}documents?filter_condition=${url}`)
                .then(response => {
                    if (response?.data?.data[0] === 'error') {
                        setAlertShow(true)
                        setAlertType('error')
                        setAlertMessage('Error')
                        setAlertValue(response?.data?.data[1].message)
                        setAlertButtons([
                            {
                                name: 'Close', action: () => {
                                    setAlertShow(false)
                                    // window.location.reload()
                                    dispatch({
                                        type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                        payload: null
                                    })
                                    dispatch({
                                        type: PUT_GST_SUBMIT_SUCCESS,
                                        payload: null
                                    })
                                    dispatch({
                                        type: PUT_ADD_MISC_INVOICE_FAILURE,
                                        payload: null
                                    })
                                }
                            },
                        ])
                        dispatch({
                            type: SET_LOADER,
                            payload: false
                        })
                    }
                    else {
                        const documentData = response.data.data
                        if (payementDoc && termsDoc) {
                            const trimmedData1 = documentData[0].file?.slice(2, -1)
                            const trimmedData2 = documentData[1].file?.slice(2, -1)
                            setpdfDataForPayments(trimmedData1)
                            setpdfDataForTerms(trimmedData2)
                            setPaymentToggle(true)
                            setTermsToggle(true)
                        }
                        else if (payementDoc) {
                            const trimmedData = documentData[0].file?.slice(2, -1)
                            setpdfDataForPayments(trimmedData)
                            setPaymentToggle(true)
                        }
                        else if (termsDoc) {
                            const trimmedData = documentData[0].file?.slice(2, -1)
                            setTermsAndConditions(documentData[0])
                            setTermsAndConditionsKey(footer.terms_and_conditions)
                            setpdfDataForTerms(trimmedData)
                            setTermsToggle(true)
                        }
                        dispatch({
                            type: SET_LOADER,
                            payload: false
                        })
                    }
                })
                .catch(error => {
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(error?.response?.data.message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_GST_SUBMIT_SUCCESS,
                                    payload: null
                                })
                                dispatch({
                                    type: PUT_ADD_MISC_INVOICE_FAILURE,
                                    payload: null
                                })
                            }
                        },
                    ])
                    dispatch({
                        type: SET_LOADER,
                        payload: false
                    })
                })
        }

    }

    const getAllInvoicesData = async (facilityId, invoiceType, status, month, year) => {
        setIsLoading(true);

        const commonParams = {
            request_type: "dropdown",
            invoiceType: invoiceType,
        };

        const filterConditions = [
            { status: "pdfgenerated" },
            // { status: "gstsubmitted" },
            { status: "emailed" },
        ];

        try {
            // Call all 3 APIs in parallel
            const responses = await Promise.all(
                filterConditions.map(condition =>
                    axios.get(base_url + `invoices/invoicesByStatus`, {
                        params: {
                            ...commonParams,
                            filter_condition: JSON.stringify({
                                facility_id: facilityId,
                                status: condition.status,
                                invoice_year: year,
                                invoice_month: month,
                            }),
                        },
                    })
                )
            );

            // Extract and merge all results
            const allData = responses.flatMap(res => res.data?.data || []);

            // Collect all invoice numbers
            const listOfKeys = allData
                .map(each => each.invoice_number)
                .filter(Boolean); // removes null/undefined

            setInvoiceNoList(listOfKeys);
        } catch (error) {
            console.error("Error fetching invoices:", error);
        } finally {
            setIsLoading(false);
        }
    };



    function formatAddressWithCapitalization(address) {
        const addressComponents = address?.split(';;');
        const formattedAddress = addressComponents
            .map(component => component
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')
            ).join(', ');
        return formattedAddress;
    }

    useEffect(() => {
        if (billingEntityDropdown && miscPlaceOfSupply) {
            setIsLoading(true)
            const billingEntity = billingEntities.find(each => each.partner_company_id === billingEntityDropdown.value)
            const placeOfSupply = miscPlaceOfSupply.value
            // api call to get the tax rates
            // invoices/transactionType
            const data = {
                "gst_number": billingEntity?.gst_number,
                "state": placeOfSupply
            }
            // gst_number = 29AAACW0000A1ZP & state=Karnataka
            axios.get(base_url + "invoices/transactionType?gst_number=" + billingEntity?.gst_number + "&state=" + placeOfSupply)
                .then((response) => {
                    const taxRates = response.data.data?.data
                    if (taxRates.igst === true) {
                        setIgstToggle(true)
                        const cgstInTable = miscInvoiceTable.some(each => each.cgst)
                        if (cgstInTable) {
                            const tableData = miscInvoiceTable.map(each => {
                                return {
                                    ...each,
                                    igst: each.cgst + each.sgst
                                }
                            })
                            setMiscInvoiceTable(tableData)
                        }
                    } else {
                        setIgstToggle(false)
                        const igstInTable = miscInvoiceTable.some(each => each.igst)
                        if (igstInTable) {
                            const tableData = miscInvoiceTable.map(each => {
                                return {
                                    ...each,
                                    cgst: each.igst / 2,
                                    sgst: each.igst / 2
                                }
                            })
                            setMiscInvoiceTable(tableData)
                        }
                    }
                    setIsLoading(false)
                })
                .catch((error) => {
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error ')
                    setAlertValue(error?.response?.data.message)
                    setAlertButtons([{
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_GST_SUBMIT_SUCCESS,
                                payload: null
                            })
                            dispatch({
                                type: PUT_ADD_MISC_INVOICE_FAILURE,
                                payload: null
                            })
                        }
                    }])
                    setIsLoading(false)
                })
        }
    }, [billingEntityDropdown, miscPlaceOfSupply])

    const getInvoiceDetialsByID = (id) => {
        axios.get(`${base_url}invoices/get_invoice?invoice_number=${id}`)
            .then(response => {
                const invoiceData = response.data.data
                const paymentDetails = invoiceData.payment_details
                setInvoicePaymentDetails(paymentDetails)
            })
            .catch(error => {
            })
    }

    const handleEditMiscInvoice = () => {
        setEditMiscInvoiceClicked(true)
        dispatch(commercialHeadGetBillingEntities())
        dispatch(commercialHeadGetCompleteContractsForDropdown(localStorage.getItem('selected_facility_id')))
        setEditInvoiceClicked(true)
        setIsEditClicked(true);
        getInvoiceDetialsByID(invoiceNo)
        // setIsNote(false);
        // handling basic amount 
        // const tableData = invoiceDetails.map(({ net_amount, ...rest }) => ({
        //     ...rest,
        //     basicAmount: net_amount,
        //     sgst_rate: parseInt(rest.sgst_rate),
        //     cgst_rate: parseInt(rest.cgst_rate),
        //     igst_rate: parseInt(rest.igst_rate),
        // }));
        // setMiscInvoiceTable([...tableData])
        // // setMiscTotalTaxAmount(totalTaxAmount)
        // const invoiceTable = [...tableData]
        // let totalTaxAmount = 0
        // if (igstToggle) {
        //     totalTaxAmount = invoiceTable.reduce((acc, each) => acc + parseFloat(each.basicAmount / 100) * (parseFloat(each.igst_rate)), 0)
        // }
        // else {
        //     totalTaxAmount = invoiceTable.reduce((acc, each) => acc + parseFloat(each.basicAmount / 100) * (parseFloat(each.cgst_rate) + parseFloat(each.sgst_rate)), 0)
        // }
        // // setMiscShowBilling(in)
        // setMiscTotalTaxAmount(totalTaxAmount)
        // setMiscTotalBasicAmount(basicAmount)
    }

    const [invoiceContactDetails, setInvoiceContactDetails] = useState([])

    const viewInvoiceNoteByNumber = (id, status, type) => {
        setIsLoading(true)
        setIsEditClicked(false);
        // setInvoiceStatus(status)
        setIsNote(true);
        let typeOfInvoice = ''
        axios.get(`${base_url}invoices/get_note`, {
            params: {
                note_number: id,
            }
        })
            .then(response => {
                const invoiceData = response.data.data
                const invoiceMaster = invoiceData.note_master
                const invoiceDetails = invoiceData.note_details
                const invoiceFooter = invoiceData.note_footer
                const invoiceHeader = invoiceData?.note_header
                setNoteNumber(invoiceMaster?.note_number)
                setNoteTypeStatus(invoiceMaster?.note_type)
                if (invoiceFooter.payment_terms || invoiceFooter.terms_and_conditions) {
                    getDocuments1(invoiceFooter)
                }
                if (invoiceHeader?.partner_logo) {
                    getImage(invoiceHeader?.partner_logo)
                } else {
                    setCompanyLogo(null)
                }

                // let isIgst  
                // invoiceDetails.some(e => e.igst > 0 ? isIgst = true : isIgst = false)
                // const isIgstToggle = isIgst
                if (invoiceHeader?.transaction_type_inter_state === 1) {
                    setIgstToggle(true)
                    // const totalTaxAmount = invoiceDetails.reduce((acc, each) => acc + parseFloat(each.igst), 0)
                    // setTotalTaxAmount(invoiceMaster?.total_tax_amount)
                    setTotalIgst(invoiceMaster?.total_igst)
                } else {
                    // const totalTaxAmount = invoiceDetails.reduce((acc, each) => acc + parseFloat(each.cgst) + parseFloat(each.sgst), 0)
                    setTotalSgst(invoiceMaster?.total_sgst)
                    setTotalCgst(invoiceMaster?.total_cgst)
                }
                // handling basic amount 
                const tableData = invoiceDetails.map(({ net_amount, ...rest }) => ({
                    ...rest,
                    basicAmount: net_amount,
                    sgst_rate: parseInt(rest.sgst_rate),
                    cgst_rate: parseInt(rest.cgst_rate),
                    igst_rate: parseInt(rest.igst_rate),
                }));
                setInvoiceStatus(invoiceMaster.status)
                const detailsBasicAmount = invoiceDetails.reduce((acc, each) => acc + parseFloat(each.net_amount), 0)
                const totalAmountInWords = convertCurrencyToWords(invoiceMaster.gross_amount)
                const addressComponents = invoiceHeader?.partner_address.split(';;');
                const formattedAddress = formatAddressWithCapitalization(invoiceHeader?.partner_address)
                const state = addressComponents.length > 1 ? addressComponents[addressComponents.length - 2] : '';
                const stateVariable = state;
                const addressComponentsC = invoiceHeader?.customer_address.split(';;');
                const formattedAddressC = invoiceHeader?.billing_address ? formatAddressWithCapitalization(invoiceHeader?.billing_address) : ''
                const stateC = addressComponentsC.length > 1 ? addressComponentsC[addressComponentsC.length - 3] : '';
                const stateVariableC = stateC;
                if (invoiceMaster?.show_computation_details === 1) {
                    setShowComputationDetails(true)
                    setMiscShowComputations(true)
                } else {
                    setShowComputationDetails(false)
                    setMiscShowComputations(false)
                }
                if (invoiceMaster?.show_billing_period === 1) {
                    setShowBillingPeriod(true)
                    setMiscShowBilling(true)
                } else {
                    setShowBillingPeriod(false)
                    setMiscShowBilling(false)
                }
                if (invoiceFooter?.show_pterms === 1) {
                    setShowPaymentDetails(true)
                }
                if (invoiceFooter?.show_tandc === 1) {
                    setShowTermsDetails(true)
                }
                setSelectedFacilityId(invoiceMaster?.facility_id)
                setMiscContractName(invoiceMaster?.contract_name)
                setInvoiceType(invoiceMaster?.service_name_in_note)
                typeOfInvoice = invoiceMaster?.service_name_in_note;
                setMiscListOfContacts(invoiceData?.invoice_contacts)

                setServiceNameInInvoice(invoiceMaster?.service_name_in_invoice)
                setDownloadPath(invoiceMaster?.pdf_path_on_s3)
                setCompanyName(invoiceMaster.company_name)
                setFacilityName(invoiceMaster?.facility_name)
                setInvoiceId(invoiceMaster?.invoice_id)
                setNoteNumber(invoiceMaster?.note_number)
                setNoteId(invoiceMaster?.note_id)
                setSlfInvoiceName(invoiceDetails?.service_name_in_invoice)
                setInvoiceDetails([...tableData])
                setCompanyCIN(invoiceHeader?.partner_cin)
                setCompanyName(invoiceHeader?.partner_name)
                setQrCode(invoiceHeader?.qr_code)
                setcustomerCIN(invoiceHeader?.customer_cin)
                setCompanyGST(invoiceHeader?.partner_gstin)
                setCompanyPhone(invoiceHeader?.partner_phone)
                setCompanyAddress(invoiceHeader?.partner_address)
                // setCompanyLogo(invoiceHeader?.partner_logo)
                setcustomerName(invoiceHeader?.customer_name)
                setContractNo(invoiceMaster?.contract_number)
                setcustomerGSTIN(invoiceHeader?.customer_gstin)
                setcustomerPAN(invoiceHeader?.customer_pan)
                setIRN(invoiceHeader?.irn_number)
                setAckNo(invoiceHeader?.gst_portal_ack_no)
                setAckDate(formatDateBasedOnValue(formatDateView(invoiceHeader?.gst_portal_ack_date)))
                setCompanyAddress(formattedAddress);
                setcustomerAddress(formattedAddressC)
                setcustomerPlaceOfSupply(invoiceMaster?.pos_state)
                setPartnerBillDate(formatDateBasedOnValue(formatDateView(invoiceHeader?.issue_date)))
                setPartnerDueDate(formatDateBasedOnValue(formatDateView(invoiceMaster?.payment_due_date)))
                setPartnerState(stateVariable)
                setPartnerPAN(invoiceHeader?.partner_pan)
                setPartnerCIN(invoiceHeader?.partner_cin)
                setInvoiceNo(invoiceHeader?.invoice_number)
                setPartnerStateCode(invoiceHeader?.partner_gstin.substring(0, 2))
                setcustomerStateCode(invoiceHeader?.customer_gstin.substring(0, 2))
                setBasicAmount(invoiceMaster?.total_basic_amount)
                setTotalAmount(invoiceMaster.gross_amount)
                setTotalAmountInWords(invoiceMaster?.amount_in_words);
                setTimeout(() => {
                    setIsLoading(false)
                })
                setToggleShippingAddress(true)
                let companyAddress = invoiceHeader?.partner_address?.replace(/;;/g, ', ');
                let customerAddress = invoiceHeader?.customer_address?.replace(/;;/g, ', ');
                let billingAddress = invoiceHeader?.billing_address?.replace(/;;/g, ', ');
                let shippingAddress = invoiceHeader?.shipping_address?.replace(/;;/g, ', ');
                setCompanyAddress(companyAddress)
                setcustomerAddress(billingAddress)
                setShippingAddress(shippingAddress)
                const invoiceTable = [...tableData]
                let totalTaxAmount = 0;

                if (invoiceHeader?.transaction_type_inter_state === 1) {
                    totalTaxAmount = invoiceTable.reduce((acc, each) =>
                        acc + (parseFloat(each.basicAmount) * parseFloat(each.igst_rate) / 100),
                        0);
                } else {
                    totalTaxAmount = invoiceTable.reduce((acc, each) =>
                        acc + (parseFloat(each.basicAmount) * (parseFloat(each.cgst_rate) + parseFloat(each.sgst_rate)) / 100),
                        0);
                }

                setMiscTotalTaxAmount(totalTaxAmount);

                const basicAmount = invoiceMaster?.total_basic_amount
                setMiscTotalBasicAmount(basicAmount)
                if (typeOfInvoice === "electricity") {
                    setCurrentPage(2)
                } else if (typeOfInvoice === "water") {
                    setCurrentPage(4)
                } else if (typeOfInvoice === "slf") {
                    setCurrentPage(5)
                } else if (typeOfInvoice === "fms") {
                    setCurrentPage(6)
                } else if (typeOfInvoice === "miscellaneous") {
                    setCurrentPage(7)
                } else {
                    setCurrentPage(8)
                }
            })
            .catch(error => {
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_GST_SUBMIT_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_FAILURE,
                            payload: null
                        })
                    }
                }])
                setIsLoading(false)
            })
    }

    const viewInvoiceNote = (id, status, type) => {
        setIsLoading(true)
        // setInvoiceStatus(status)
        setIsNote(true);
        let typeOfInvoice = ''
        axios.get(`${base_url}invoices/get_note`, {
            params: {
                note_id: id,
            }
        })
            .then(response => {
                const invoiceData = response.data.data
                const invoiceMaster = invoiceData.note_master
                const invoiceDetails = invoiceData.note_details
                const invoiceFooter = invoiceData.note_footer
                const invoiceHeader = invoiceData?.note_header
                setNoteNumber(invoiceMaster?.note_number)
                setNoteTypeStatus(invoiceMaster?.note_type)
                setNoteType(invoiceMaster?.note_type == 'credit' ? 'Credit Note' : 'Debit Note')
                if (invoiceFooter.payment_terms || invoiceFooter.terms_and_conditions) {
                    getDocuments1(invoiceFooter)
                }
                if (invoiceHeader?.partner_logo) {
                    getImage(invoiceHeader?.partner_logo)
                } else {
                    setCompanyLogo(null)
                }

                let isIgst
                invoiceDetails.some(e => e.igst > 0 ? isIgst = true : isIgst = false)
                const isIgstToggle = isIgst
                if (isIgst) {
                    setIgstToggle(true)
                    // const totalTaxAmount = invoiceDetails.reduce((acc, each) => acc + parseFloat(each.igst), 0)
                    // setTotalTaxAmount(invoiceMaster?.total_tax_amount)
                    setTotalIgst(invoiceMaster?.total_igst)
                } else {
                    // const totalTaxAmount = invoiceDetails.reduce((acc, each) => acc + parseFloat(each.cgst) + parseFloat(each.sgst), 0)
                    setTotalSgst(invoiceMaster?.total_sgst)
                    setTotalCgst(invoiceMaster?.total_cgst)
                }
                // handling basic amount 
                const tableData = invoiceDetails.map(({ net_amount, ...rest }) => ({
                    ...rest,
                    basicAmount: net_amount,
                    sgst_rate: parseInt(rest.sgst_rate),
                    cgst_rate: parseInt(rest.cgst_rate),
                    igst_rate: parseInt(rest.igst_rate),
                }));
                setInvoiceStatus(invoiceMaster.status)
                const detailsBasicAmount = invoiceDetails.reduce((acc, each) => acc + parseFloat(each.net_amount), 0)
                const totalAmountInWords = convertCurrencyToWords(invoiceMaster.gross_amount)
                const addressComponents = invoiceHeader?.partner_address.split(';;');
                const formattedAddress = formatAddressWithCapitalization(invoiceHeader?.partner_address)
                const state = addressComponents.length > 1 ? addressComponents[addressComponents.length - 2] : '';
                const stateVariable = state;
                const addressComponentsC = invoiceHeader?.customer_address.split(';;');
                const formattedAddressC = invoiceHeader?.billing_address ? formatAddressWithCapitalization(invoiceHeader?.billing_address) : ''
                const stateC = addressComponentsC.length > 1 ? addressComponentsC[addressComponentsC.length - 3] : '';
                const stateVariableC = stateC;
                if (invoiceMaster?.show_computation_details === 1) {
                    setShowComputationDetails(true)
                    setMiscShowComputations(true)
                } else {
                    setShowComputationDetails(false)
                    setMiscShowComputations(false)
                }
                if (invoiceMaster?.show_billing_period === 1) {
                    setShowBillingPeriod(true)
                    setMiscShowBilling(true)
                } else {
                    setShowBillingPeriod(false)
                    setMiscShowBilling(false)
                }
                if (invoiceFooter?.show_pterms === 1) {
                    setShowPaymentDetails(true)
                }
                if (invoiceFooter?.show_tandc === 1) {
                    setShowTermsDetails(true)
                }
                setSelectedFacilityId(invoiceMaster?.facility_id)
                setMiscContractName(invoiceMaster?.contract_name)
                setInvoiceType(invoiceMaster?.service_name_in_note)
                typeOfInvoice = invoiceMaster?.service_name_in_note;
                setMiscListOfContacts(invoiceData?.invoice_contacts)

                setServiceNameInInvoice(invoiceMaster?.service_name_in_invoice)
                setDownloadPath(invoiceMaster?.pdf_path_on_s3)
                setCompanyName(invoiceMaster.company_name)
                setFacilityName(invoiceMaster?.facility_name)
                setInvoiceId(invoiceMaster?.invoice_id)
                setNoteNumber(invoiceMaster?.note_number)
                setNoteId(invoiceMaster?.note_id)
                setSlfInvoiceName(invoiceDetails?.service_name_in_invoice)
                setInvoiceDetails([...tableData])
                setCompanyCIN(invoiceHeader?.partner_cin)
                setCompanyName(invoiceHeader?.partner_name?.toUpperCase())
                setQrCode(invoiceHeader?.qr_code)
                setcustomerCIN(invoiceHeader?.customer_cin)
                setCompanyGST(invoiceHeader?.partner_gstin)
                setCompanyPhone(invoiceHeader?.partner_phone)
                setCompanyAddress(invoiceHeader?.partner_address)
                // setCompanyLogo(invoiceHeader?.partner_logo)
                setcustomerName(invoiceHeader?.customer_name)
                setContractNo(invoiceMaster?.contract_number)
                setcustomerGSTIN(invoiceHeader?.customer_gstin)
                setcustomerPAN(invoiceHeader?.customer_pan)
                setIRN(invoiceHeader?.irn_number)
                setAckNo(invoiceHeader?.gst_portal_ack_no)
                setAckDate(formatDateBasedOnValue(formatDateView(invoiceHeader?.gst_portal_ack_date)))
                setCompanyAddress(formattedAddress);
                setcustomerAddress(formattedAddressC)
                setcustomerPlaceOfSupply(invoiceMaster?.pos_state)
                setPartnerBillDate(formatDateBasedOnValue(formatDateView(invoiceHeader?.issue_date)))
                setPartnerDueDate(formatDateBasedOnValue(formatDateView(invoiceMaster?.payment_due_date)))
                setPartnerState(stateVariable)
                setPartnerPAN(invoiceHeader?.partner_pan)
                setPartnerCIN(invoiceHeader?.partner_cin)
                setInvoiceNo(invoiceHeader?.invoice_number)
                setPartnerStateCode(invoiceHeader?.partner_gstin.substring(0, 2))
                setcustomerStateCode(invoiceHeader?.customer_gstin.substring(0, 2))
                setBasicAmount(invoiceMaster?.total_basic_amount)
                setTotalAmount(invoiceMaster.gross_amount)
                setTotalAmountInWords(invoiceMaster?.amount_in_words);
                setTimeout(() => {
                    setIsLoading(false)
                })
                setToggleShippingAddress(true)
                let companyAddress = invoiceHeader?.partner_address?.replace(/;;/g, ', ');
                let customerAddress = invoiceHeader?.customer_address?.replace(/;;/g, ', ');
                let billingAddress = invoiceHeader?.billing_address?.replace(/;;/g, ', ');
                let shippingAddress = invoiceHeader?.shipping_address?.replace(/;;/g, ', ');
                setCompanyAddress(companyAddress)
                setcustomerAddress(billingAddress)
                setShippingAddress(shippingAddress)
                const invoiceTable = [...tableData]
                let totalTaxAmount = 0;

                if (isIgstToggle) {
                    totalTaxAmount = invoiceTable.reduce((acc, each) =>
                        acc + (parseFloat(each.basicAmount) * parseFloat(each.igst_rate) / 100),
                        0);
                } else {
                    totalTaxAmount = invoiceTable.reduce((acc, each) =>
                        acc + (parseFloat(each.basicAmount) * (parseFloat(each.cgst_rate) + parseFloat(each.sgst_rate)) / 100),
                        0);
                }

                setMiscTotalTaxAmount(totalTaxAmount);

                const basicAmount = invoiceMaster?.total_basic_amount
                setMiscTotalBasicAmount(basicAmount)
                if (typeOfInvoice === "electricity") {
                    setCurrentPage(2)
                } else if (typeOfInvoice === "water") {
                    setCurrentPage(4)
                } else if (typeOfInvoice === "slf") {
                    setCurrentPage(5)
                } else if (typeOfInvoice === "fms") {
                    setCurrentPage(6)
                } else if (typeOfInvoice === "miscellaneous") {
                    setCurrentPage(7)
                } else {
                    setCurrentPage(8)
                }
                axios.get(`${base_url}invoices/get_invoice?invoice_number=${invoiceHeader?.invoice_number}`)
                    .then(res => {
                        const invoiceData = res.data.data
                        const invoiceContactDetails = invoiceData.invoice_contacts
                        setInvoiceContactDetails(invoiceContactDetails)
                    })
                    .catch(err => {
                        setAlertShow(true)
                        setAlertType('error')
                        setAlertMessage('Error')
                        setAlertValue(err?.response?.data.message)
                        setAlertButtons([{
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        }])
                    })
            })
            .catch(error => {
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_GST_SUBMIT_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_FAILURE,
                            payload: null
                        })
                    }
                }])
                setIsLoading(false)
            })
    }

    const handleViewButton = (id, status, type) => {
        setIsLoading(true)
        setInvoiceStatus(status)
        if (!editInvoiceClicked) {
            setEditInvoiceClicked(true)
        }
        let typeOfInvoice = ''
        const url = `${base_url}invoices/get_invoice?invoice_number=${id}`
        axios.get(url)
            .then(response => {
                const invoiceData = response.data.data
                const invoiceMaster = invoiceData.invoice_master
                const invoiceDetails = invoiceData.invoice_details
                const invoiceFooter = invoiceData.invoice_footer
                const invoiceHeader = invoiceData?.invoice_header
                setInvoicePaymentDetails(invoiceData?.payment_details)

                if (invoiceFooter.payment_terms || invoiceFooter.terms_and_conditions) {
                    getDocuments1(invoiceFooter)
                }
                if (invoiceHeader?.partner_logo) {
                    getImage(invoiceHeader?.partner_logo)
                } else {
                    setCompanyLogo(null)
                }

                let isIgst
                invoiceDetails.some(e => e.igst > 0 ? isIgst = true : isIgst = false)
                const isIgstToggle = isIgst
                if (isIgst) {
                    setIgstToggle(true)
                    // const totalTaxAmount = invoiceDetails.reduce((acc, each) => acc + parseFloat(each.igst), 0)
                    // setTotalTaxAmount(invoiceMaster?.total_tax_amount)
                    setTotalIgst(invoiceMaster?.total_igst)
                } else {
                    // const totalTaxAmount = invoiceDetails.reduce((acc, each) => acc + parseFloat(each.cgst) + parseFloat(each.sgst), 0)
                    setTotalSgst(invoiceMaster?.total_sgst)
                    setTotalCgst(invoiceMaster?.total_cgst)
                }
                // handling basic amount 
                const tableData = invoiceDetails.map(({ net_amount, ...rest }) => ({
                    ...rest,
                    basicAmount: net_amount,
                    sgst_rate: parseInt(rest.sgst_rate),
                    cgst_rate: parseInt(rest.cgst_rate),
                    igst_rate: parseInt(rest.igst_rate),
                }));

                const detailsBasicAmount = invoiceDetails.reduce((acc, each) => acc + parseFloat(each.net_amount), 0)
                const totalAmountInWords = convertCurrencyToWords(invoiceMaster.gross_amount)
                const addressComponents = invoiceHeader?.partner_address.split(';;');
                const formattedAddress = formatAddressWithCapitalization(invoiceHeader?.partner_address)
                const state = addressComponents.length > 1 ? addressComponents[addressComponents.length - 2] : '';
                const stateVariable = state;
                const addressComponentsC = invoiceHeader?.customer_address.split(';;');
                const formattedAddressC = invoiceHeader?.billing_address ? formatAddressWithCapitalization(invoiceHeader?.billing_address) : ''
                const stateC = addressComponentsC.length > 1 ? addressComponentsC[addressComponentsC.length - 3] : '';
                const stateVariableC = stateC;
                if (invoiceMaster?.show_computation_details === 1) {
                    setShowComputationDetails(true)
                    setMiscShowComputations(true)
                } else {
                    setShowComputationDetails(false)
                    setMiscShowComputations(false)
                }
                if (invoiceMaster?.show_billing_period === 1) {
                    setShowBillingPeriod(true)
                    setMiscShowBilling(true)
                } else {
                    setShowBillingPeriod(false)
                    setMiscShowBilling(false)
                }
                if (invoiceFooter?.show_pterms === 1) {
                    setShowPaymentDetails(true)
                }
                if (invoiceFooter?.show_tandc === 1) {
                    setShowTermsDetails(true)
                }
                setSelectedFacilityId(invoiceMaster?.facility_id)
                setMiscContractName(invoiceMaster?.contract_name)
                setInvoiceType(invoiceMaster?.invoice_type)
                typeOfInvoice = invoiceMaster?.invoice_type;
                setMiscListOfContacts(invoiceData?.invoice_contacts)

                setServiceNameInInvoice(invoiceMaster?.service_name_in_invoice)
                setDownloadPath(invoiceMaster?.pdf_path_on_s3)
                setCompanyName(invoiceMaster.company_name)
                setFacilityName(invoiceMaster?.facility_name)
                setInvoiceId(invoiceMaster?.invoice_id)
                setSlfInvoiceName(invoiceDetails?.service_name_in_invoice)
                setInvoiceDetails([...tableData])
                setCompanyCIN(invoiceHeader?.partner_cin)
                setCompanyName(invoiceHeader?.partner_name?.toUpperCase())
                setQrCode(invoiceHeader?.qr_code)
                setcustomerCIN(invoiceHeader?.customer_cin)
                setCompanyGST(invoiceHeader?.partner_gstin)
                setCompanyPhone(invoiceHeader?.partner_phone)
                setCompanyAddress(invoiceHeader?.partner_address)
                // setCompanyLogo(invoiceHeader?.partner_logo)
                setcustomerName(invoiceHeader?.customer_name)
                setContractNo(invoiceMaster?.contract_number)
                setcustomerGSTIN(invoiceHeader?.customer_gstin)
                setcustomerPAN(invoiceHeader?.customer_pan)
                setIRN(invoiceHeader?.irn_number)
                setAckNo(invoiceHeader?.gst_portal_ack_no)
                setAckDate(formatDateBasedOnValue(formatDateView(invoiceHeader?.gst_portal_ack_date)))
                setCompanyAddress(formattedAddress);
                setcustomerAddress(formattedAddressC)
                setcustomerPlaceOfSupply(invoiceMaster?.pos_state)
                setPartnerBillDate(formatDateBasedOnValue(formatDateView(invoiceHeader?.issue_date)))
                setPartnerDueDate(formatDateBasedOnValue(formatDateView(invoiceMaster?.payment_due_date)))
                setPartnerState(stateVariable)
                setPartnerPAN(invoiceHeader?.partner_pan)
                setPartnerCIN(invoiceHeader?.partner_cin)
                setInvoiceNo(invoiceHeader?.invoice_number)
                setPartnerStateCode(invoiceHeader?.partner_gstin.substring(0, 2))
                setcustomerStateCode(invoiceHeader?.customer_gstin.substring(0, 2))
                setBasicAmount(invoiceMaster?.total_basic_amount)
                setTotalAmount(invoiceMaster.gross_amount)
                setTotalAmountInWords(invoiceMaster?.amount_in_words);
                setTimeout(() => {
                    setIsLoading(false)
                })
                setToggleShippingAddress(true)
                let companyAddress = invoiceHeader?.partner_address?.replace(/;;/g, ', ');
                let customerAddress = invoiceHeader?.customer_address?.replace(/;;/g, ', ');
                let billingAddress = invoiceHeader?.billing_address?.replace(/;;/g, ', ');
                let shippingAddress = invoiceHeader?.shipping_address?.replace(/;;/g, ', ');
                setCompanyAddress(companyAddress)
                setcustomerAddress(billingAddress)
                setShippingAddress(shippingAddress)
                const invoiceTable = [...tableData]
                let totalTaxAmount = 0;

                if (isIgstToggle) {
                    totalTaxAmount = invoiceTable.reduce((acc, each) =>
                        acc + (parseFloat(each.basicAmount) * parseFloat(each.igst_rate) / 100),
                        0);
                } else {
                    totalTaxAmount = invoiceTable.reduce((acc, each) =>
                        acc + (parseFloat(each.basicAmount) * (parseFloat(each.cgst_rate) + parseFloat(each.sgst_rate)) / 100),
                        0);
                }

                setMiscTotalTaxAmount(totalTaxAmount);

                const basicAmount = invoiceMaster?.total_basic_amount
                setMiscTotalBasicAmount(basicAmount)
                if (typeOfInvoice === "electricity") {
                    setCurrentPage(2)
                } else if (typeOfInvoice === "water") {
                    setCurrentPage(4)
                } else if (typeOfInvoice === "slf") {
                    setCurrentPage(5)
                } else if (typeOfInvoice === "fms") {
                    setCurrentPage(6)
                } else if (typeOfInvoice === "miscellaneous") {
                    setCurrentPage(7)
                } else {
                    setCurrentPage(8)
                }
            })
            .catch(error => {
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_GST_SUBMIT_SUCCESS,
                            payload: null
                        })
                        dispatch({
                            type: PUT_ADD_MISC_INVOICE_FAILURE,
                            payload: null
                        })
                    }
                }])
                setIsLoading(false)
            })
    }

    const handleInvoiceItemChange = (id, field, value) => {
        setInvoiceDetails(prev => {
            const updated = prev.map(item =>
                item.id === id ? { ...item, [field]: value } : item
            );

            // Recalculate totals immediately after state change
            calculateTotalBasicAmount(updated);
            calculateTotalTaxAmount(updated);

            return updated;
        });
    };

    const calculateTotalBasicAmount = (table) => {
        const invoiceTable = table ? table : invoiceDetails
        const totalBasicAmount = parseFloat(invoiceTable.reduce((acc, each) => acc + parseFloat(each.basicAmount), 0).toFixed(2))
        setMiscTotalBasicAmount(totalBasicAmount);
    };

    const calculateTotalTaxAmount = (table) => {
        const invoiceTable = table ? table : invoiceDetails
        let totalTaxAmount = 0
        if (igstToggle) {
            totalTaxAmount = parseFloat(invoiceTable.reduce((acc, each) => {
                const rowIgst = parseFloat((parseFloat(each.basicAmount) / 100 * parseFloat(each.igst_rate)).toFixed(2))
                return acc + rowIgst
            }, 0).toFixed(2))
        }
        else {
            totalTaxAmount = parseFloat(invoiceTable.reduce((acc, each) => {
                const rowCgst = parseFloat((parseFloat(each.basicAmount) / 100 * parseFloat(each.cgst_rate)).toFixed(2))
                const rowSgst = parseFloat((parseFloat(each.basicAmount) / 100 * parseFloat(each.sgst_rate)).toFixed(2))
                return acc + rowCgst + rowSgst
            }, 0).toFixed(2))
        }
        setMiscTotalTaxAmount(totalTaxAmount)
    };

    const reusableInvoiceTable = () => {
        return (
            <>
                {/* electric invoice */}
                {currentPage === 2 &&
                    <Table className="invoice-preview-table">
                        <thead >
                            <tr >
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                <th colSpan={2}><b>Bill Period / Reading</b></th>
                                {showComputationDetails && <th colSpan={1}><b>Total Units</b></th>}
                                {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                                {/* <th colSpan={1}><b>Meter Rent</b></th> */}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>Gross</b></th>
                            </tr>
                            <tr>
                                <th>From / Op. Reading</th>
                                <th>To / Cl. Reading</th>

                                {showComputationDetails && <th>kWh</th>}
                                {showComputationDetails && <th>
                                    ({formatCurrencyBasedOnRegion()} / kWh)</th>}
                                {/* <th>Amount (INR)</th> */}
                                <th>Amount ({formatCurrencyBasedOnRegion()})</th>
                                {!igstToggle && <th>Rate (%)</th>}
                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate (%)</th>}
                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate (%)</th>}
                                {igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount ({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceDetails?.map((item, index) => (
                                <tr key={index}>
                                    {/* Service Name & Identifier */}
                                    <th className="text-start">
                                        {item?.service_name_in_note ? item?.service_name_in_note?.toUpperCase() : item?.service_name_in_invoice?.toUpperCase()},<br />
                                        {item?.service_identifier}
                                    </th>

                                    {/* HSN */}
                                    <th className="text-start"><input
                                        type="text"
                                        value={item.hsn || ''}
                                        onChange={e =>
                                            handleInvoiceItemChange(item.id, 'hsn', e.target.value)
                                        }
                                        style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                    /></th>

                                    {/* From Date & Initial Reading */}
                                    <th style={{ textAlign: 'end' }}>
                                        <div>
                                            <input
                                                type="date"
                                                value={item.from_date || ''}
                                                onChange={e =>
                                                    handleInvoiceItemChange(item.id, 'from_date', e.target.value)
                                                }
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                            <hr />
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                value={item.initial_reading || ''}
                                                onChange={e => {
                                                    handleInvoiceItemChange(item.id, 'initial_reading', e.target.value);
                                                    calculateTotalBasicAmount(invoiceDetails);
                                                    calculateTotalTaxAmount(invoiceDetails);
                                                }}
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                        </div>
                                    </th>

                                    {/* To Date & Final Reading */}
                                    <th style={{ textAlign: 'end' }}>
                                        <div>
                                            <input
                                                type="date"
                                                value={item.to_date || ''}
                                                onChange={e =>
                                                    handleInvoiceItemChange(item.id, 'to_date', e.target.value)
                                                }
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                            <hr />
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                value={item.final_reading || ''}
                                                onChange={e => {
                                                    handleInvoiceItemChange(item.id, 'final_reading', e.target.value);
                                                    calculateTotalBasicAmount(invoiceDetails);
                                                    calculateTotalTaxAmount(invoiceDetails);
                                                }}
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                        </div>
                                    </th>

                                    {/* Conditional Computation Columns */}
                                    {showComputationDetails && (
                                        <th style={{ textAlign: 'end' }}>
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                value={item.consumption || ''}
                                                onChange={e => {
                                                    // handleInvoiceItemChange(item.id, 'consumption', e.target.value);
                                                    // calculateTotalBasicAmount(invoiceDetails);
                                                    // calculateTotalTaxAmount(invoiceDetails);
                                                    let temp = [...invoiceDetails];
                                                    const input = e.target.value;
                                                    const formattedInput = input.replace(/[^0-9.]/g, '');
                                                    const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                    const trimmedInput = validInput.trim();


                                                    // Check if the input has more than 2 decimal places
                                                    const decimalIndex = trimmedInput.indexOf('.');
                                                    if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                        return; // Ignore the input if it has more than 2 decimal places
                                                    }

                                                    // Check if the input is a positive number
                                                    if (parseFloat(trimmedInput) < 0) {
                                                        return; // Ignore the input if it is negative
                                                    }

                                                    temp[index].consumption = trimmedInput;
                                                    if (trimmedInput.length === 0) {
                                                        temp[index].consumption = 0.0
                                                    }
                                                    if (temp[index].rate_per_unit.length > 0) {
                                                        temp[index].basicAmount = (parseFloat(trimmedInput) * parseFloat(temp[index].rate_per_unit)).toFixed(2)
                                                    }
                                                    temp[index].consumption = trimmedInput;
                                                    setInvoiceDetails(temp);
                                                    calculateTotalBasicAmount();
                                                    calculateTotalTaxAmount();
                                                }}
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                        </th>
                                    )}

                                    {showComputationDetails && (
                                        <th style={{ textAlign: 'end' }}>
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                value={item.rate_per_unit || ''}
                                                onChange={e => {
                                                    let temp = [...invoiceDetails];
                                                    const input = e.target.value;
                                                    const formattedInput = input.replace(/[^0-9.]/g, '');
                                                    const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                    const trimmedInput = validInput.trim();


                                                    // Check if the input has more than 2 decimal places
                                                    const decimalIndex = trimmedInput.indexOf('.');
                                                    if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                        return; // Ignore the input if it has more than 2 decimal places
                                                    }

                                                    // Check if the input is a positive number
                                                    if (parseFloat(trimmedInput) < 0) {
                                                        return; // Ignore the input if it is negative
                                                    }

                                                    temp[index].rate_per_unit = trimmedInput;
                                                    if (trimmedInput.length === 0) {
                                                        temp[index].rate_per_unit = 0.0
                                                    }
                                                    if (temp[index].consumption.length > 0) {
                                                        temp[index].basicAmount = (parseFloat(temp[index].consumption) * parseFloat(trimmedInput)).toFixed(2)
                                                    }
                                                    temp[index].rate_per_unit = trimmedInput;
                                                    setInvoiceDetails(temp);
                                                    calculateTotalBasicAmount();
                                                    calculateTotalTaxAmount();
                                                }}
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                        </th>
                                    )}

                                    {/* Net Amount */}
                                    <th style={{ textAlign: 'end' }}>
                                        <input
                                            type="text"
                                            inputMode="decimal"
                                            value={item.basicAmount || ''}
                                            onChange={e => {
                                                let temp = [...invoiceDetails];
                                                const input = e.target.value;
                                                const formattedInput = input.replace(/[^0-9.]/g, '');
                                                const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                const trimmedInput = validInput.trim();


                                                // Check if the input has more than 2 decimal places
                                                const decimalIndex = trimmedInput.indexOf('.');
                                                if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                    return; // Ignore the input if it has more than 2 decimal places
                                                }

                                                // Check if the input is a positive number
                                                if (parseFloat(trimmedInput) < 0) {
                                                    return; // Ignore the input if it is negative
                                                }

                                                temp[index].basicAmount = trimmedInput;
                                                if (trimmedInput.length === 0) {
                                                    temp[index].basicAmount = 0.0
                                                }
                                                setInvoiceDetails(temp);
                                                calculateTotalBasicAmount();
                                                calculateTotalTaxAmount();
                                            }}
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        />
                                    </th>

                                    {/* sgst rate*/}
                                    {!igstToggle && <th>
                                        <select value={item.sgst} onChange={(e) => {
                                            let temp = [...invoiceDetails]
                                            temp[index].sgst = e.target.value
                                            temp[index].cgst = e.target.value
                                            setInvoiceDetails(temp)
                                            calculateTotalTaxAmount()
                                        }}>
                                            {miscCgstSgstOptions.map((option, index) => {
                                                return (
                                                    <option key={index} value={option}>{option}</option>
                                                )
                                            })}
                                        </select>
                                    </th>}
                                    {/* sgst amount*/}
                                    {!igstToggle && (
                                        <th className="text-end">
                                            {formatToIndianRupee(((item.basicAmount / 100) * item.sgst).toFixed(2))}
                                        </th>
                                    )}
                                    {/* cgst rate*/}
                                    {!igstToggle && <th>
                                        <select value={item.cgst} onChange={(e) => {
                                            let temp = [...invoiceDetails]
                                            temp[index].sgst = e.target.value
                                            temp[index].cgst = e.target.value
                                            setInvoiceDetails(temp)
                                            calculateTotalTaxAmount()
                                        }}>
                                            {miscCgstSgstOptions.map((option, index) => {
                                                return (
                                                    <option key={index} value={option}>{option}</option>
                                                )
                                            })}
                                        </select>
                                    </th>}
                                    {/* cgst amount*/}
                                    {!igstToggle && (
                                        <th className="text-end">
                                            {formatToIndianRupee(((item.basicAmount / 100) * item.cgst).toFixed(2))}
                                        </th>
                                    )}
                                    {/* igst rate*/}
                                    {igstToggle && <th>
                                        <select value={item.igst_rate} onChange={(e) => {
                                            let temp = [...invoiceDetails]
                                            temp[index].igst_rate = e.target.value
                                            setInvoiceDetails(temp)
                                            calculateTotalTaxAmount()
                                        }}>
                                            {miscIgstOptions.map((option, index) => {
                                                return (
                                                    <option key={index} value={option}>{option}</option>
                                                )
                                            })}
                                        </select>
                                    </th>}
                                    {/* igst amount*/}
                                    {igstToggle && (
                                        <th className="text-end">
                                            {formatToIndianRupee(((item.basicAmount / 100) * item.igst_rate).toFixed(2))}
                                        </th>
                                    )}

                                    {/* Gross Amount */}
                                    <th style={{ textAlign: 'end' }}>
                                        {igstToggle
                                            ? formatToIndianRupee(
                                                (parseFloat(item.basicAmount) + parseFloat((item.basicAmount / 100) * item.igst_rate)).toFixed(2)
                                            )
                                            : formatToIndianRupee(
                                                (parseFloat(item.basicAmount) +
                                                    parseFloat((item.basicAmount / 100) * item.cgst) +
                                                    parseFloat((item.basicAmount / 100) * item.sgst)).toFixed(2)
                                            )}
                                    </th>
                                </tr>
                            ))}

                            {/* Grand Total Row */}
                            <tr>
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>

                                {/* Empty Columns for Layout Alignment */}
                                <th colSpan={5}></th>

                                {/* Basic Amount */}
                                <th className="text-end">{formatToIndianRupee(parseFloat(miscTotalBasicAmount).toFixed(2))}</th>

                                {/* SGST/CGST */}
                                {!igstToggle ? (
                                    <>
                                        <th></th>
                                        <th className="text-end"> {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                        <th></th>
                                        <th className="text-end"> {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                    </>
                                ) : (
                                    <>
                                        <th></th>
                                        <th className="text-end">{formatToIndianRupee(miscTotalTaxAmount.toFixed(2))}</th>
                                    </>
                                )}

                                {/* Gross Total */}
                                <th className="text-end">{formatToIndianRupee((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))}</th>
                            </tr>
                        </tbody>
                    </Table>
                }
                {/* FMS invoice */}
                {currentPage === 6 &&
                    <Table className="invoice-preview-table">
                        <thead>
                            <tr>
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                <th colSpan={2}><b>Bill Period </b></th>
                                {showComputationDetails && <th colSpan={1}><b>Total Area</b></th>}
                                {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>GROSS</b></th>
                            </tr>
                            <tr>

                                <th>From</th>
                                <th>To</th>
                                {showComputationDetails && <th>Sq. ft</th>}
                                {showComputationDetails && <th> ({formatCurrencyBasedOnRegion()} / Sq. ft)</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                                {!igstToggle && <th>Rate <br /> (%)</th>}
                                {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate <br />(%)</th>}
                                {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate <br />(%)</th>}
                                {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceDetails?.map((item, index) => (
                                <tr key={index}>
                                    {/* Service Name & Identifier */}
                                    <th className="text-start">
                                        {item?.service_name_in_note ? item?.service_name_in_note?.toUpperCase() : item?.service_name_in_invoice?.toUpperCase()},<br />
                                        {item?.service_identifier}
                                    </th>

                                    {/* HSN */}
                                    <th className="text-start"><input
                                        type="text"
                                        value={item.hsn || ''}
                                        onChange={e =>
                                            handleInvoiceItemChange(item.id, 'hsn', e.target.value)
                                        }
                                        style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                    /></th>

                                    {/* From Date */}
                                    <th style={{ textAlign: 'end', textWrap: 'nowrap' }}>
                                        <input
                                            type="date"
                                            value={item.from_date || ''}
                                            onChange={e =>
                                                handleInvoiceItemChange(item.id, 'from_date', e.target.value)
                                            }
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        />
                                    </th>

                                    {/* To Date */}
                                    <th style={{ textAlign: 'end', textWrap: 'nowrap' }}>
                                        <input
                                            type="date"
                                            value={item.to_date || ''}
                                            onChange={e =>
                                                handleInvoiceItemChange(item.id, 'to_date', e.target.value)
                                            }
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        />
                                    </th>

                                    {/* Computation Details */}
                                    {showComputationDetails && (
                                        <th style={{ textAlign: 'end' }}> <input
                                            type="text"
                                            inputMode="decimal"
                                            value={item.consumption || ''}
                                            onChange={e => {
                                                // handleInvoiceItemChange(item.id, 'consumption', e.target.value);
                                                // calculateTotalBasicAmount(invoiceDetails);
                                                // calculateTotalTaxAmount(invoiceDetails);
                                                let temp = [...invoiceDetails];
                                                const input = e.target.value;
                                                const formattedInput = input.replace(/[^0-9.]/g, '');
                                                const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                const trimmedInput = validInput.trim();


                                                // Check if the input has more than 2 decimal places
                                                const decimalIndex = trimmedInput.indexOf('.');
                                                if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                    return; // Ignore the input if it has more than 2 decimal places
                                                }

                                                // Check if the input is a positive number
                                                if (parseFloat(trimmedInput) < 0) {
                                                    return; // Ignore the input if it is negative
                                                }

                                                temp[index].consumption = trimmedInput;
                                                if (trimmedInput.length === 0) {
                                                    temp[index].consumption = 0.0
                                                }
                                                if (temp[index].rate_per_unit.length > 0) {
                                                    temp[index].basicAmount = (parseFloat(trimmedInput) * parseFloat(temp[index].rate_per_unit)).toFixed(2)
                                                }
                                                temp[index].consumption = trimmedInput;
                                                setInvoiceDetails(temp);
                                                calculateTotalBasicAmount();
                                                calculateTotalTaxAmount();
                                            }}
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        /></th>
                                    )}

                                    {showComputationDetails && (
                                        <th style={{ textAlign: 'end' }}>
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                value={item.rate_per_unit || ''}
                                                onChange={e => {
                                                    let temp = [...invoiceDetails];
                                                    const input = e.target.value;
                                                    const formattedInput = input.replace(/[^0-9.]/g, '');
                                                    const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                    const trimmedInput = validInput.trim();


                                                    // Check if the input has more than 2 decimal places
                                                    const decimalIndex = trimmedInput.indexOf('.');
                                                    if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                        return; // Ignore the input if it has more than 2 decimal places
                                                    }

                                                    // Check if the input is a positive number
                                                    if (parseFloat(trimmedInput) < 0) {
                                                        return; // Ignore the input if it is negative
                                                    }

                                                    temp[index].rate_per_unit = trimmedInput;
                                                    if (trimmedInput.length === 0) {
                                                        temp[index].rate_per_unit = 0.0
                                                    }
                                                    if (temp[index].consumption.length > 0) {
                                                        temp[index].basicAmount = (parseFloat(temp[index].consumption) * parseFloat(trimmedInput)).toFixed(2)
                                                    }
                                                    temp[index].rate_per_unit = trimmedInput;
                                                    setInvoiceDetails(temp);
                                                    calculateTotalBasicAmount();
                                                    calculateTotalTaxAmount();
                                                }}
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                        </th>
                                    )}

                                    {/* Basic Amount */}
                                    <th style={{ textAlign: 'end' }}><input
                                        type="text"
                                        inputMode="decimal"
                                        value={item.basicAmount || ''}
                                        onChange={e => {
                                            let temp = [...invoiceDetails];
                                            const input = e.target.value;
                                            const formattedInput = input.replace(/[^0-9.]/g, '');
                                            const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                            const trimmedInput = validInput.trim();


                                            // Check if the input has more than 2 decimal places
                                            const decimalIndex = trimmedInput.indexOf('.');
                                            if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                return; // Ignore the input if it has more than 2 decimal places
                                            }

                                            // Check if the input is a positive number
                                            if (parseFloat(trimmedInput) < 0) {
                                                return; // Ignore the input if it is negative
                                            }

                                            temp[index].basicAmount = trimmedInput;
                                            if (trimmedInput.length === 0) {
                                                temp[index].basicAmount = 0.0
                                            }
                                            setInvoiceDetails(temp);
                                            calculateTotalBasicAmount();
                                            calculateTotalTaxAmount();
                                        }}
                                        style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                    /></th>

                                    {/* sgst rate*/}
                                    {!igstToggle && <th>
                                        <select value={item.sgst} onChange={(e) => {
                                            let temp = [...invoiceDetails]
                                            temp[index].sgst = e.target.value
                                            temp[index].cgst = e.target.value
                                            setInvoiceDetails(temp)
                                            calculateTotalTaxAmount()
                                        }}>
                                            {miscCgstSgstOptions.map((option, index) => {
                                                return (
                                                    <option key={index} value={option}>{option}</option>
                                                )
                                            })}
                                        </select>
                                    </th>}
                                    {/* sgst amount*/}
                                    {!igstToggle && (
                                        <th className="text-end">
                                            {formatToIndianRupee(((item.basicAmount / 100) * item.sgst).toFixed(2))}
                                        </th>
                                    )}
                                    {/* cgst rate*/}
                                    {!igstToggle && <th>
                                        <select value={item.cgst} onChange={(e) => {
                                            let temp = [...invoiceDetails]
                                            temp[index].sgst = e.target.value
                                            temp[index].cgst = e.target.value
                                            setInvoiceDetails(temp)
                                            calculateTotalTaxAmount()
                                        }}>
                                            {miscCgstSgstOptions.map((option, index) => {
                                                return (
                                                    <option key={index} value={option}>{option}</option>
                                                )
                                            })}
                                        </select>
                                    </th>}
                                    {/* cgst amount*/}
                                    {!igstToggle && (
                                        <th className="text-end">
                                            {formatToIndianRupee(((item.basicAmount / 100) * item.cgst).toFixed(2))}
                                        </th>
                                    )}
                                    {/* igst rate*/}
                                    {igstToggle && <th>
                                        <select value={item.igst_rate} onChange={(e) => {
                                            let temp = [...invoiceDetails]
                                            temp[index].igst_rate = e.target.value
                                            setInvoiceDetails(temp)
                                            calculateTotalTaxAmount()
                                        }}>
                                            {miscIgstOptions.map((option, index) => {
                                                return (
                                                    <option key={index} value={option}>{option}</option>
                                                )
                                            })}
                                        </select>
                                    </th>}
                                    {/* igst amount*/}
                                    {igstToggle && (
                                        <th className="text-end">
                                            {formatToIndianRupee(((item.basicAmount / 100) * item.igst_rate).toFixed(2))}
                                        </th>
                                    )}

                                    {/* Gross Amount */}
                                    <th style={{ textAlign: 'end' }}>
                                        {igstToggle
                                            ? formatToIndianRupee(
                                                (parseFloat(item.basicAmount) + parseFloat((item.basicAmount / 100) * item.igst_rate)).toFixed(2)
                                            )
                                            : formatToIndianRupee(
                                                (parseFloat(item.basicAmount) +
                                                    parseFloat((item.basicAmount / 100) * item.cgst) +
                                                    parseFloat((item.basicAmount / 100) * item.sgst)).toFixed(2)
                                            )}
                                    </th>
                                </tr>
                            ))}

                            {/* Grand Total Row */}
                            <tr>
                                {/* Description */}
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>

                                {/* Empty cells for layout alignment */}
                                <th colSpan={3}></th>

                                {showComputationDetails && (
                                    <>
                                        <th></th>
                                        <th></th>
                                    </>
                                )}

                                {/* Basic Amount */}
                                <th className="text-end">{formatToIndianRupee(parseFloat(miscTotalBasicAmount).toFixed(2))}</th>

                                {/* SGST/CGST */}
                                {!igstToggle ? (
                                    <>
                                        <th></th>
                                        <th className="text-end"> {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                        <th></th>
                                        <th className="text-end"> {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                    </>
                                ) : (
                                    <>
                                        <th></th>
                                        <th className="text-end">{formatToIndianRupee(miscTotalTaxAmount.toFixed(2))}</th>
                                    </>
                                )}


                                {/* Gross Total */}
                                <th className="text-end">{formatToIndianRupee((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))}</th>

                            </tr>
                        </tbody>

                    </Table>}
                {/* water invoice */}
                {currentPage === 4 &&
                    <Table className="invoice-preview-table">
                        <thead>
                            <tr>
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                <th colSpan={2}><b>Bill Period / Reading</b></th>
                                {showComputationDetails && <th colSpan={1}><b>Total Units</b></th>}
                                {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                                {/* <th colSpan={1}><b>Meter Rent</b></th> */}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>GROSS</b></th>
                            </tr>
                            <tr>
                                <th>From / Op. Reading</th>
                                <th>To / Cl. Reading</th>
                                {showComputationDetails && <th>kL</th>}
                                {showComputationDetails && <th>({formatCurrencyBasedOnRegion()} / kL)</th>}
                                <th>Amount ({formatCurrencyBasedOnRegion()})</th>
                                {/* <th>Amount (INR)</th> */}
                                {!igstToggle && <th>Rate (%)</th>}
                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate (%)</th>}
                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate (%)</th>}
                                {igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount ({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceDetails?.map((item, index) => (
                                <tr key={index}>
                                    {/* Service Name & Identifier */}
                                    <th className="text-start">
                                        {item?.service_name_in_note ? item?.service_name_in_note?.toUpperCase() : item?.service_name_in_invoice?.toUpperCase()},<br />
                                        {item?.service_identifier}
                                    </th>

                                    {/* HSN */}
                                    <th className="text-start"><input
                                        type="text"
                                        value={item.hsn || ''}
                                        onChange={e =>
                                            handleInvoiceItemChange(item.id, 'hsn', e.target.value)
                                        }
                                        style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                    /></th>

                                    {/* From Date & Initial Reading */}
                                    <th style={{ textAlign: 'end' }}>
                                        <div>
                                            <input
                                                type="date"
                                                value={item.from_date || ''}
                                                onChange={e =>
                                                    handleInvoiceItemChange(item.id, 'from_date', e.target.value)
                                                }
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                            <hr />
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                value={item.initial_reading || ''}
                                                onChange={e => {
                                                    handleInvoiceItemChange(item.id, 'initial_reading', e.target.value);
                                                    calculateTotalBasicAmount(invoiceDetails);
                                                    calculateTotalTaxAmount(invoiceDetails);
                                                }}
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                        </div>
                                    </th>

                                    {/* To Date & Final Reading */}
                                    <th style={{ textAlign: 'end' }}>
                                        <div>
                                            <input
                                                type="date"
                                                value={item.to_date || ''}
                                                onChange={e =>
                                                    handleInvoiceItemChange(item.id, 'to_date', e.target.value)
                                                }
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                            <hr />
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                value={item.final_reading || ''}
                                                onChange={e => {
                                                    handleInvoiceItemChange(item.id, 'final_reading', e.target.value);
                                                    calculateTotalBasicAmount(invoiceDetails);
                                                    calculateTotalTaxAmount(invoiceDetails);
                                                }}
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                        </div>
                                    </th>

                                    {/* Conditional Computation Columns */}
                                    {showComputationDetails && (
                                        <th style={{ textAlign: 'end' }}>
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                value={item.consumption || ''}
                                                onChange={e => {
                                                    // handleInvoiceItemChange(item.id, 'consumption', e.target.value);
                                                    // calculateTotalBasicAmount(invoiceDetails);
                                                    // calculateTotalTaxAmount(invoiceDetails);
                                                    let temp = [...invoiceDetails];
                                                    const input = e.target.value;
                                                    const formattedInput = input.replace(/[^0-9.]/g, '');
                                                    const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                    const trimmedInput = validInput.trim();


                                                    // Check if the input has more than 2 decimal places
                                                    const decimalIndex = trimmedInput.indexOf('.');
                                                    if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                        return; // Ignore the input if it has more than 2 decimal places
                                                    }

                                                    // Check if the input is a positive number
                                                    if (parseFloat(trimmedInput) < 0) {
                                                        return; // Ignore the input if it is negative
                                                    }

                                                    temp[index].consumption = trimmedInput;
                                                    if (trimmedInput.length === 0) {
                                                        temp[index].consumption = 0.0
                                                    }
                                                    if (temp[index].rate_per_unit.length > 0) {
                                                        temp[index].basicAmount = (parseFloat(trimmedInput) * parseFloat(temp[index].rate_per_unit)).toFixed(2)
                                                    }
                                                    temp[index].consumption = trimmedInput;
                                                    setInvoiceDetails(temp);
                                                    calculateTotalBasicAmount();
                                                    calculateTotalTaxAmount();
                                                }}
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                        </th>
                                    )}

                                    {showComputationDetails && (
                                        <th style={{ textAlign: 'end' }}>
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                value={item.rate_per_unit || ''}
                                                onChange={e => {
                                                    let temp = [...invoiceDetails];
                                                    const input = e.target.value;
                                                    const formattedInput = input.replace(/[^0-9.]/g, '');
                                                    const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                    const trimmedInput = validInput.trim();


                                                    // Check if the input has more than 2 decimal places
                                                    const decimalIndex = trimmedInput.indexOf('.');
                                                    if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                        return; // Ignore the input if it has more than 2 decimal places
                                                    }

                                                    // Check if the input is a positive number
                                                    if (parseFloat(trimmedInput) < 0) {
                                                        return; // Ignore the input if it is negative
                                                    }

                                                    temp[index].rate_per_unit = trimmedInput;
                                                    if (trimmedInput.length === 0) {
                                                        temp[index].rate_per_unit = 0.0
                                                    }
                                                    if (temp[index].consumption.length > 0) {
                                                        temp[index].basicAmount = (parseFloat(temp[index].consumption) * parseFloat(trimmedInput)).toFixed(2)
                                                    }
                                                    temp[index].rate_per_unit = trimmedInput;
                                                    setInvoiceDetails(temp);
                                                    calculateTotalBasicAmount();
                                                    calculateTotalTaxAmount();
                                                }}
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                        </th>
                                    )}

                                    {/* Net Amount */}
                                    <th style={{ textAlign: 'end' }}>
                                        <input
                                            type="text"
                                            inputMode="decimal"
                                            value={item.basicAmount || ''}
                                            onChange={e => {
                                                let temp = [...invoiceDetails];
                                                const input = e.target.value;
                                                const formattedInput = input.replace(/[^0-9.]/g, '');
                                                const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                const trimmedInput = validInput.trim();


                                                // Check if the input has more than 2 decimal places
                                                const decimalIndex = trimmedInput.indexOf('.');
                                                if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                    return; // Ignore the input if it has more than 2 decimal places
                                                }

                                                // Check if the input is a positive number
                                                if (parseFloat(trimmedInput) < 0) {
                                                    return; // Ignore the input if it is negative
                                                }

                                                temp[index].basicAmount = trimmedInput;
                                                if (trimmedInput.length === 0) {
                                                    temp[index].basicAmount = 0.0
                                                }
                                                setInvoiceDetails(temp);
                                                calculateTotalBasicAmount();
                                                calculateTotalTaxAmount();
                                            }}
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        />
                                    </th>

                                    {/* sgst rate*/}
                                    {!igstToggle && <th>
                                        <select value={item.sgst} onChange={(e) => {
                                            let temp = [...invoiceDetails]
                                            temp[index].sgst = e.target.value
                                            temp[index].cgst = e.target.value
                                            setInvoiceDetails(temp)
                                            calculateTotalTaxAmount()
                                        }}>
                                            {miscCgstSgstOptions.map((option, index) => {
                                                return (
                                                    <option key={index} value={option}>{option}</option>
                                                )
                                            })}
                                        </select>
                                    </th>}
                                    {/* sgst amount*/}
                                    {!igstToggle && (
                                        <th className="text-end">
                                            {formatToIndianRupee(((item.basicAmount / 100) * item.sgst).toFixed(2))}
                                        </th>
                                    )}
                                    {/* cgst rate*/}
                                    {!igstToggle && <th>
                                        <select value={item.cgst} onChange={(e) => {
                                            let temp = [...invoiceDetails]
                                            temp[index].sgst = e.target.value
                                            temp[index].cgst = e.target.value
                                            setInvoiceDetails(temp)
                                            calculateTotalTaxAmount()
                                        }}>
                                            {miscCgstSgstOptions.map((option, index) => {
                                                return (
                                                    <option key={index} value={option}>{option}</option>
                                                )
                                            })}
                                        </select>
                                    </th>}
                                    {/* cgst amount*/}
                                    {!igstToggle && (
                                        <th className="text-end">
                                            {formatToIndianRupee(((item.basicAmount / 100) * item.cgst).toFixed(2))}
                                        </th>
                                    )}
                                    {/* igst rate*/}
                                    {igstToggle && <th>
                                        <select value={item.igst_rate} onChange={(e) => {
                                            let temp = [...invoiceDetails]
                                            temp[index].igst_rate = e.target.value
                                            setInvoiceDetails(temp)
                                            calculateTotalTaxAmount()
                                        }}>
                                            {miscIgstOptions.map((option, index) => {
                                                return (
                                                    <option key={index} value={option}>{option}</option>
                                                )
                                            })}
                                        </select>
                                    </th>}
                                    {/* igst amount*/}
                                    {igstToggle && (
                                        <th className="text-end">
                                            {formatToIndianRupee(((item.basicAmount / 100) * item.igst_rate).toFixed(2))}
                                        </th>
                                    )}

                                    {/* Gross Amount */}
                                    <th style={{ textAlign: 'end' }}>
                                        {igstToggle
                                            ? formatToIndianRupee(
                                                (parseFloat(item.basicAmount) + parseFloat((item.basicAmount / 100) * item.igst_rate)).toFixed(2)
                                            )
                                            : formatToIndianRupee(
                                                (parseFloat(item.basicAmount) +
                                                    parseFloat((item.basicAmount / 100) * item.cgst) +
                                                    parseFloat((item.basicAmount / 100) * item.sgst)).toFixed(2)
                                            )}
                                    </th>
                                </tr>
                            ))}

                            {/* Grand Total Row */}
                            <tr>
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>

                                {/* Empty Columns for Layout Alignment */}
                                <th colSpan={5}></th>

                                {/* Basic Amount */}
                                <th className="text-end">{formatToIndianRupee(parseFloat(miscTotalBasicAmount).toFixed(2))}</th>

                                {/* SGST/CGST */}
                                {!igstToggle ? (
                                    <>
                                        <th></th>
                                        <th className="text-end"> {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                        <th></th>
                                        <th className="text-end"> {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                    </>
                                ) : (
                                    <>
                                        <th></th>
                                        <th className="text-end">{formatToIndianRupee(miscTotalTaxAmount.toFixed(2))}</th>
                                    </>
                                )}

                                {/* Gross Total */}
                                <th className="text-end">{formatToIndianRupee((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))}</th>
                            </tr>
                        </tbody>
                    </Table>}
                {/* mics invoice */}
                {currentPage === 7 &&
                    <Table className="invoice-preview-table">
                        <thead>
                            <tr>
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                {miscShowBilling && <th colSpan={2}><b>Bill Period</b></th>}
                                {miscShowComputations && <th colSpan={1} rowSpan={2}><b>Total Units</b></th>}
                                {miscShowComputations && <th colSpan={1} rowSpan={2}><b>Rate</b></th>}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>GROSS</b></th>
                            </tr>
                            <tr>
                                {miscShowBilling && <><th>From</th>
                                    <th>To</th>
                                </>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                                {!igstToggle && <th>Rate <br /> (%)</th>}
                                {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate <br />(%)</th>}
                                {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate <br />(%)</th>}
                                {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody >
                            {invoiceDetails?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <th className="text-start">
                                            {item?.service_name_in_note ? item?.service_name_in_note?.toUpperCase() : item?.service_name_in_invoice?.toUpperCase()},<br />
                                            {item?.service_identifier}
                                        </th>
                                        <th className="text-start"><input
                                            type="text"
                                            value={item.hsn || ''}
                                            onChange={e =>
                                                handleInvoiceItemChange(item.id, 'hsn', e.target.value)
                                            }
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        /></th>
                                        {miscShowBilling && <th> <input
                                            type="date"
                                            value={item.from_date || ''}
                                            onChange={e =>
                                                handleInvoiceItemChange(item.id, 'from_date', e.target.value)
                                            }
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        /></th>}
                                        {miscShowBilling && <th><input
                                            type="date"
                                            value={item.to_date || ''}
                                            onChange={e =>
                                                handleInvoiceItemChange(item.id, 'to_date', e.target.value)
                                            }
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        /></th>}
                                        {miscShowComputations && <th><input
                                            type="text"
                                            inputMode="decimal"
                                            value={item.consumption || ''}
                                            onChange={e => {
                                                // handleInvoiceItemChange(item.id, 'consumption', e.target.value);
                                                // calculateTotalBasicAmount(invoiceDetails);
                                                // calculateTotalTaxAmount(invoiceDetails);
                                                let temp = [...invoiceDetails];
                                                const input = e.target.value;
                                                const formattedInput = input.replace(/[^0-9.]/g, '');
                                                const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                const trimmedInput = validInput.trim();


                                                // Check if the input has more than 2 decimal places
                                                const decimalIndex = trimmedInput.indexOf('.');
                                                if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                    return; // Ignore the input if it has more than 2 decimal places
                                                }

                                                // Check if the input is a positive number
                                                if (parseFloat(trimmedInput) < 0) {
                                                    return; // Ignore the input if it is negative
                                                }

                                                temp[index].consumption = trimmedInput;
                                                if (trimmedInput.length === 0) {
                                                    temp[index].consumption = 0.0
                                                }
                                                if (temp[index].rate_per_unit.length > 0) {
                                                    temp[index].basicAmount = (parseFloat(trimmedInput) * parseFloat(temp[index].rate_per_unit)).toFixed(2)
                                                }
                                                temp[index].consumption = trimmedInput;
                                                setInvoiceDetails(temp);
                                                calculateTotalBasicAmount();
                                                calculateTotalTaxAmount();
                                            }}
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        /></th>}
                                        {miscShowComputations && <th><input
                                            type="text"
                                            inputMode="decimal"
                                            value={item.rate_per_unit || ''}
                                            onChange={e => {
                                                let temp = [...invoiceDetails];
                                                const input = e.target.value;
                                                const formattedInput = input.replace(/[^0-9.]/g, '');
                                                const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                const trimmedInput = validInput.trim();


                                                // Check if the input has more than 2 decimal places
                                                const decimalIndex = trimmedInput.indexOf('.');
                                                if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                    return; // Ignore the input if it has more than 2 decimal places
                                                }

                                                // Check if the input is a positive number
                                                if (parseFloat(trimmedInput) < 0) {
                                                    return; // Ignore the input if it is negative
                                                }

                                                temp[index].rate_per_unit = trimmedInput;
                                                if (trimmedInput.length === 0) {
                                                    temp[index].rate_per_unit = 0.0
                                                }
                                                if (temp[index].consumption.length > 0) {
                                                    temp[index].basicAmount = (parseFloat(temp[index].consumption) * parseFloat(trimmedInput)).toFixed(2)
                                                }
                                                temp[index].rate_per_unit = trimmedInput;
                                                setInvoiceDetails(temp);
                                                calculateTotalBasicAmount();
                                                calculateTotalTaxAmount();
                                            }}
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        /></th>}
                                        <th style={{ textAlign: 'end' }}><input
                                            type="text"
                                            inputMode="decimal"
                                            value={item.basicAmount || ''}
                                            onChange={e => {
                                                let temp = [...invoiceDetails];
                                                const input = e.target.value;
                                                const formattedInput = input.replace(/[^0-9.]/g, '');
                                                const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                const trimmedInput = validInput.trim();


                                                // Check if the input has more than 2 decimal places
                                                const decimalIndex = trimmedInput.indexOf('.');
                                                if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                    return; // Ignore the input if it has more than 2 decimal places
                                                }

                                                // Check if the input is a positive number
                                                if (parseFloat(trimmedInput) < 0) {
                                                    return; // Ignore the input if it is negative
                                                }

                                                temp[index].basicAmount = trimmedInput;
                                                if (trimmedInput.length === 0) {
                                                    temp[index].basicAmount = 0.0
                                                }
                                                setInvoiceDetails(temp);
                                                calculateTotalBasicAmount();
                                                calculateTotalTaxAmount();
                                            }}
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        /></th>


                                        {/* sgst rate*/}
                                        {!igstToggle && <th>
                                            <select value={item.sgst} onChange={(e) => {
                                                let temp = [...invoiceDetails]
                                                temp[index].sgst = e.target.value
                                                temp[index].cgst = e.target.value
                                                setInvoiceDetails(temp)
                                                calculateTotalTaxAmount()
                                            }}>
                                                {miscCgstSgstOptions.map((option, index) => {
                                                    return (
                                                        <option key={index} value={option}>{option}</option>
                                                    )
                                                })}
                                            </select>
                                        </th>}
                                        {/* sgst amount*/}
                                        {!igstToggle && (
                                            <th className="text-end">
                                                {formatToIndianRupee(((item.basicAmount / 100) * item.sgst).toFixed(2))}
                                            </th>
                                        )}
                                        {/* cgst rate*/}
                                        {!igstToggle && <th>
                                            <select value={item.cgst} onChange={(e) => {
                                                let temp = [...invoiceDetails]
                                                temp[index].sgst = e.target.value
                                                temp[index].cgst = e.target.value
                                                setInvoiceDetails(temp)
                                                calculateTotalTaxAmount()
                                            }}>
                                                {miscCgstSgstOptions.map((option, index) => {
                                                    return (
                                                        <option key={index} value={option}>{option}</option>
                                                    )
                                                })}
                                            </select>
                                        </th>}
                                        {/* cgst amount*/}
                                        {!igstToggle && (
                                            <th className="text-end">
                                                {formatToIndianRupee(((item.basicAmount / 100) * item.cgst).toFixed(2))}
                                            </th>
                                        )}
                                        {/* igst rate*/}
                                        {igstToggle && <th>
                                            <select value={item.igst_rate} onChange={(e) => {
                                                let temp = [...invoiceDetails]
                                                temp[index].igst_rate = e.target.value
                                                setInvoiceDetails(temp)
                                                calculateTotalTaxAmount()
                                            }}>
                                                {miscIgstOptions.map((option, index) => {
                                                    return (
                                                        <option key={index} value={option}>{option}</option>
                                                    )
                                                })}
                                            </select>
                                        </th>}
                                        {/* igst amount*/}
                                        {igstToggle && (
                                            <th className="text-end">
                                                {formatToIndianRupee(((item.basicAmount / 100) * item.igst_rate).toFixed(2))}
                                            </th>
                                        )}

                                        {/* Gross Amount */}
                                        <th style={{ textAlign: 'end' }}>
                                            {igstToggle
                                                ? formatToIndianRupee(
                                                    (parseFloat(item.basicAmount) + parseFloat((item.basicAmount / 100) * item.igst_rate)).toFixed(2)
                                                )
                                                : formatToIndianRupee(
                                                    (parseFloat(item.basicAmount) +
                                                        parseFloat((item.basicAmount / 100) * item.cgst) +
                                                        parseFloat((item.basicAmount / 100) * item.sgst)).toFixed(2)
                                                )}
                                        </th>
                                    </tr>
                                )
                            })
                            }
                            {/* Grand Total */}
                            <tr >
                                {/* service description */}
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>
                                {/* sac/hsn */}
                                <th className="text-start">
                                </th>
                                {miscShowBilling && <th className="text-start">
                                </th>}
                                {miscShowBilling && <th className="text-start">
                                </th>}
                                {miscShowComputations && <th className="text-start">
                                </th>}
                                {miscShowComputations && <th className="text-start">
                                </th>}
                                {/* Basic Amount */}
                                <th className="text-end">{formatToIndianRupee(parseFloat(miscTotalBasicAmount).toFixed(2))}</th>

                                {/* SGST/CGST */}
                                {!igstToggle ? (
                                    <>
                                        <th></th>
                                        <th className="text-end"> {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                        <th></th>
                                        <th className="text-end"> {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                    </>
                                ) : (
                                    <>
                                        <th></th>
                                        <th className="text-end">{formatToIndianRupee(miscTotalTaxAmount.toFixed(2))}</th>
                                    </>
                                )}

                                {/* Gross Total */}
                                <th className="text-end">{formatToIndianRupee((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))}</th>
                            </tr>
                        </tbody>
                    </Table>}
                {/* other invoices */}
                {currentPage === 8 && <Table className="invoice-preview-table">
                    <thead>
                        <tr>
                            <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                            <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                            <th colSpan={2}><b>Bill Period </b></th>
                            {showComputationDetails && <th colSpan={1}><b>Total Area</b></th>}
                            {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                            <th colSpan={1}><b>Basic Amount</b></th>
                            {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                            {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                            {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                            <th colSpan={1}><b>GROSS</b></th>
                        </tr>
                        <tr>

                            <th>From</th>
                            <th>To</th>
                            {showComputationDetails && <th>Sq. ft</th>}
                            {showComputationDetails && <th> ({formatCurrencyBasedOnRegion()} / Sq. ft)</th>}
                            <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                            {!igstToggle && <th>Rate <br /> (%)</th>}
                            {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                            {!igstToggle && <th>Rate <br />(%)</th>}
                            {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
                            {igstToggle && <th>Rate <br />(%)</th>}
                            {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                            <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoiceDetails?.map((item, index) => (
                            <tr key={index}>
                                {/* Service Name & Identifier */}
                                <th className="text-start">
                                    {item?.service_name_in_note ? item?.service_name_in_note?.toUpperCase() : item?.service_name_in_invoice?.toUpperCase()},<br />
                                    {item?.service_identifier}
                                </th>

                                {/* HSN */}
                                <th className="text-start">
                                    <input
                                        type="text"
                                        value={item.hsn || ''}
                                        onChange={e =>
                                            handleInvoiceItemChange(item.id, 'hsn', e.target.value)
                                        }
                                        style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                    />
                                </th>

                                {/* Bill Period From */}
                                <th style={{ textAlign: 'end' }}>
                                    <input
                                        type="date"
                                        value={item.from_date || ''}
                                        onChange={e => handleInvoiceItemChange(item.id, 'from_date', e.target.value)}
                                        style={{ width: '100%', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', textAlign: 'end' }}
                                    />
                                </th>

                                {/* Bill Period To */}
                                <th style={{ textAlign: 'end' }}>
                                    <input
                                        type="date"
                                        value={item.to_date || ''}
                                        onChange={e => handleInvoiceItemChange(item.id, 'to_date', e.target.value)}
                                        style={{ width: '100%', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', textAlign: 'end' }}
                                    />
                                </th>

                                {/* Computation Details */}
                                {showComputationDetails && (
                                    <th style={{ textAlign: 'end' }}>
                                        <input
                                            type="text"
                                            inputMode="decimal"
                                            value={item.consumption || ''}
                                            onChange={e => {
                                                // handleInvoiceItemChange(item.id, 'consumption', e.target.value);
                                                // calculateTotalBasicAmount(invoiceDetails);
                                                // calculateTotalTaxAmount(invoiceDetails);
                                                let temp = [...invoiceDetails];
                                                const input = e.target.value;
                                                const formattedInput = input.replace(/[^0-9.]/g, '');
                                                const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                const trimmedInput = validInput.trim();


                                                // Check if the input has more than 2 decimal places
                                                const decimalIndex = trimmedInput.indexOf('.');
                                                if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                    return; // Ignore the input if it has more than 2 decimal places
                                                }

                                                // Check if the input is a positive number
                                                if (parseFloat(trimmedInput) < 0) {
                                                    return; // Ignore the input if it is negative
                                                }

                                                temp[index].consumption = trimmedInput;
                                                if (trimmedInput.length === 0) {
                                                    temp[index].consumption = 0.0
                                                }
                                                if (temp[index].rate_per_unit.length > 0) {
                                                    temp[index].basicAmount = (parseFloat(trimmedInput) * parseFloat(temp[index].rate_per_unit)).toFixed(2)
                                                }
                                                temp[index].consumption = trimmedInput;
                                                setInvoiceDetails(temp);
                                                calculateTotalBasicAmount();
                                                calculateTotalTaxAmount();
                                            }}
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        />
                                    </th>
                                )}

                                {showComputationDetails && (
                                    <th style={{ textAlign: 'end' }}>
                                        <input
                                            type="text"
                                            inputMode="decimal"
                                            value={item.rate_per_unit || ''}
                                            onChange={e => {
                                                let temp = [...invoiceDetails];
                                                const input = e.target.value;
                                                const formattedInput = input.replace(/[^0-9.]/g, '');
                                                const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                const trimmedInput = validInput.trim();


                                                // Check if the input has more than 2 decimal places
                                                const decimalIndex = trimmedInput.indexOf('.');
                                                if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                    return; // Ignore the input if it has more than 2 decimal places
                                                }

                                                // Check if the input is a positive number
                                                if (parseFloat(trimmedInput) < 0) {
                                                    return; // Ignore the input if it is negative
                                                }

                                                temp[index].rate_per_unit = trimmedInput;
                                                if (trimmedInput.length === 0) {
                                                    temp[index].rate_per_unit = 0.0
                                                }
                                                if (temp[index].consumption.length > 0) {
                                                    temp[index].basicAmount = (parseFloat(temp[index].consumption) * parseFloat(trimmedInput)).toFixed(2)
                                                }
                                                temp[index].rate_per_unit = trimmedInput;
                                                setInvoiceDetails(temp);
                                                calculateTotalBasicAmount();
                                                calculateTotalTaxAmount();
                                            }}
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        />
                                    </th>
                                )}

                                {/* Basic Amount */}
                                <th style={{ textAlign: 'end' }}>
                                    <input
                                        type="text"
                                        inputMode="decimal"
                                        value={item.basicAmount || ''}
                                        onChange={e => {
                                            let temp = [...invoiceDetails];
                                            const input = e.target.value;
                                            const formattedInput = input.replace(/[^0-9.]/g, '');
                                            const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                            const trimmedInput = validInput.trim();


                                            // Check if the input has more than 2 decimal places
                                            const decimalIndex = trimmedInput.indexOf('.');
                                            if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                return; // Ignore the input if it has more than 2 decimal places
                                            }

                                            // Check if the input is a positive number
                                            if (parseFloat(trimmedInput) < 0) {
                                                return; // Ignore the input if it is negative
                                            }

                                            temp[index].basicAmount = trimmedInput;
                                            if (trimmedInput.length === 0) {
                                                temp[index].basicAmount = 0.0
                                            }
                                            setInvoiceDetails(temp);
                                            calculateTotalBasicAmount();
                                            calculateTotalTaxAmount();
                                        }}
                                        style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                    />
                                </th>

                                {/* Tax Columns */}
                                {/* sgst rate*/}
                                {!igstToggle && <th>
                                    <select value={item.sgst} onChange={(e) => {
                                        let temp = [...invoiceDetails]
                                        temp[index].sgst = e.target.value
                                        temp[index].cgst = e.target.value
                                        setInvoiceDetails(temp)
                                        calculateTotalTaxAmount()
                                    }}>
                                        {miscCgstSgstOptions.map((option, index) => {
                                            return (
                                                <option key={index} value={option}>{option}</option>
                                            )
                                        })}
                                    </select>
                                </th>}
                                {/* sgst amount*/}
                                {!igstToggle && (
                                    <th className="text-end">
                                        {formatToIndianRupee(((item.basicAmount / 100) * item.sgst).toFixed(2))}
                                    </th>
                                )}
                                {/* cgst rate*/}
                                {!igstToggle && <th>
                                    <select value={item.cgst} onChange={(e) => {
                                        let temp = [...invoiceDetails]
                                        temp[index].sgst = e.target.value
                                        temp[index].cgst = e.target.value
                                        setInvoiceDetails(temp)
                                        calculateTotalTaxAmount()
                                    }}>
                                        {miscCgstSgstOptions.map((option, index) => {
                                            return (
                                                <option key={index} value={option}>{option}</option>
                                            )
                                        })}
                                    </select>
                                </th>}
                                {/* cgst amount*/}
                                {!igstToggle && (
                                    <th className="text-end">
                                        {formatToIndianRupee(((item.basicAmount / 100) * item.cgst).toFixed(2))}
                                    </th>
                                )}
                                {/* igst rate*/}
                                {igstToggle && <th>
                                    <select value={item.igst_rate} onChange={(e) => {
                                        let temp = [...invoiceDetails]
                                        temp[index].igst_rate = e.target.value
                                        setInvoiceDetails(temp)
                                        calculateTotalTaxAmount()
                                    }}>
                                        {miscIgstOptions.map((option, index) => {
                                            return (
                                                <option key={index} value={option}>{option}</option>
                                            )
                                        })}
                                    </select>
                                </th>}
                                {/* igst amount*/}
                                {igstToggle && (
                                    <th className="text-end">
                                        {formatToIndianRupee(((item.basicAmount / 100) * item.igst_rate).toFixed(2))}
                                    </th>
                                )}

                                {/* Gross */}
                                <th style={{ textAlign: 'end' }}>
                                    {igstToggle
                                        ? formatToIndianRupee(
                                            (parseFloat(item.basicAmount) + parseFloat((item.basicAmount / 100) * item.igst_rate)).toFixed(2)
                                        )
                                        : formatToIndianRupee(
                                            (parseFloat(item.basicAmount) +
                                                parseFloat((item.basicAmount / 100) * item.cgst) +
                                                parseFloat((item.basicAmount / 100) * item.sgst)).toFixed(2)
                                        )}
                                </th>
                            </tr>
                        ))}

                        {/* Grand Total Row */}
                        <tr>
                            <th className="text-start" style={{ fontWeight: 'bold', fontSize: 'small' }}>Total</th>
                            <th></th>
                            <th></th>
                            <th></th>

                            {showComputationDetails && (
                                <>
                                    <th></th>
                                    <th></th>
                                </>
                            )}

                            <th className="text-end">{formatToIndianRupee(parseFloat(miscTotalBasicAmount).toFixed(2))}</th>

                            {!igstToggle ? (
                                <>
                                    <th></th>
                                    <th className="text-end"> {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                    <th></th>
                                    <th className="text-end"> {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                </>
                            ) : (
                                <>
                                    <th></th>
                                    <th className="text-end">{formatToIndianRupee(miscTotalTaxAmount.toFixed(2))}</th>
                                </>
                            )}

                            <th className="text-end">{formatToIndianRupee((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))}</th>
                        </tr>
                    </tbody>
                </Table>}
                {/* slf invoice */}
                {currentPage === 5 &&
                    <Table className="invoice-preview-table">
                        <thead>
                            <tr>
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                <th colSpan={2}><b>Bill Period </b></th>
                                {showComputationDetails && <th colSpan={1}><b>Total Area</b></th>}
                                {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>GROSS</b></th>
                            </tr>
                            <tr>

                                <th>From</th>
                                <th>To</th>
                                {showComputationDetails && <th>Sq. ft</th>}
                                {showComputationDetails && <th> ({formatCurrencyBasedOnRegion()} / Sq. ft)</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                                {!igstToggle && <th>Rate <br /> (%)</th>}
                                {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate <br />(%)</th>}
                                {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate <br />(%)</th>}
                                {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceDetails?.map((item, index) => (
                                <tr key={index}>
                                    {/* Service Name & Identifier */}
                                    <th className="text-start">
                                        {item?.service_name_in_note ? item?.service_name_in_note?.toUpperCase() : item?.service_name_in_invoice?.toUpperCase()},<br />
                                        {item?.service_identifier}
                                    </th>

                                    {/* HSN */}
                                    <th className="text-start">
                                        <input
                                            type="text"
                                            value={item.hsn || ''}
                                            onChange={e =>
                                                handleInvoiceItemChange(item.id, 'hsn', e.target.value)
                                            }
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        />
                                    </th>

                                    {/* Bill Period From */}
                                    <th style={{ textAlign: 'end' }}>
                                        <input
                                            type="date"
                                            value={item.from_date || ''}
                                            onChange={e =>
                                                handleInvoiceItemChange(item.id, 'from_date', e.target.value)
                                            }
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        />
                                    </th>

                                    {/* Bill Period To */}
                                    <th style={{ textAlign: 'end' }}>
                                        <input
                                            type="date"
                                            value={item.to_date || ''}
                                            onChange={e =>
                                                handleInvoiceItemChange(item.id, 'to_date', e.target.value)
                                            }
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        />
                                    </th>

                                    {/* Computation Details */}
                                    {showComputationDetails && (
                                        <th style={{ textAlign: 'end' }}>
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                value={item.consumption || ''}
                                                onChange={e => {
                                                    // handleInvoiceItemChange(item.id, 'consumption', e.target.value);
                                                    // calculateTotalBasicAmount(invoiceDetails);
                                                    // calculateTotalTaxAmount(invoiceDetails);
                                                    let temp = [...invoiceDetails];
                                                    const input = e.target.value;
                                                    const formattedInput = input.replace(/[^0-9.]/g, '');
                                                    const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                    const trimmedInput = validInput.trim();


                                                    // Check if the input has more than 2 decimal places
                                                    const decimalIndex = trimmedInput.indexOf('.');
                                                    if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                        return; // Ignore the input if it has more than 2 decimal places
                                                    }

                                                    // Check if the input is a positive number
                                                    if (parseFloat(trimmedInput) < 0) {
                                                        return; // Ignore the input if it is negative
                                                    }

                                                    temp[index].consumption = trimmedInput;
                                                    if (trimmedInput.length === 0) {
                                                        temp[index].consumption = 0.0
                                                    }
                                                    if (temp[index].rate_per_unit.length > 0) {
                                                        temp[index].basicAmount = (parseFloat(trimmedInput) * parseFloat(temp[index].rate_per_unit)).toFixed(2)
                                                    }
                                                    temp[index].consumption = trimmedInput;
                                                    setInvoiceDetails(temp);
                                                    calculateTotalBasicAmount();
                                                    calculateTotalTaxAmount();
                                                }}
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                        </th>
                                    )}

                                    {showComputationDetails && (
                                        <th style={{ textAlign: 'end' }}>
                                            <input
                                                type="text"
                                                inputMode="decimal"
                                                value={item.rate_per_unit || ''}
                                                onChange={e => {
                                                    let temp = [...invoiceDetails];
                                                    const input = e.target.value;
                                                    const formattedInput = input.replace(/[^0-9.]/g, '');
                                                    const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                    const trimmedInput = validInput.trim();


                                                    // Check if the input has more than 2 decimal places
                                                    const decimalIndex = trimmedInput.indexOf('.');
                                                    if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                        return; // Ignore the input if it has more than 2 decimal places
                                                    }

                                                    // Check if the input is a positive number
                                                    if (parseFloat(trimmedInput) < 0) {
                                                        return; // Ignore the input if it is negative
                                                    }

                                                    temp[index].rate_per_unit = trimmedInput;
                                                    if (trimmedInput.length === 0) {
                                                        temp[index].rate_per_unit = 0.0
                                                    }
                                                    if (temp[index].consumption.length > 0) {
                                                        temp[index].basicAmount = (parseFloat(temp[index].consumption) * parseFloat(trimmedInput)).toFixed(2)
                                                    }
                                                    temp[index].rate_per_unit = trimmedInput;
                                                    setInvoiceDetails(temp);
                                                    calculateTotalBasicAmount();
                                                    calculateTotalTaxAmount();
                                                }}
                                                style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                            />
                                        </th>
                                    )}

                                    {/* Basic Amount */}
                                    <th style={{ textAlign: 'end' }}>
                                        <input
                                            type="text"
                                            inputMode="decimal"
                                            value={item.basicAmount || ''}
                                            onChange={e => {
                                                let temp = [...invoiceDetails];
                                                const input = e.target.value;
                                                const formattedInput = input.replace(/[^0-9.]/g, '');
                                                const validInput = limitCurrencyAmount(formattedInput.trim(), 1000000000.00);
                                                const trimmedInput = validInput.trim();


                                                // Check if the input has more than 2 decimal places
                                                const decimalIndex = trimmedInput.indexOf('.');
                                                if (decimalIndex !== -1 && trimmedInput.length - decimalIndex - 1 > 2) {
                                                    return; // Ignore the input if it has more than 2 decimal places
                                                }

                                                // Check if the input is a positive number
                                                if (parseFloat(trimmedInput) < 0) {
                                                    return; // Ignore the input if it is negative
                                                }

                                                temp[index].basicAmount = trimmedInput;
                                                if (trimmedInput.length === 0) {
                                                    temp[index].basicAmount = 0.0
                                                }
                                                setInvoiceDetails(temp);
                                                calculateTotalBasicAmount();
                                                calculateTotalTaxAmount();
                                            }}
                                            style={{ width: '100%', textAlign: 'end', border: 'none', outline: 'none', backgroundColor: '#e6f7ff', }}
                                        />
                                    </th>

                                    {/* Tax Columns */}
                                    {/* sgst rate*/}
                                    {!igstToggle && <th>
                                        <select value={item.sgst} onChange={(e) => {
                                            let temp = [...invoiceDetails]
                                            temp[index].sgst = e.target.value
                                            temp[index].cgst = e.target.value
                                            setInvoiceDetails(temp)
                                            calculateTotalTaxAmount()
                                        }}>
                                            {miscCgstSgstOptions.map((option, index) => {
                                                return (
                                                    <option key={index} value={option}>{option}</option>
                                                )
                                            })}
                                        </select>
                                    </th>}
                                    {/* sgst amount*/}
                                    {!igstToggle && (
                                        <th className="text-end">
                                            {formatToIndianRupee(((item.basicAmount / 100) * item.sgst).toFixed(2))}
                                        </th>
                                    )}
                                    {/* cgst rate*/}
                                    {!igstToggle && <th>
                                        <select value={item.cgst} onChange={(e) => {
                                            let temp = [...invoiceDetails]
                                            temp[index].sgst = e.target.value
                                            temp[index].cgst = e.target.value
                                            setInvoiceDetails(temp)
                                            calculateTotalTaxAmount()
                                        }}>
                                            {miscCgstSgstOptions.map((option, index) => {
                                                return (
                                                    <option key={index} value={option}>{option}</option>
                                                )
                                            })}
                                        </select>
                                    </th>}
                                    {/* cgst amount*/}
                                    {!igstToggle && (
                                        <th className="text-end">
                                            {formatToIndianRupee(((item.basicAmount / 100) * item.cgst).toFixed(2))}
                                        </th>
                                    )}
                                    {/* igst rate*/}
                                    {igstToggle && <th>
                                        <select value={item.igst_rate} onChange={(e) => {
                                            let temp = [...invoiceDetails]
                                            temp[index].igst_rate = e.target.value
                                            setInvoiceDetails(temp)
                                            calculateTotalTaxAmount()
                                        }}>
                                            {miscIgstOptions.map((option, index) => {
                                                return (
                                                    <option key={index} value={option}>{option}</option>
                                                )
                                            })}
                                        </select>
                                    </th>}
                                    {/* igst amount*/}
                                    {igstToggle && (
                                        <th className="text-end">
                                            {formatToIndianRupee(((item.basicAmount / 100) * item.igst_rate).toFixed(2))}
                                        </th>
                                    )}
                                    {/* Gross Amount */}
                                    <th style={{ textAlign: 'end' }}>
                                        {igstToggle
                                            ? formatToIndianRupee(
                                                (parseFloat(item.basicAmount) + parseFloat((item.basicAmount / 100) * item.igst_rate)).toFixed(2)
                                            )
                                            : formatToIndianRupee(
                                                (parseFloat(item.basicAmount) +
                                                    parseFloat((item.basicAmount / 100) * item.cgst) +
                                                    parseFloat((item.basicAmount / 100) * item.sgst)).toFixed(2)
                                            )}
                                    </th>
                                </tr>
                            ))}

                            {/* Grand Total Row */}
                            <tr>
                                <th className="text-start" style={{ fontWeight: 'bold', fontSize: 'small' }}>
                                    Total
                                </th>
                                <th></th>
                                <th></th>
                                <th></th>

                                {showComputationDetails && (
                                    <>
                                        <th></th>
                                        <th></th>
                                    </>
                                )}

                                {/* Basic Amount */}
                                <th className="text-end">{formatToIndianRupee(parseFloat(miscTotalBasicAmount).toFixed(2))}</th>

                                {/* SGST/CGST */}
                                {!igstToggle ? (
                                    <>
                                        <th></th>
                                        <th className="text-end"> {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                        <th></th>
                                        <th className="text-end"> {formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                    </>
                                ) : (
                                    <>
                                        <th></th>
                                        <th className="text-end">{formatToIndianRupee(miscTotalTaxAmount.toFixed(2))}</th>
                                    </>
                                )}

                                {/* grand total */}
                                <th className="text-end">{formatToIndianRupee((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))}</th>

                            </tr>
                        </tbody>

                    </Table>}
            </>
        )
    }

    const reusableInvoiceTableView = () => {
        return (
            <>
                {/* electric invoice */}
                {currentPage === 2 &&
                    <Table className="invoice-preview-table">
                        <thead >
                            <tr >
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                <th colSpan={2}><b>Bill Period / Reading</b></th>
                                {showComputationDetails && <th colSpan={1}><b>Total Units</b></th>}
                                {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                                {/* <th colSpan={1}><b>Meter Rent</b></th> */}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>Gross</b></th>
                            </tr>
                            <tr>
                                <th>From / Op. Reading</th>
                                <th>To / Cl. Reading</th>

                                {showComputationDetails && <th>kWh</th>}
                                {showComputationDetails && <th>
                                    ({formatCurrencyBasedOnRegion()} / kWh)</th>}
                                {/* <th>Amount (INR)</th> */}
                                <th>Amount ({formatCurrencyBasedOnRegion()})</th>
                                {!igstToggle && <th>Rate (%)</th>}
                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate (%)</th>}
                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate (%)</th>}
                                {igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount ({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceDetails?.map((item, index) => (
                                <tr key={index}>
                                    {/* Service Name & Identifier */}
                                    <th className="text-start">
                                        {item?.service_name_in_note?.toUpperCase()},<br />
                                        {item?.service_identifier}
                                    </th>

                                    {/* HSN */}
                                    <th className="text-start">
                                        <p style={{ textAlign: 'end', margin: 0 }}>{item.hsn || '-'}</p>
                                    </th>

                                    {/* From Date & Initial Reading */}
                                    <th style={{ textAlign: 'end' }}>
                                        <div>
                                            <p style={{ textAlign: 'end', margin: 0 }}>{item.from_date || '-'}</p>
                                            <hr />
                                            <p style={{ textAlign: 'end', margin: 0 }}>{item.initial_reading || '-'}</p>
                                        </div>
                                    </th>

                                    {/* To Date & Final Reading */}
                                    <th style={{ textAlign: 'end' }}>
                                        <div>
                                            <p style={{ textAlign: 'end', margin: 0 }}>{item.to_date || '-'}</p>
                                            <hr />
                                            <p style={{ textAlign: 'end', margin: 0 }}>{item.final_reading || '-'}</p>
                                        </div>
                                    </th>

                                    {/* Conditional Computation Columns */}
                                    {showComputationDetails && (
                                        <th style={{ textAlign: 'end' }}>
                                            <p style={{ textAlign: 'end', margin: 0 }}>{item.consumption || '-'}</p>
                                        </th>
                                    )}

                                    {showComputationDetails && (
                                        <th style={{ textAlign: 'end' }}>
                                            <p style={{ textAlign: 'end', margin: 0 }}>{item.rate_per_unit || '-'}</p>
                                        </th>
                                    )}

                                    {/* Net Amount */}
                                    <th style={{ textAlign: 'end' }}>
                                        <p style={{ textAlign: 'end', margin: 0 }}>{item.basicAmount || '-'}</p>
                                    </th>

                                    {/* SGST / CGST */}
                                    {!igstToggle && (
                                        <>
                                            <th style={{ textAlign: 'center' }}>
                                                <p style={{ margin: 0 }}>{item.sgst || '-'}</p>
                                            </th>
                                            <th className="text-end">
                                                {formatToIndianRupee(((item.basicAmount / 100) * item.sgst).toFixed(2))}
                                            </th>
                                            <th style={{ textAlign: 'center' }}>
                                                <p style={{ margin: 0 }}>{item.cgst || '-'}</p>
                                            </th>
                                            <th className="text-end">
                                                {formatToIndianRupee(((item.basicAmount / 100) * item.cgst).toFixed(2))}
                                            </th>
                                        </>
                                    )}

                                    {/* IGST */}
                                    {igstToggle && (
                                        <>
                                            <th style={{ textAlign: 'center' }}>
                                                <p style={{ margin: 0 }}>{item.igst_rate || '-'}</p>
                                            </th>
                                            <th className="text-end">
                                                {formatToIndianRupee(((item.basicAmount / 100) * item.igst_rate).toFixed(2))}
                                            </th>
                                        </>
                                    )}

                                    {/* Gross Amount */}
                                    <th style={{ textAlign: 'end' }}>
                                        {igstToggle
                                            ? formatToIndianRupee(
                                                (parseFloat(item.basicAmount) + parseFloat((item.basicAmount / 100) * item.igst_rate)).toFixed(2)
                                            )
                                            : formatToIndianRupee(
                                                (parseFloat(item.basicAmount) +
                                                    parseFloat((item.basicAmount / 100) * item.cgst) +
                                                    parseFloat((item.basicAmount / 100) * item.sgst)).toFixed(2)
                                            )}
                                    </th>
                                </tr>
                            ))}

                            {/* Grand Total Row */}
                            <tr>
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>

                                {/* Empty Columns for Layout Alignment */}
                                <th colSpan={5}></th>

                                {/* Basic Amount */}
                                <th className="text-end">{formatToIndianRupee(parseFloat(miscTotalBasicAmount).toFixed(2))}</th>

                                {/* SGST/CGST */}
                                {!igstToggle ? (
                                    <>
                                        <th></th>
                                        <th className="text-end">{formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                        <th></th>
                                        <th className="text-end">{formatToIndianRupee((miscTotalTaxAmount / 2).toFixed(2))}</th>
                                    </>
                                ) : (
                                    <>
                                        <th></th>
                                        <th className="text-end">{formatToIndianRupee(miscTotalTaxAmount.toFixed(2))}</th>
                                    </>
                                )}

                                {/* Gross Total */}
                                <th className="text-end">
                                    {formatToIndianRupee((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))}
                                </th>
                            </tr>
                        </tbody>

                    </Table>
                }
                {/* FMS invoice */}
                {currentPage === 6 &&
                    <Table className="invoice-preview-table">
                        <thead>
                            <tr>
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                <th colSpan={2}><b>Bill Period </b></th>
                                {showComputationDetails && <th colSpan={1}><b>Total Area</b></th>}
                                {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>GROSS</b></th>
                            </tr>
                            <tr>

                                <th>From</th>
                                <th>To</th>
                                {showComputationDetails && <th>Sq. ft</th>}
                                {showComputationDetails && <th> ({formatCurrencyBasedOnRegion()} / Sq. ft)</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                                {!igstToggle && <th>Rate <br /> (%)</th>}
                                {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate <br />(%)</th>}
                                {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate <br />(%)</th>}
                                {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceDetails?.map((item, index) => (
                                <tr key={index}>
                                    {/* Service Name & Identifier */}
                                    <th className="text-start">
                                        {item?.service_name_in_note?.toUpperCase()},<br />
                                        {item?.service_identifier}
                                    </th>

                                    {/* HSN */}
                                    <th className="text-start">{item?.hsn}</th>

                                    {/* From Date */}
                                    <th style={{ textAlign: 'end', textWrap: 'nowrap' }}>
                                        {formatDateBasedOnValue(formatDateView(item.from_date))}
                                    </th>

                                    {/* To Date */}
                                    <th style={{ textAlign: 'end', textWrap: 'nowrap' }}>
                                        {formatDateBasedOnValue(formatDateView(item.to_date))}
                                    </th>

                                    {/* Computation Details */}
                                    {showComputationDetails && (
                                        <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>
                                    )}

                                    {showComputationDetails && (
                                        <th style={{ textAlign: 'end' }}>
                                            {formatToIndianRupee(item.rate_per_unit)}
                                        </th>
                                    )}

                                    {/* Basic Amount */}
                                    <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.basicAmount)}</th>

                                    {/* SGST / CGST / IGST Columns */}
                                    {!igstToggle && (
                                        <>
                                            {/* SGST Rate */}
                                            <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>
                                            {/* SGST Amount */}
                                            <th className="text-end">
                                                {formatToIndianRupee(item.sgst)}
                                            </th>
                                            {/* CGST Rate */}
                                            <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>
                                            {/* CGST Amount */}
                                            <th className="text-end">
                                                {formatToIndianRupee(item.cgst)}
                                            </th>
                                        </>
                                    )}

                                    {igstToggle && (
                                        <>
                                            {/* IGST Rate */}
                                            <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>
                                            {/* IGST Amount */}
                                            <th className="text-end">
                                                {formatToIndianRupee(item.igst)}
                                            </th>
                                        </>
                                    )}

                                    {/* Gross Amount */}
                                    <th style={{ textAlign: 'end' }}>
                                        {formatToIndianRupee(item.gross_amount)}
                                    </th>
                                </tr>
                            ))}

                            {/* Grand Total Row */}
                            <tr>
                                {/* Description */}
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>

                                {/* Empty cells for layout alignment */}
                                <th colSpan={3}></th>

                                {showComputationDetails && (
                                    <>
                                        <th></th>
                                        <th></th>
                                    </>
                                )}

                                {/* Basic Total */}
                                <th className="text-end">{formatToIndianRupee(basicAmount)}</th>

                                {/* Tax Columns */}
                                {!igstToggle ? (
                                    <>
                                        {/* SGST Rate (empty for alignment) */}
                                        <th></th>
                                        {/* SGST Total */}
                                        <th className="text-end">{formatToIndianRupee(totalSgst)}</th>
                                        {/* CGST Rate (empty for alignment) */}
                                        <th></th>
                                        {/* CGST Total */}
                                        <th className="text-end">{formatToIndianRupee(totalCgst)}</th>
                                    </>
                                ) : (
                                    <>
                                        {/* IGST Rate (empty for alignment) */}
                                        <th></th>
                                        {/* IGST Total */}
                                        <th className="text-end">{formatToIndianRupee(totalIgst)}</th>
                                    </>
                                )}

                                {/* Gross Total */}
                                <th className="text-end">
                                    {formatToIndianRupee(TotalAmount)}
                                </th>
                            </tr>
                        </tbody>

                    </Table>}
                {/* water invoice */}
                {currentPage === 4 &&
                    <Table className="invoice-preview-table">
                        <thead>
                            <tr>
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                <th colSpan={2}><b>Bill Period / Reading</b></th>
                                {showComputationDetails && <th colSpan={1}><b>Total Units</b></th>}
                                {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                                {/* <th colSpan={1}><b>Meter Rent</b></th> */}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>GROSS</b></th>
                            </tr>
                            <tr>
                                <th>From / Op. Reading</th>
                                <th>To / Cl. Reading</th>
                                {showComputationDetails && <th>kL</th>}
                                {showComputationDetails && <th>({formatCurrencyBasedOnRegion()} / kL)</th>}
                                <th>Amount ({formatCurrencyBasedOnRegion()})</th>
                                {/* <th>Amount (INR)</th> */}
                                {!igstToggle && <th>Rate (%)</th>}
                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate (%)</th>}
                                {!igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate (%)</th>}
                                {igstToggle && <th>Amount ({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount ({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody >
                            {invoiceDetails?.map((item, index) => (
                                <tr key={index}>
                                    <th className="text-start">{item?.service_name_in_note?.toUpperCase()},<br />
                                        {item?.service_identifier}</th>
                                    <th className="text-start">{item?.hsn}</th>
                                    <th style={{ textAlign: 'end' }}>
                                        <div>
                                            <p style={{ marginBottom: '-5px', textWrap: 'nowrap' }}>{formatDateBasedOnValue(formatDateView(item.from_date))}
                                                <hr />
                                                {formatToIndianRupee(item.initial_reading)}
                                            </p>
                                        </div>
                                    </th>
                                    <th style={{ textAlign: 'end' }}><div>
                                        <p style={{ marginBottom: '-5px' }}>{formatDateBasedOnValue(formatDateView(item.to_date))}
                                            <hr />
                                            {formatToIndianRupee(item.final_reading)}
                                        </p>
                                    </div></th>
                                    {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>}
                                    {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.rate_per_unit)}</th>}
                                    {/* <th>-</th> */}
                                    <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.basicAmount)}</th>
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
                                    {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
                                    {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
                                    <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
                                </tr>
                            ))}
                            {/* Grand Total */}
                            <tr >
                                {/* service description */}
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>
                                {/* sac/hsn */}
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                {/* basic amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(basicAmount)}
                                </th>
                                {/* sgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* sgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalSgst)}
                                </th>}
                                {/* cgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* cgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalCgst)}
                                </th>}
                                {/* igst rate*/}
                                {igstToggle && <th>

                                </th>}
                                {/* igst amount*/}
                                {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
                                {/* gross amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(TotalAmount)}
                                    {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
                                </th>
                            </tr>
                        </tbody>
                    </Table>}
                {/* mics invoice */}
                {currentPage === 7 &&
                    <Table className="invoice-preview-table">
                        <thead>
                            <tr>
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                {miscShowBilling && <th colSpan={2}><b>Bill Period</b></th>}
                                {miscShowComputations && <th colSpan={1} rowSpan={2}><b>Total Units</b></th>}
                                {miscShowComputations && <th colSpan={1} rowSpan={2}><b>Rate</b></th>}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>GROSS</b></th>
                            </tr>
                            <tr>
                                {miscShowBilling && <><th>From</th>
                                    <th>To</th>
                                </>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                                {!igstToggle && <th>Rate <br /> (%)</th>}
                                {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate <br />(%)</th>}
                                {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate <br />(%)</th>}
                                {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody >
                            {invoiceDetails?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <th className="text-start">{item?.service_name_in_note?.toUpperCase()},<br />
                                            {item?.service_identifier}
                                        </th>
                                        <th className="text-start">{item?.hsn}</th>
                                        {miscShowBilling && <th>{item?.from_date}</th>}
                                        {miscShowBilling && <th>{item?.to_date}</th>}
                                        {miscShowComputations && <th>{item?.consumption}</th>}
                                        {miscShowComputations && <th>{item?.rate_per_unit}</th>}
                                        <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.basicAmount)}</th>

                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
                                        {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
                                        {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
                                        <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
                                    </tr>
                                )
                            })
                            }
                            {/* Grand Total */}
                            <tr >
                                {/* service description */}
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>
                                {/* sac/hsn */}
                                <th className="text-start">
                                </th>
                                {miscShowBilling && <th className="text-start">
                                </th>}
                                {miscShowBilling && <th className="text-start">
                                </th>}
                                {miscShowComputations && <th className="text-start">
                                </th>}
                                {miscShowComputations && <th className="text-start">
                                </th>}
                                {/* basic amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(basicAmount)}
                                </th>
                                {/* sgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* sgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalSgst)}
                                </th>}
                                {/* cgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* cgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalCgst)}
                                </th>}
                                {/* igst rate*/}
                                {igstToggle && <th>

                                </th>}
                                {/* igst amount*/}
                                {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
                                {/* gross amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(TotalAmount)}
                                    {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
                                </th>
                            </tr>
                        </tbody>
                    </Table>}
                {/* other invoices */}
                {currentPage === 8 && <Table className="invoice-preview-table">
                    <thead>
                        <tr>
                            <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                            <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                            <th colSpan={2}><b>Bill Period </b></th>
                            {showComputationDetails && <th colSpan={1}><b>Total Area</b></th>}
                            {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                            <th colSpan={1}><b>Basic Amount</b></th>
                            {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                            {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                            {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                            <th colSpan={1}><b>GROSS</b></th>
                        </tr>
                        <tr>

                            <th>From</th>
                            <th>To</th>
                            {showComputationDetails && <th>Sq. ft</th>}
                            {showComputationDetails && <th> ({formatCurrencyBasedOnRegion()} / Sq. ft)</th>}
                            <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                            {!igstToggle && <th>Rate <br /> (%)</th>}
                            {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                            {!igstToggle && <th>Rate <br />(%)</th>}
                            {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
                            {igstToggle && <th>Rate <br />(%)</th>}
                            {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                            <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                        </tr>
                    </thead>
                    <tbody >
                        {invoiceDetails?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <th className="text-start">{item?.service_name_in_note?.toUpperCase()},<br />
                                        {item?.service_identifier}
                                    </th>
                                    <th className="text-start">{item?.hsn}</th>
                                    <th style={{ textAlign: 'end' }}>{(formatDateBasedOnValue(formatDateView(item.from_date)))}</th>
                                    <th style={{ textAlign: 'end' }}>
                                        <div>
                                            {formatDateBasedOnValue(formatDateView(item.to_date))}
                                        </div>
                                    </th>
                                    {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>}
                                    {showComputationDetails && <th style={{ textAlign: 'end' }}><div>
                                        {formatToIndianRupee(item.rate_per_unit)}
                                    </div></th>}
                                    <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.basicAmount)}</th>

                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
                                    {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
                                    {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
                                    {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
                                    <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
                                </tr>
                            )
                        })
                        }
                        {/* Grand Total */}
                        <tr >
                            {/* service description */}
                            <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                Total
                            </th>
                            {/* sac/hsn */}
                            <th className="text-start">
                            </th>
                            <th className="text-start">
                            </th>
                            <th className="text-start">
                            </th>
                            <th className="text-start">
                            </th>
                            <th className="text-start">
                            </th>
                            {/* basic amount */}
                            <th className="text-end">
                                {formatToIndianRupee(basicAmount)}
                            </th>
                            {/* sgst rate*/}
                            {!igstToggle && <th>

                            </th>}
                            {/* sgst amount*/}
                            {!igstToggle && <th className="text-end">
                                {formatToIndianRupee(totalSgst)}
                            </th>}
                            {/* cgst rate*/}
                            {!igstToggle && <th>

                            </th>}
                            {/* cgst amount*/}
                            {!igstToggle && <th className="text-end">
                                {formatToIndianRupee(totalCgst)}
                            </th>}
                            {/* igst rate*/}
                            {igstToggle && <th>

                            </th>}
                            {/* igst amount*/}
                            {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
                            {/* gross amount */}
                            <th className="text-end">
                                {formatToIndianRupee(TotalAmount)}
                                {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
                            </th>
                        </tr>
                    </tbody>
                </Table>}
                {/* slf invoice */}
                {currentPage === 5 &&
                    <Table className="invoice-preview-table">
                        <thead>
                            <tr>
                                <th colSpan={1} rowSpan={2}><b>Particulars of Services</b></th>
                                <th colSpan={1} rowSpan={2}><b>SAC / HSN</b></th>
                                <th colSpan={2}><b>Bill Period </b></th>
                                {showComputationDetails && <th colSpan={1}><b>Total Area</b></th>}
                                {showComputationDetails && <th colSpan={1}><b>Rate</b></th>}
                                <th colSpan={1}><b>Basic Amount</b></th>
                                {!igstToggle && <th colSpan={2}><b>CGST</b></th>}
                                {!igstToggle && <th colSpan={2}><b>SGST</b></th>}
                                {igstToggle && <th colSpan={2}><b>IGST</b></th>}
                                <th colSpan={1}><b>GROSS</b></th>
                            </tr>
                            <tr>

                                <th>From</th>
                                <th>To</th>
                                {showComputationDetails && <th>Sq. ft</th>}
                                {showComputationDetails && <th> ({formatCurrencyBasedOnRegion()} / Sq. ft)</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                                {!igstToggle && <th>Rate <br /> (%)</th>}
                                {!igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                {!igstToggle && <th>Rate <br />(%)</th>}
                                {!igstToggle && <th>Amount<br /> ({formatCurrencyBasedOnRegion()})</th>}
                                {igstToggle && <th>Rate <br />(%)</th>}
                                {igstToggle && <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>}
                                <th>Amount <br />({formatCurrencyBasedOnRegion()})</th>
                            </tr>
                        </thead>
                        <tbody >
                            {invoiceDetails?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <th className="text-start">{item?.service_name_in_note?.toUpperCase()},<br />
                                            {item?.service_identifier}
                                        </th>
                                        <th className="text-start">{item?.hsn}</th>
                                        <th style={{ textAlign: 'end' }}>{(formatDateBasedOnValue(formatDateView(item.from_date)))}</th>
                                        <th style={{ textAlign: 'end' }}>
                                            <div>
                                                {formatDateBasedOnValue(formatDateView(item.to_date))}
                                            </div>
                                        </th>
                                        {showComputationDetails && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.consumption)}</th>}
                                        {showComputationDetails && <th style={{ textAlign: 'end' }}><div>
                                            {formatToIndianRupee(item.rate_per_unit)}
                                        </div></th>}
                                        <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.basicAmount)}</th>

                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst_rate)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.cgst)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst_rate)}</th>}
                                        {!igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.sgst)}</th>}
                                        {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst_rate)}</th>}
                                        {igstToggle && <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.igst)}</th>}
                                        <th style={{ textAlign: 'end' }}>{formatToIndianRupee(item.gross_amount)}</th>
                                    </tr>
                                )
                            })
                            }
                            {/* Grand Total */}
                            <tr >
                                {/* service description */}
                                <th style={{ fontWeight: 'bold', fontSize: 'small' }} className="text-start">
                                    Total
                                </th>
                                {/* sac/hsn */}
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                <th className="text-start">
                                </th>
                                {/* basic amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(basicAmount)}
                                </th>
                                {/* sgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* sgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalSgst)}
                                </th>}
                                {/* cgst rate*/}
                                {!igstToggle && <th>

                                </th>}
                                {/* cgst amount*/}
                                {!igstToggle && <th className="text-end">
                                    {formatToIndianRupee(totalCgst)}
                                </th>}
                                {/* igst rate*/}
                                {igstToggle && <th>

                                </th>}
                                {/* igst amount*/}
                                {igstToggle && <th className="text-end">{formatToIndianRupee(totalIgst)}</th>}
                                {/* gross amount */}
                                <th className="text-end">
                                    {formatToIndianRupee(TotalAmount)}
                                    {/* parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.igst)) : formatToIndianRupee(parseFloat(each.basicAmount) + parseFloat((each.basicAmount / 100) * each.cgst) + parseFloat((each.basicAmount / 100) * each.sgst))} */}
                                </th>
                            </tr>
                        </tbody>
                    </Table>}
            </>
        )
    }

    const changeTabType = (id) => {
        setTabType(id);
        if (id === 'all') {
            getCreditList(undefined, 1)
        } else if (id === 'credit') {
            getCreditList('credit', 1)
        } else if (id === 'debit') {
            getCreditList('debit', 1)
        }
    }

    const handleSelectTermsAndCondition = (files) => {
        setTermsAndConditions(null)
        let processedFiles1 = [];
        files.forEach((file) => {
            const reader1 = new FileReader();
            reader1.onloadend = function () {
                const base64FileContent = reader1.result.split(",")[1];
                const processedFile1 = {
                    file_content: base64FileContent,
                    file_name: file?.file?.name,
                    file_type: "pdf",
                    object_type: "terms_documents",
                    flag: null,
                    document_type: "tandc",
                    user_id: localStorage.getItem("username"),
                    contract_name: miscContractName?.label,
                    service_code: "miscellaneous"
                };
                processedFiles1 = [...processedFiles1, processedFile1];
                if (processedFiles1.length === files.length) {
                    setFileData(processedFiles1);
                }
            };
            reader1.readAsDataURL(file.file);
        });
    }
    const handleTermsAndConditionsUpload = (index) => {
        const data = { "files": [fileData[index]] }
        dispatch(handleDocumentLoaderTrue())
        axios.post(base_url + "documents", data)
            .then((response) => {
                if (response.status === 200) {
                    setTermsAndConditions(response.data.data[0].key)
                    dispatch(handleDocumentLoaderFalse())
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    function base64ToArrayBuffer(base64) {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }

    const handleDownloadDocument = (key_value) => {
        setIsLoading(true)
        const encodedKeyValue = encodeURIComponent(key_value);
        axios
            .get(
                base_url +
                `documents?filter_condition=%7B%22s3_keys%22%3A%5B%22` +
                encodedKeyValue +
                "%22%5D%7D"
            )
            .then((res) => {
                setDocumentLoader(false)
                setIsLoading(false)
                const url = window.URL.createObjectURL(
                    new Blob([base64ToArrayBuffer(res.data.data[0].file.slice(2, -1))], {
                        type: "application/" + res.data.data[0].file_type,
                    })
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", res.data.data[0].file_name + "." + res.data.data[0].file_type);
                document.body.appendChild(link);
                link.click();
            })
            .catch((err) => {
                setIsLoading(false)
                setDocumentLoader(false)
                setErrorValue(err.response.data.message)
                // handleErrorFromDocument(err.response.data.message)
            });
    };

    return (
        <>
            <>
                <NavBarTop />
                <LeftNavBar />
            </>
            <AlertPopUp alertShow={alertShow} alertType={alertType} alertMsg={alertMessage} alertValue={alertValue} alertButtons={alertButtons} />
            <div>
                {currentPage === 1 && !editInvoiceClicked && <div className='invoice_container'>
                    <div className='fm-invoice-con'>
                        <div className='fm-invoice-heading-con  mb-1'>
                            <h3 className="invoice-heading">Credit And Debit Notes</h3>
                            {/* <p className="fin_man_meter_label pt-2"><span>{invoicesList?.length}</span> Total</p> */}
                        </div>

                        <div className="d-flex gap-2 mb-3">
                            <Dropdown as={ButtonGroup}>
                                <Dropdown.Toggle className="invoice_btn" id="dropdown-basic">
                                    Credit/Debit Note
                                </Dropdown.Toggle>

                                <Dropdown.Menu style={{ width: 'max-content' }}>
                                    <Dropdown.Item onClick={() => {

                                        getAllInvoicesData(selectedFacilityId, invoiceSelected, "pdfgenerated", billingMonthFilter, billingYearFilter)
                                        setNoteType('Credit Note')
                                        // setCurrentPage(2)
                                        setEditInvoiceClicked(true)
                                        setIsCreditDebitClicked(true)
                                    }}>Credit Note</Dropdown.Item>
                                    <Dropdown.Item onClick={() => {
                                        getAllInvoicesData(selectedFacilityId, invoiceSelected, "pdfgenerated", billingMonthFilter, billingYearFilter)
                                        setNoteType('Debit Note')
                                        // setCurrentPage(2)
                                        setEditInvoiceClicked(true)
                                        setIsCreditDebitClicked(true);
                                    }}>Debit Note</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                    <div className='fm-invoice-con-filters mb-3 mt-2 ' style={{ zIndex: 100 }}>
                        <div style={{ width: '280px' }} className="meter-report-filters fin_man_billing_period">
                            <p style={{ marginBottom: '-15px' }}>Facility:&nbsp;</p>
                            <SearchableDropdown
                                style={{ zIndex: 100 }}
                                options={facilityList ? facilityList : []}
                                selectedOption={selectedFacility}
                                noOptionsAvailable="Facility unavailable"
                                onChange={(e) => {
                                    setSelectedFacility(e.value);
                                    const selectedFacilityObj = facilitiesListForNav?.find((facility) => `${facility.city}, ${facility.name}` === e.value);
                                    setSelectedFacilityName(selectedFacilityObj?.name);
                                    setSelectedCityName(selectedFacilityObj?.city);
                                    setSelectedFacility(`${selectedFacilityObj?.city}, ${selectedFacilityObj?.name}`);
                                    setSelectedFacilityId(selectedFacilityObj?.facility_id);
                                }}
                                placeholder="Select Facility"
                                isDisabled={false}
                            />
                        </div>
                        <div className="meter-report-filters payments-select-container fin_man_billing_period">
                            <p style={{ marginBottom: '5px' }}>Invoice Type:&nbsp;</p>
                            <select
                                value={invoiceSelected}
                                onChange={(e) => setinvoiceSelected(e.target.value)}
                                className="form-select payments-select invoice-select-date"
                                style={{ width: "100%", height: "2.5rem" }}
                            >
                                <option value={""}>All Invoices</option>
                                <option value="miscellaneous">Miscellaneous</option>
                                {servicesForDropdown?.map((service, index) => (
                                    <option key={index} value={service.service_code}>{service.service_name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="payments-select-container fin_man_billing_period" style={{ width: '180px' }}>
                            <p style={{ marginBottom: '0px' }}>Billing Period:&nbsp;</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label=""
                                    value={dayjs(`${billingYearFilter}-${billingMonthFilter}`)}
                                    views={['month', 'year']}
                                    onChange={(newValue) => {
                                        setBillingMonthFilter(dayjs(newValue).month() + 1);
                                        setBillingYearFilter(dayjs(newValue).year());
                                        setBillingPeriodFilter(newValue);

                                    }}
                                    sx={{
                                        '.MuiInputBase-root': {
                                            height: '40px',
                                            backgroundColor: 'white',
                                            borderRadius: '6px',
                                            fontSize: '14px',
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className='d-flex align-items-center gap-3 mb-3'>
                            <div className='fin_man_meter_search_bar_container'>
                                <input style={{ marginTop: '20px', height: '2.5rem' }} type='search' placeholder='Search' value={searchText}
                                    onChange={(e) => handleSearchSubmit(e.target.value)}
                                    className='fin_man_meter_search_bar' />
                                <GoSearch style={{ marginTop: '17px' }} className='search-input-icon fin_man_meter_search_bar_icon C-pointer' />
                            </div>
                        </div>
                        <div className="fm-invoice-con-filters mb-2 mt-3">
                            <button className="add_fac_apply_btn primary-button" style={{ color: 'white', height: '20px !important' }} onClick={applyFilter}>Apply</button>
                            <button className="add_fac_clear_btn secondary-button" style={{ color: 'white', height: '20px !important' }} onClick={handleClear}>Clear</button>

                        </div>
                    </div>
                    <Stack direction="horizontal" className="mt-1 invoice-type-div" gap={3}>
                        {typesOfTabs.map((i, index) => (
                            <div key={index} className="invoice-type-card" onClick={() => changeTabType(i.id)}>
                                <p className={i.id === tabType ? "selected-invoice-type C-pointer" : "C-pointer"}>{i.name}</p>
                            </div>
                        ))}
                    </Stack>
                    {tabType === "all" && (
                        <>
                            <div
                                className="table_container_commercial_head_credit_debit"
                            >
                                <TableComponent
                                    headers={[
                                        {
                                            name: 'note Number',
                                            type: 'text',
                                            key: 'note_number',
                                            sort: true
                                        },
                                        {
                                            name: 'Note Type',
                                            type: 'text',
                                            key: 'note_type',
                                            sort: true
                                        },
                                        {
                                            name: 'Invoice No',
                                            type: 'text',
                                            key: 'invoice_number',
                                            sort: true
                                        },
                                        {
                                            name: 'Invoice Type',
                                            type: 'text',
                                            key: 'service_name_in_note',
                                            sort: true
                                        },
                                        {
                                            name: 'Company Name',
                                            type: 'text',
                                            key: 'company_name',
                                            sort: true
                                        },
                                        {
                                            name: 'Billing Period',
                                            type: 'text',
                                            key: 'billingPeriod',
                                            sort: true
                                        },
                                        {
                                            name: 'Note Amount',
                                            type: 'number',
                                            key: 'gross_amount',
                                            sort: true
                                        },
                                        {
                                            name: 'Status',
                                            type: 'text',
                                            key: 'status',
                                            sort: true
                                        },
                                        {
                                            name: 'Update By',
                                            type: 'text',
                                            key: 'updated_by',
                                            sort: true
                                        },
                                        {
                                            name: 'Updated on',
                                            type: 'time_stamp',
                                            key: 'updated_at',
                                            sort: true
                                        },
                                        {
                                            name: "Action",
                                            type: "button",
                                            buttons: [{
                                                name: "View",
                                                icon: "./images/icons/ViewViewIconEye.svg",
                                                disable: () => false,
                                                action: (row) => {
                                                    // View action logic here
                                                    viewInvoiceNote(row.note_id, row.service_name_in_note, row.status)
                                                }
                                            }]
                                        }
                                    ]}
                                    data={creditAndDebitList}
                                />
                            </div>
                            <Pagination
                                handledPaginationNextClicked={handledPaginationNextClicked}
                                handledPaginationPrevClicked={handledPaginationPrevClicked}
                                isApplyClicked
                                totalRecords={totalNotes}
                                recordsPerPage={RECORDS_PER_PAGE}
                                currentPaginationPage={currentPaginationPage}
                            />

                        </>
                    )}

                    {tabType === "credit" && (
                        <>
                            <div className="table_container_commercial_head_credit_debit">
                                <TableComponent
                                    headers={[
                                        {
                                            name: 'Credit Number',
                                            type: 'text',
                                            key: 'note_number',
                                            sort: true
                                        },
                                        {
                                            name: 'Note Type',
                                            type: 'text',
                                            key: 'note_type',
                                            sort: true
                                        },
                                        {
                                            name: 'Invoice No',
                                            type: 'text',
                                            key: 'invoice_number',
                                            sort: true
                                        },
                                        {
                                            name: 'Invoice Type',
                                            type: 'text',
                                            key: 'service_name_in_note',
                                            sort: true
                                        },
                                        {
                                            name: 'Company Name',
                                            type: 'text',
                                            key: 'company_name',
                                            sort: true
                                        },
                                        {
                                            name: 'Billing Period',
                                            type: 'text',
                                            key: 'billingPeriod',
                                            sort: true
                                        },
                                        {
                                            name: 'Note Amount',
                                            type: 'number',
                                            key: 'gross_amount',
                                            sort: true
                                        },
                                        {
                                            name: 'Status',
                                            type: 'text',
                                            key: 'status',
                                            sort: true
                                        },
                                        {
                                            name: 'Update By',
                                            type: 'text',
                                            key: 'updated_by',
                                            sort: true
                                        },
                                        {
                                            name: 'Updated on',
                                            type: 'time_stamp',
                                            key: 'updated_at',
                                            sort: true
                                        },
                                        {
                                            name: "Action",
                                            type: "button",
                                            buttons: [{
                                                name: "View",
                                                icon: "./images/icons/ViewViewIconEye.svg",
                                                disable: () => false,
                                                action: (row) => {
                                                    // View action logic here
                                                    viewInvoiceNote(row.note_id, row.service_name_in_note, row.status)
                                                }
                                            }]
                                        }
                                    ]}
                                    data={creditAndDebitList}
                                />
                            </div>
                            <Pagination
                                handledPaginationNextClicked={handledPaginationNextClicked}
                                handledPaginationPrevClicked={handledPaginationPrevClicked}
                                isApplyClicked
                                totalRecords={totalNotes}
                                recordsPerPage={RECORDS_PER_PAGE}
                                currentPaginationPage={currentPaginationPage}
                            />

                        </>
                    )}

                    {tabType === "debit" && (
                        <>
                            <div className="table_container_commercial_head_credit_debit">
                                <TableComponent
                                    headers={[
                                        {
                                            name: 'Debit Number',
                                            type: 'text',
                                            key: 'note_number',
                                            sort: true
                                        },
                                        {
                                            name: 'Note Type',
                                            type: 'text',
                                            key: 'note_type',
                                            sort: true
                                        },
                                        {
                                            name: 'Invoice No',
                                            type: 'text',
                                            key: 'invoice_number',
                                            sort: true
                                        },
                                        {
                                            name: 'Invoice Type',
                                            type: 'text',
                                            key: 'service_name_in_note',
                                            sort: true
                                        },
                                        {
                                            name: 'Company Name',
                                            type: 'text',
                                            key: 'company_name',
                                            sort: true
                                        },
                                        {
                                            name: 'Billing Period',
                                            type: 'text',
                                            key: 'billingPeriod',
                                            sort: true
                                        },
                                        {
                                            name: 'Note Amount',
                                            type: 'number',
                                            key: 'gross_amount',
                                            sort: true
                                        },
                                        {
                                            name: 'Status',
                                            type: 'text',
                                            key: 'status',
                                            sort: true
                                        },
                                        {
                                            name: 'Update By',
                                            type: 'text',
                                            key: 'updated_by',
                                            sort: true
                                        },
                                        {
                                            name: 'Updated on',
                                            type: 'time_stamp',
                                            key: 'updated_at',
                                            sort: true
                                        },
                                        {
                                            name: "Action",
                                            type: "button",
                                            buttons: [{
                                                name: "View",
                                                icon: "./images/icons/ViewViewIconEye.svg",
                                                disable: () => false,
                                                action: (row) => {
                                                    // View action logic here
                                                    viewInvoiceNote(row.note_id, row.service_name_in_note, row.status)
                                                }
                                            }]
                                        }
                                    ]}
                                    data={creditAndDebitList}
                                />
                            </div>
                            <Pagination
                                handledPaginationNextClicked={handledPaginationNextClicked}
                                handledPaginationPrevClicked={handledPaginationPrevClicked}
                                isApplyClicked
                                totalRecords={totalNotes}
                                recordsPerPage={RECORDS_PER_PAGE}
                                currentPaginationPage={currentPaginationPage}
                            />

                        </>
                    )}

                </div>
                }
                {/* generate credit/debit note preview */}
                {editInvoiceClicked && <div className="invoice_preview_container">

                    <div className="invoice-preview-con">
                        {!preview && <div className="fm-invoice-setting-con">
                            <h1 className="invoice-setting-header">Invoice Details</h1>
                            {isCreditDebitClicked &&
                                <div>
                                    <div style={{ marginBottom: '3px', marginTop: '15px' }} className="fin_man_billing_period">
                                        <p style={{ marginBottom: '-18px' }}>Facility:&nbsp;</p>
                                        <SearchableDropdown
                                            style={{ zIndex: 100 }}
                                            // className = "searchable-dropdown2"
                                            options={facilityList ? facilityList : []} //facilityList is the array of facilities
                                            selectedOption={selectedFacility}
                                            noOptionsAvailable="Facility unavailable"
                                            onChange={(e) => {
                                                setSelectedFacility(e.value)
                                                const selectedFacility = facilitiesListForNav?.find((facility) => `${facility.city}, ${facility.name}` === e.value);
                                                setSelectedFacilityName(selectedFacility?.name);
                                                setSelectedCityName(selectedFacility?.city);
                                                setSelectedFacility(`${selectedFacility?.city}, ${selectedFacility?.name}`);
                                                setSelectedFacilityId(selectedFacility?.facility_id);
                                                getAllInvoicesData(selectedFacility?.facility_id, invoiceType, "pdfgenerated", billingMonthFilter, billingYearFilter)
                                            }}

                                            placeholder="Select Facility"
                                            isDisabled={false}
                                        />
                                    </div>

                                    <div style={{ marginBottom: '3px', marginTop: '15px' }} className="fin_man_billing_period">
                                        <p style={{ marginBottom: '5px' }}>Invoice Type:&nbsp;</p>
                                        <select
                                            value={invoiceSelected}
                                            onChange={(e) => {
                                                setinvoiceSelected(e.target.value);
                                                // getAllInvoices()
                                                getAllInvoicesData(selectedFacilityId, e.target.value, "pdfgenerated", billingMonthFilter, billingYearFilter)
                                            }}
                                            className="invoice-select-date"
                                            style={{ width: "100%", height: "2.5rem" }}
                                        >
                                            <option value={""}>All Invoices</option>
                                            <option value="miscellaneous">Miscellaneous</option>
                                            {servicesForDropdown?.map((service, index) => (
                                                <option key={index} value={service.service_code}>{service.service_name}</option>
                                            ))}
                                        </select>
                                    </div>


                                    <div style={{ marginBottom: '3px', marginTop: '15px' }} className="fin_man_billing_period">
                                        <p style={{ marginBottom: '0px' }}>Billing Period:&nbsp;</p>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label=""
                                                value={dayjs(`${billingYearFilter}-${billingMonthFilter}`)}
                                                views={['month', 'year']}
                                                // minDate={dayjs('2022-01-01')} // Set minimum selectable date
                                                // maxDate={dayjs('2025-01-08')} // Set minimum selectable date
                                                onChange={(newValue) => {
                                                    setBillingMonthFilter(dayjs(newValue).month() + 1);
                                                    setBillingYearFilter(dayjs(newValue).year());
                                                    setBillingPeriodFilter(newValue)
                                                    getAllInvoicesData(selectedFacilityId, invoiceSelected, "pdfgenerated", dayjs(newValue).month() + 1, dayjs(newValue).year())
                                                }
                                                }
                                                sx={{
                                                    '.MuiInputBase-root': {
                                                        height: '40px', // Adjust height
                                                        // width: "180px",
                                                        backgroundColor: 'white', // Set background to white
                                                        borderRadius: '6px', // Optional: Rounded corners
                                                        fontSize: '14px', // Optional: Adjust text size
                                                    },
                                                    '.MuiInputAdornment-root .MuiIconButton-root': {
                                                        padding: '4px',    // Adjust the padding around the icon
                                                        width: '30px',     // Icon width
                                                        height: '30px',    // Icon height
                                                        // marginRight: '1px', // Space between icon and input text
                                                        marginBottom: '-2px',
                                                    },
                                                    '.MuiSvgIcon-root': {
                                                        fontSize: '20px',  // Adjust icon size
                                                    }
                                                }}

                                            />
                                        </LocalizationProvider>


                                    </div>

                                    <div style={{ marginBottom: '3px', marginTop: '15px' }} className="fin_man_billing_period">
                                        <p style={{ marginBottom: '-18px' }}>Invoice No:&nbsp;</p>
                                        <SearchableDropdown
                                            style={{ zIndex: 100 }}
                                            // className = "searchable-dropdown2"
                                            options={invoiceNoList ? invoiceNoList : []} //facilityList is the array of facilities
                                            selectedOption={selectedInvoiceNo}
                                            noOptionsAvailable="Invoice unavailable"
                                            onChange={(e) => {
                                                setSelectedInvoiceNo(e.value)
                                                handleViewButton(e.value, "pdfgenerated", invoiceSelected)
                                            }}

                                            placeholder="Select Invoice No"
                                            isDisabled={false}
                                        />
                                    </div>

                                    <div style={{ marginBottom: '3px', marginTop: '5px' }} className="fin_man_billing_period">
                                        {miscContractName && termsAndConditions && <><p style={{ marginBottom: '10px', marginTop: '15px' }}>Terms and Conditions</p>

                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    width: "110px",
                                                }}
                                                onClick={() => {
                                                    setDocumentLoader(true)
                                                    handleDownloadDocument(termsAndConditionsKey)

                                                }}
                                                title={termsAndConditions?.file_name + "." + termsAndConditions?.file_type}
                                            >
                                                <div>
                                                    {termsAndConditions?.file_type === "pdf" ? (
                                                        <GrDocumentPdf size={40} />
                                                    ) : (
                                                        <IoImage size={40} />
                                                    )}
                                                </div>
                                                <span
                                                    style={{
                                                        color: "green",
                                                        marginTop: "10px",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        maxWidth: "100px", // adjust this value as per your requirement
                                                    }}
                                                >
                                                    {/* {termsAndConditions?.file_name + "." + termsAndConditions?.file_type} */}
                                                    {termsAndConditions?.file_name?.slice(0, 11) + '...' + termsAndConditions?.file_type}
                                                </span>
                                            </div>
                                        </>}
                                    </div>
                                </div>
                            }
                            {
                                !isCreditDebitClicked &&
                                <div>


                                    <div style={{ marginBottom: '3px', marginTop: '15px' }} className="fin_man_billing_period">
                                        <p style={{ marginBottom: '5px' }}>Invoice Number:&nbsp;</p>
                                        <select
                                            value={invoiceNo}
                                            disabled
                                            className="invoice-select-date"
                                            style={{ width: "100%", height: "2.5rem" }}
                                        >
                                            <option value={""}>{invoiceNo}</option>
                                        </select>
                                    </div>
                                    <div style={{ marginBottom: '3px', marginTop: '' }} className="fin_man_billing_period">
                                        {miscContractName && termsAndConditions && <><p style={{ marginBottom: '10px', marginTop: '15px' }}>Terms and Conditions</p>

                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    width: "110px",
                                                }}
                                                onClick={() => {
                                                    setDocumentLoader(true)
                                                    handleDownloadDocument(termsAndConditionsKey)

                                                }}
                                                title={termsAndConditions?.file_name + "." + termsAndConditions?.file_type}
                                            >
                                                <div>
                                                    {termsAndConditions?.file_type === "pdf" ? (
                                                        <GrDocumentPdf size={40} />
                                                    ) : (
                                                        <IoImage size={40} />
                                                    )}
                                                </div>
                                                <span
                                                    style={{
                                                        color: "green",
                                                        marginTop: "10px",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        maxWidth: "100px", // adjust this value as per your requirement
                                                    }}
                                                >
                                                    {termsAndConditions?.file_name?.slice(0, 11) + '...' + termsAndConditions?.file_type}
                                                </span>
                                            </div>
                                        </>}
                                    </div>
                                </div>
                            }






                        </div>}
                        <div className="invoice-preview-scrollable" style={{ width: preview ? '100vw' : '' }}>
                            <div className="invoice-preview-card">
                                <div className="invoice-preview-card-details">
                                    {companyLogo ? <div className="invoice-logo-placeholder">
                                        <div>
                                            <img style={{ width: '15rem', height: '5rem' }} src={companyLogo} alt="company logo" />
                                        </div>
                                    </div> :
                                        <p style={{ marginTop: '10px' }}></p>}
                                    <div className="d-flex justify-content-between w-100">
                                        <div className="invoice-header-address text-center" style={{ marginTop: "-50px" }}>
                                            <h5>{companyName?.toUpperCase()}</h5>
                                            <p style={{ textAlign: 'center' }}><span ><b>Reg.Office:</b>
                                                {companyAddress}</span></p>
                                        </div>
                                        {
                                            QrCode?.length > 0 ?
                                                <QRCode style={{ marginTop: '-70px' }} value={QrCode} size={170} />
                                                :
                                                <div className="invoice-bar-code" style={{ marginTop: '-70px' }}>
                                                    {invoiceStatus === "rejected" ? (
                                                        <p className="rejected-text">Rejected</p>
                                                    ) : (
                                                        <p className="qr-code-text">QR Code</p>
                                                    )}
                                                </div>
                                        }

                                    </div>
                                    <h5 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>{noteType}</h5>
                                    {/* <h6 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>{miscInvoiceTable[0]?.service ?<> ({miscInvoiceTable[0]?.service}) </>: ''}</h6> */}

                                    <div className="invoice-preview-inner-card-div">
                                        <div className="invoice-preview-inner-card">
                                            <div style={{ width: '100%' }}>
                                                <p>
                                                    <b style={{ fontSize: "18px" }}>Buyer </b>
                                                    <br /> <b>{customerName}</b><br />
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>Billed To</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerAddress}</span>
                                                    </div>
                                                    {toggleShippingAddress && <div className="invoice-left-data">
                                                        <span className="key"><b>Shipped To</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value">
                                                            {streetAddress ?
                                                                <>
                                                                    {streetAddress}{streetAddress ? ", " : ""} {city}{city ? ", " : ""} {state}{state ? ", " : ""} {pincode}
                                                                </>
                                                                :
                                                                <>
                                                                    {shippingAddress}
                                                                </>
                                                            }
                                                        </span>
                                                    </div>}
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>State Code</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerStateCode}</span>
                                                    </div>
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>GSTIN</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerGSTIN}</span>
                                                    </div>
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>PAN</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerPAN}</span>
                                                    </div>
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>CIN</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerCIN}</span>
                                                    </div>
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>Place Of Supply</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerPlaceOfSupply}</span>
                                                    </div>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="invoice-address-right">
                                            <div >
                                                <br />
                                                <p> <b>Note No</b></p>
                                                <p> <b>Contract No   </b> </p>
                                                <p><b>Invoice No</b> </p>
                                                <p><b>State</b></p>
                                                <p><b>State Code</b> </p>
                                                <p><b>GSTIN</b></p>
                                                <p><b>PAN</b></p>
                                                <p><b>CIN</b></p>
                                                <br />
                                                <p><b>Note Date</b></p>
                                                <p><b>Due Date</b></p>

                                            </div>
                                            <div style={{ marginLeft: "20px" }}>
                                                <br />
                                                {/* <p>: {editMiscInvoiceClicked ? invoiceNo : 'Generated at creation'}</p> */}
                                                <p>: {isNote ? noteNumber : 'Generated at creation'}</p>
                                                <p>: {contractNo}</p>
                                                <p>: {invoiceNo}</p>
                                                <p>: {parnterState}</p>
                                                <p>: {partnerStateCode}</p>
                                                <p>: {companyGST}</p>
                                                <p>: {partnerPAN}</p>
                                                <p>: {companyCIN}</p>

                                                <br />
                                                <p>: {isNote ? ackDate : ''}</p>
                                                <p>: {isNote ? partnerDueDate : ''}</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="invoice-preview-card-details-bottom">
                                    <div className="invoice-preview-inner-card-2">
                                        <p><span><b>IRN :</b> </span>{isNote ? IRN : ''}<br /></p>
                                    </div>
                                </div>
                                <div className="invoice-preview-table-container">
                                    {reusableInvoiceTable()}
                                    <div className="invoice-preview-total-con">
                                        <div className="invoice-preview-total-con-left">
                                            <span>
                                                <b>Total Invoice Amount In Words ({formatCurrencyBasedOnRegion()}) : </b>
                                            </span>
                                            <p >{convertCurrencyToWords((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))} {convertCurrencyToWords(parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount).toFixed(2)) ? '' : ''}
                                            </p>
                                        </div>
                                        <div className="invoice-preview-total d-flex">
                                            <p className="invoice-preview-total-key" >Total : </p>
                                            {/* <span className="diagonal-line"></span> */}
                                            {/* <span></span> */}
                                            <p className={`invoice-preview-total-value ${paymentDetailsError && noteType === "Credit Note" ? 'error-text' : ''}`} >&nbsp;
                                                &nbsp;{formatToIndianRupee((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))} <span>{formatCurrencyBasedOnRegion()}</span></p>
                                        </div>
                                    </div>
                                    {paymentDetailsError && noteType === "Credit Note" && <p className="error-text">total amount should be less than Payment Due ({invoicePaymentDetails?.amount_due} {localStorage.getItem('currency_format')})</p>}
                                    {userNotesToggle && <div className="invoice-user-notes-div">
                                        <p className="invoice-user-notes">User Notes</p>
                                        <p>{userNotes}</p>
                                    </div>}
                                </div>

                            </div>

                        </div>
                    </div>
                    {!preview && <div className="invoice-preview-buttons">
                        <button className="secondary-button" onClick={() => { setCurrentPage(1); backFunction(); backPagination() }}> Back</button>
                        {editMiscInvoiceClicked ?
                            <button
                                style={{ opacity: paymentDetailsError && noteType === "Credit Note" ? '50%' : '100%' }}
                                disabled={paymentDetailsError && noteType === "Credit Note" ? true : false}
                                onClick={() => {
                                    if (isEditClicked) {
                                        updateCreditNote()
                                    } else {
                                        addCreditDebitNote()
                                    }
                                }}>{isEditClicked ? 'Regenerate' : 'Generate'}</button>
                            :
                            <button className="primary-button"
                                style={{ opacity: paymentDetailsError && noteType === "Credit Note" ? '50%' : '100%' }}
                                disabled={paymentDetailsError && noteType === "Credit Note" ? true : false}
                                onClick={() => {
                                    if (isEditClicked) {
                                        updateCreditNote()
                                    } else {
                                        addCreditDebitNote()
                                    }
                                }}>{isEditClicked ? 'Regenerate' : 'Generate'}</button>}
                    </div>}
                    {preview && <div className="invoice-preview-buttons">
                        <button onClick={() => setPreview(false)}> Back</button>
                    </div>}
                </div >
                }
                {isNote && !isEditClicked && <div className="invoice_preview_container">

                    <div className="invoice-preview-con d-flex justify-content-center " >
                        <div className="invoice-preview-scrollable" style={{ width: preview ? '100vw' : '' }}>
                            <div className="invoice-preview-card">
                                <div className="invoice-preview-card-details">
                                    {companyLogo ? <div className="invoice-logo-placeholder">
                                        <div>
                                            <img style={{ width: '15rem', height: '5rem' }} src={companyLogo} alt="company logo" />
                                        </div>
                                    </div> :
                                        <p style={{ marginTop: '10px' }}></p>}
                                    <div className="d-flex justify-content-between w-100">
                                        <div className="invoice-header-address text-center" style={{ marginTop: "-50px" }}>
                                            <h5>{companyName?.toUpperCase()}</h5>
                                            <p style={{ textAlign: 'center' }}><span ><b>Reg.Office:</b>
                                                {companyAddress}</span></p>
                                        </div>
                                        {
                                            QrCode?.length > 0 ?
                                                <QRCode style={{ marginTop: '-70px' }} value={QrCode} size={170} />
                                                :
                                                <div className="invoice-bar-code" style={{ marginTop: '-70px' }}>
                                                    {invoiceStatus === "rejected" ? (
                                                        <p className="rejected-text">Rejected</p>
                                                    ) : (
                                                        <p className="qr-code-text">QR Code</p>
                                                    )}
                                                </div>
                                        }

                                    </div>
                                    <h5 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>{noteType}</h5>
                                    {/* <h6 style={{ textAlign: "center", margin: '-15px', width: '100%', fontWeight: 'bold' }}>{miscInvoiceTable[0]?.service ?<> ({miscInvoiceTable[0]?.service}) </>: ''}</h6> */}

                                    <div className="invoice-preview-inner-card-div">
                                        <div className="invoice-preview-inner-card">
                                            <div style={{ width: '100%' }}>
                                                <p>
                                                    <b style={{ fontSize: "18px" }}>Buyer </b>
                                                    <br /> <b>{customerName}</b><br />
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>Billed To</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerAddress}</span>
                                                    </div>
                                                    {toggleShippingAddress && <div className="invoice-left-data">
                                                        <span className="key"><b>Shipped To</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value">
                                                            {streetAddress ?
                                                                <>
                                                                    {streetAddress}{streetAddress ? ", " : ""} {city}{city ? ", " : ""} {state}{state ? ", " : ""} {pincode}
                                                                </>
                                                                :
                                                                <>
                                                                    {shippingAddress}
                                                                </>
                                                            }
                                                        </span>
                                                    </div>}
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>State Code</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerStateCode}</span>
                                                    </div>
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>GSTIN</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerGSTIN}</span>
                                                    </div>
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>PAN</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerPAN}</span>
                                                    </div>
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>CIN</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerCIN}</span>
                                                    </div>
                                                    <div className="invoice-left-data">
                                                        <span className="key"><b>Place Of Supply</b></span>
                                                        <span style={{ marginRight: '3px' }}>:</span>
                                                        <span className="value"> {customerPlaceOfSupply}</span>
                                                    </div>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="invoice-address-right">
                                            <div >
                                                <br />
                                                <p> <b>Note No</b></p>
                                                <p> <b>Contract No   </b> </p>
                                                <p><b>Invoice No</b> </p>
                                                <p><b>State</b></p>
                                                <p><b>State Code</b> </p>
                                                <p><b>GSTIN</b></p>
                                                <p><b>PAN</b></p>
                                                <p><b>CIN</b></p>
                                                <br />
                                                <p><b>Note Date</b></p>
                                                <p><b>Due Date</b></p>

                                            </div>
                                            <div style={{ marginLeft: "20px" }}>
                                                <br />
                                                {/* <p>: {editMiscInvoiceClicked ? invoiceNo : 'Generated at creation'}</p> */}
                                                <p>: {isNote ? noteNumber : 'Generated at creation'}</p>
                                                <p>: {contractNo}</p>
                                                <p>: {invoiceNo}</p>
                                                <p>: {parnterState}</p>
                                                <p>: {partnerStateCode}</p>
                                                <p>: {companyGST}</p>
                                                <p>: {partnerPAN}</p>
                                                <p>: {companyCIN}</p>

                                                <br />
                                                <p>: {isNote ? ackDate : ''}</p>
                                                <p>: {isNote ? partnerDueDate : ''}</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="invoice-preview-card-details-bottom">
                                    <div className="invoice-preview-inner-card-2">
                                        <p><span><b>IRN :</b> </span>{isNote ? IRN : ''}<br /></p>
                                    </div>
                                </div>
                                <div className="invoice-preview-table-container">
                                    {reusableInvoiceTableView()}
                                    <div className="invoice-preview-total-con">
                                        <div className="invoice-preview-total-con-left">
                                            <span>
                                                <b>Total Invoice Amount In Words ({formatCurrencyBasedOnRegion()}) : </b>
                                            </span>
                                            <p >{convertCurrencyToWords((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))} {convertCurrencyToWords(parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount).toFixed(2)) ? '' : ''}
                                            </p>
                                        </div>
                                        <div className="invoice-preview-total d-flex">
                                            <p className="invoice-preview-total-key" >Total : </p>
                                            {/* <span className="diagonal-line"></span> */}
                                            {/* <span></span> */}
                                            <p className={`invoice-preview-total-value ${paymentDetailsError && noteType === "Credit Note" ? 'error-text' : ''}`} >&nbsp;
                                                &nbsp;{formatToIndianRupee((parseFloat(miscTotalBasicAmount) + parseFloat(miscTotalTaxAmount)).toFixed(2))} <span>{formatCurrencyBasedOnRegion()}</span></p>
                                        </div>
                                    </div>
                                    {paymentDetailsError && noteType === "Credit Note" && <p className="error-text">Payment details amount due is less than total invoice amount.</p>}

                                    <div className="signature">
                                        <p></p>
                                        <p>sign here</p>
                                    </div>

                                </div>


                            </div>
                            {(paymentToggle && pdfDataForPayments && showPaymentDetails) && <PdfViewer base64Pdf={pdfDataForPayments} />}
                            {(termsToggle && pdfDataForTerms && showTermsDetails) && <PdfViewer base64Pdf={pdfDataForTerms} />}
                        </div>
                    </div>
                    {!preview && <div className="invoice-preview-buttons">
                        {/* <button className="secondary-button" onClick={() => { setCurrentPage(1); backFunction(); backPagination() }}> Back</button> */}
                        {downloadPath && <button onClick={() => {
                            handleDownload()
                        }} disabled={downloadPath === '' || downloadPath === null} style={{ opacity: downloadPath ? '100%' : '50%' }}>Download</button>}
                        {(invoiceStatus === "approved") && <button onClick={() => {
                            submitToGSTPortal(noteNumber)
                        }} >Submit to GST</button>}
                        {(invoiceStatus === "pdfgenerated" && downloadPath) && (
                            < button
                                onClick={() => {
                                    setSendCustomerModal(true)
                                    setSendCustomerSubject(`Email of ${noteType} towards an Invoice ${invoiceNo}`)
                                    setSendCustomerMessage(`Dear User,\n\nPlease find the attached ${noteType} (${noteNumber}) against the Invoice No. ${invoiceNo} for your reference.\nKindly acknowledge the receipt of this invoice.\n\nBest Wishes,\nAvinash\nAccounts & Finance\nShristi Cargo Warehouse Pvt. Ltd.\nOffice Block, ACLC II,\nOpp. Gate No. 6 Cargo Terminal,\nIGI Airport, Delhi 110037\nMobile: +91 7561945389\nEmail: finance@scwpl.in`)
                                }}
                            >
                                Send to Customer
                            </button>
                        )}
                        {(invoiceStatus === "gstsubmitted") && <button onClick={() => {
                            handleGeneratePdf()
                        }}  >Generate PDF</button>}
                        {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "rejected") && <button onClick={() => {
                            handleEditMiscInvoice()
                            // setApprovalType('miscellaneous')
                        }}
                        // disabled
                        // style={{ opacity: '50%' }}
                        >Edit {noteTypeStatus} Note</button>}
                        <button onClick={() => { setCurrentPage(1); setPreview(false); backFunction(); backPagination() }}> Back</button>
                        {(invoiceStatus === "draft" || invoiceStatus === "onhold" || invoiceStatus === "approved") && <button onClick={() => {
                            handleReject()
                            // setApprovalType('miscellaneous')
                        }} >Reject</button>}
                        {(invoiceStatus === "draft" || invoiceStatus === "rejected" || invoiceStatus === "approved") && <button onClick={() => {
                            handleHold()
                            // setApprovalType('miscellaneous')
                        }} >Hold</button>}
                        {!(invoiceStatus !== "rejected" && invoiceStatus !== 'onhold' && invoiceStatus !== "draft") && <button
                            onClick={() => {
                                editInvoice()
                                // setApprovalType('miscellaneous')
                            }
                            }
                            style={{ opacity: checkSendForApprovalValidation() ? '100%' : '50%' }} disabled={!checkSendForApprovalValidation()}>Approve</button>}

                    </div>}


                </div >}
            </div >
            <Modal keyboard={false} backdrop="static" show={rejectModal} centered className="popper-modal">
                <Modal.Body className="text-center mt-4">
                    <>
                        <h5>Do you reject this note?</h5>
                        <p style={{ textAlign: 'start', marginBottom: '-1px' }}>Please mention reason for rejection</p>
                        <textarea
                            name=""
                            id=""
                            value={rejectReason}
                            onChange={e => {
                                const value = e.target.value.trimStart(); // Remove leading spaces
                                const regex = /^[a-zA-Z0-9 .,!?@#%^&*()_+=-]*$/; // Allow only standard keyboard characters
                                if (regex.test(value)) {
                                    if (value.length <= 250) {
                                        setRejectReason(value);
                                        setRejectReasonError("");
                                    } else {
                                        setRejectReasonError("Cannot exceed 250 characters");
                                    }
                                } else {
                                    setRejectReasonError("Invalid characters entered");
                                }
                            }}
                            style={{ width: '100%', borderRadius: '8px', borderColor: 'grey', outline: "none", padding: '10px' }}
                            rows="5"
                        ></textarea>
                    </>
                </Modal.Body>
                <Modal.Footer className="footer d-flex justify-content-center">
                    <Button style={{ width: `45%` }} variant="secondary" className="secondary" onClick={() => {
                        setRejectReason('');
                        setRejectReasonError('');
                        setRejectModal(false);
                    }}>
                        Close
                    </Button>
                    <Button style={{ width: `45%`, opacity: rejectReason.length > 0 ? '100%' : '50%' }} variant="secondary" className="secondary"
                        disabled={rejectReason.length <= 0}
                        onClick={() => {
                            const trimmedReason = rejectReason.trim(); // Trim leading and trailing spaces on submit
                            if (!trimmedReason) {
                                setRejectReasonError("Reason cannot be empty");
                            } else {
                                setRejectReasonError("");
                                setRejectModal(false);
                                rejectAnInvoice(trimmedReason); // Proceed with the valid reason
                            }
                        }}
                    >
                        Reject
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal keyboard={false} backdrop="static" show={sendCustomerModal} centered className="popper-modal-large" size="lg">
                <Modal.Body className="text-center mt-4" >
                    <>
                        <h5>Send To Customer</h5>
                        <div className='d-flex flex-column gap-2 inputsSection'>
                            <label className="text-start">To</label>
                            <div className='d-flex flex-wrap align-items-center cc-emails-container'>
                                {invoiceContactDetails.length > 0 && invoiceContactDetails.map((contact, index) => (
                                    <p key={index} className='cc-list-items'>
                                        {contact.email}
                                    </p>
                                ))}
                            </div>
                        </div>
                        <div className='d-flex flex-column gap-2 inputsSection'>
                            <label className="text-start">CC Email</label>
                            <div className={`d-flex gap-2 position-relative`} style={{ minHeight: '48px' }}>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type='email'
                                        id='cc-email-input'
                                        className='form-control responsive-add-facility-input-fields'
                                        placeholder='Enter email address'
                                        value={ccEmailInput}
                                        onChange={(e) => { handleCCEmailInput(e) }}
                                        style={{ marginBottom: 0 }}
                                    />
                                    {!isValidEmail && (
                                        <span className='text-danger' >Invalid Email Address</span>
                                    )}
                                    {isDuplicateEmail && (
                                        <span className='text-danger' >Email already exist</span>
                                    )}
                                </div>
                                <button disabled={!isValidEmail || isDuplicateEmail || ccEmailInput === ""} onClick={handleAddCCEmail} className="btn btn-secondary cc-email-button" style={{ padding: '6px 12px', fontSize: '14px', height: '36px' }} >
                                    <img src='./images/icons/AddIcon.svg' alt='add' />Add
                                </button>
                            </div>
                            <div className='d-flex flex-wrap align-items-center cc-emails-container'>
                                {[...ccEmailsData, ...newlyAddedEmails].map((email, index) => (
                                    <p key={email.email_cc_master_id ? email.email_cc_master_id : index} className='cc-list-items'>
                                        {email.cc_email} {<img onClick={() => handleConfirmRemoveCCEmail(email, index)} className='wrong-icon' src='./images/icons/WrongIcon.svg' alt='remove' />}
                                    </p>
                                ))}

                            </div>
                        </div>
                        <p style={{ textAlign: 'start', marginBottom: '-1px' }}>Subject</p>
                        <textarea
                            name=""
                            id=""
                            value={sendCustomerSubject}
                            onChange={e => {
                                const value = e.target.value.trimStart(); // Remove leading spaces
                                const regex = /^[a-zA-Z0-9 .,!?@#%^&*()_+=-]*$/; // Allow only standard keyboard characters
                                if (regex.test(value)) {
                                    setSendCustomerSubject(value);
                                    setRejectReasonError("");
                                } else {
                                    setRejectReasonError("Invalid characters entered");
                                }
                            }}
                            style={{ width: '100%', borderRadius: '8px', borderColor: 'grey', outline: "none", padding: '10px' }}
                            rows="1"
                        ></textarea>
                        <p style={{ textAlign: 'start', marginBottom: '-1px' }}>Body</p>
                        <textarea
                            name=""
                            id=""
                            value={sendCustomerMessage}
                            onChange={e => {

                                setSendCustomerMessage(e.target.value);
                                setRejectReasonError("");

                            }}
                            style={{ width: '100%', borderRadius: '8px', borderColor: 'grey', outline: "none", padding: '10px' }}
                            rows="5"
                        ></textarea>
                    </>
                </Modal.Body>
                <Modal.Footer className="footer d-flex justify-content-center">
                    <Button style={{ width: `45%` }} variant="secondary" className="secondary" onClick={() => {
                        setSendCustomerSubject('');
                        setSendCustomerMessage('');
                        setRejectReasonError('');
                        setSendCustomerModal(false);
                    }}>
                        Cancel
                    </Button>
                    <Button style={{ width: `45%`, }} variant="secondary" className="secondary"
                        // disabled={rejectReason.length <= 0}
                        disabled={sendCustomerSubject.trim() === '' || sendCustomerMessage.trim() === ''}
                        onClick={() => {
                            if (sendCustomerSubject.trim() !== '' && sendCustomerMessage.trim() !== '') {
                                sendToCustomer()
                            }
                        }}
                    >
                        Send
                    </Button>
                </Modal.Footer>
            </Modal>

            {
                (loading || isLoading) && <FormLoader />
            }
            {contractApiLoader && <FormLoader />}
            <Footer />
        </>
    );
}

export default CreditAndDebit;
